const translations = {
  en: {
    'common.add': 'Add',
    'common.addNew': 'Add new',
    'common.edit': 'Edit',
    'common.update': 'Update',
    'common.view': 'View',
    'common.delete': 'Delete',
    'common.cancel': 'Cancel',
    'common.optional': 'optional',
    'common.close': 'Close',
    'common.details': 'Details',
    'common.openDetailsPage': 'Open full page',
    'common.createdAt': 'Created at',
    'common.updatedAt': 'Updated at',
    'common.actions': 'Actions',
    'common.confirmDeleteTitle': 'Delete Item',
    'common.confirmDeleteMessage': 'Are you sure you want to delete this item?',
    'common.back': 'Back',
    'common.deleteConfirm': 'Delete',
    'common.added': 'Added',
    'common.zeroPlaceholder': '0',
    'common.notes': 'Notes',
    'common.phone': 'Phone Number',
    'common.whatsapp': 'WhatsApp Number',
    'common.address': 'Address',
    'common.email': 'Email',
    'common.subject': 'Subject',
    'common.required': 'This field is required',
    'common.confirm': 'Confirm',
    'common.clear': 'Clear',
    'common.validationError': 'Validation error',
    'api.errors.validation_error': 'Validation error',
    'api.errors.invalid_credentials': 'Invalid credentials',
    'api.errors.unauthenticated': 'Unauthenticated',
    'api.errors.permission_denied': 'You do not have permission to perform this action',
    'api.errors.invalid_current_password': 'Current password is incorrect',
    'api.errors.login_identifier_required': 'Please provide an email address or a username.',
    'api.errors.email_invalid': 'Please provide a valid email address.',
    'api.errors.email_taken': 'This email is already registered.',
    'api.errors.username_taken': 'This username is already taken.',
    'api.errors.already_taken': 'This value is already taken.',
    'api.errors.backoffice_access_denied': 'This account cannot access the backoffice portal.',
    'api.errors.vendor_portal_only': 'This account must sign in through the vendor portal.',
    'api.errors.not_found': 'Not found',
    'api.errors.request_failed': 'Something went wrong',
    'forms.whatsappSameAsPhone': 'WhatsApp same as phone',
    'forms.phone.placeholder': 'Enter phone number',
    'forms.whatsapp.placeholder': 'Enter WhatsApp number',
    'forms.copyFromVendor.label': 'Use lab contact details',
    'forms.copyFromVendor.phone': 'Lab phone',
    'forms.copyFromVendor.whatsapp': 'Lab WhatsApp',
    'forms.copyFromVendor.address': 'Lab address',
    'forms.copyFromClient.label': 'Use client contact details',
    'forms.copyFromClient.phone': 'Client phone',
    'forms.copyFromClient.whatsapp': 'Client WhatsApp',
    'forms.copyFromClient.address': 'Client address',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.general': 'General',
    'validation.name.required': 'Name is required',
    'validation.name.min': 'Name must be at least 2 characters',
    'validation.name.max': 'Name cannot exceed 255 characters',
    'validation.email.required': 'Email is required',
    'validation.email.invalid': 'Please enter a valid email address',
    'validation.email.max': 'Email cannot exceed 255 characters',
    'validation.username.required': 'Username is required',
    'validation.username.min': 'Username must be at least 3 characters',
    'validation.username.max': 'Username cannot exceed 50 characters',
    'validation.username.invalid': 'Username may only contain letters, numbers, dots, underscores, and hyphens',
    'validation.login.identifierRequired': 'Enter an email or a username',
    'validation.phone.required': 'Phone is required',
    'validation.phone.invalid': 'Please enter a valid phone number',
    'validation.phone.max': 'Phone cannot exceed 50 characters',
    'validation.whatsapp.required': 'WhatsApp is required',
    'validation.whatsapp.invalid': 'Please enter a valid WhatsApp number',
    'validation.whatsapp.max': 'WhatsApp cannot exceed 50 characters',
    'common.loading': 'Loading...',
    'common.saved': 'Saved successfully',
    'common.active': 'Active',
    'common.status': 'Status',
    'common.inactive': 'Inactive',

    // Sidebar
    'sidebar.dashboard': 'Dashboard',
    'sidebar.reports': 'Reports',
    'sidebar.settings': 'Settings',
    'sidebar.setting': 'Setting',
    'sidebar.orders': 'Orders',
    'sidebar.orders_calendar': 'Calendar',
    'sidebar.invoices': 'Invoices',

    // Invoices
    'invoices.header.title': 'Invoices',
    'invoices.header.subtitle': 'Manage laboratory invoices, payment collection statuses and financial records',
    'invoices.stats.total': 'Total Invoices',
    'invoices.stats.totalSubtitle': '{paid} paid · {partial} partial · {unpaid} unpaid',
    'invoices.stats.amount': 'Invoiced Amount',
    'invoices.stats.collected': 'Collected',
    'invoices.stats.collectedSubtitle': '{percent}% of invoiced amount',
    'invoices.stats.outstanding': 'Outstanding',
    'invoices.stats.outstandingSubtitle': '{count} invoices awaiting payment',
    'invoices.stats.overdue': 'Overdue',
    'invoices.stats.overdueSubtitle': '{count} invoices past due date',
    'invoices.filter.title': 'Filter Invoices',
    'invoices.filter.active': 'Active',
    'invoices.filter.clear': 'Reset Filters',
    'invoices.table.refresh': 'Refresh',
    'invoices.table.ordersCount': 'Orders',
    'invoices.table.number': 'Invoice ID',
    'invoice.table.orderRef': 'Order Ref',
    'invoice.table.invoiceRef': 'Invoice Ref',
    'invoice.field.shipmentDate': 'Shipment Date',
    'invoice.field.vat': 'VAT',
    'invoice.field.deliveryCost': 'Delivery Cost',
    'invoice.field.orderId': 'Order Id',
    'invoice.field.amount': 'Amount',
    'invoices.table.status': 'Status',
    'invoices.table.issueDate': 'Issue Date',
    'invoices.table.client': 'Client',
    'invoices.table.dentist': 'Dentist',
    'invoices.table.dueDate': 'Due Date',
    'invoices.table.total': 'Total',
    'invoices.table.actions': 'Actions',
    'invoices.table.draft': 'Archived',
    'invoices.table.draftLabel': 'Archived',
    'invoices.confirm.delete': 'Are you sure you want to delete this invoice?',
    'invoices.alert.noAccess': 'You do not have access to view invoices.',
    'invoices.button.showDrafts': 'Show Archived',
    'invoices.button.hideDrafts': 'Hide Archived',
    'invoices.filter.all': 'Show All',
    'invoices.filter.drafts': 'Show Archived',
    'invoices.filter.nonDrafts': 'Hide Archived',
    'invoices.search.placeholder': 'Search invoice #, ref, client, dentist or notes',

  
    'sidebar.formula_types': 'Formula Types',
    'sidebar.colors': 'Colors',
    'sidebar.assets': 'Assets',
    'sidebar.branchs': 'Branches',
    'sidebar.delivery_centers': 'Delivery Centers',
    'sidebar.expenses': 'Expenses',
    'sidebar.expense_types': 'Expense Types',
    'sidebar.dentists': 'Dentists',
    'sidebar.users': 'Users',
    'sidebar.roles': 'Roles & Permissions',
    'sidebar.transactions': 'Transactions',
    'sidebar.activities': 'Activities',
    'sidebar.units': 'Units',
    'sidebar.unit_types': 'Unit Types',

    // Activities
    'activities.subtitle': 'Audit trail of user operations across the platform',
    'activities.table.vendor': 'Vendor',
    'activities.table.entity_affected': 'Entity affected',
    'activities.table.user': 'User name',
    'activities.table.operation': 'Operation',
    'activities.table.ip': 'Device IP',
    'activities.table.date': 'Date',
    'activities.table.properties': 'Properties',
    'activities.filters.vendor': 'Vendor',
    'activities.filters.name': 'Name, username or email',
    'activities.filters.entity': 'Entity',
    'activities.filters.operation': 'Operation',
    'activities.operations.create': 'CREATE',
    'activities.operations.created': 'CREATE',
    'activities.operations.update': 'UPDATE',
    'activities.operations.updated': 'UPDATE',
    'activities.operations.delete': 'DELETE',
    'activities.operations.deleted': 'DELETE',
    'activities.operations.login': 'LOGIN',
    'activities.operations.logout': 'LOGOUT',
    'activities.operations.impersonate': 'IMPERSONATE',
    'activities.operations.force_logout': 'FORCE_LOGOUT',
    'activities.operations.paid_invoice': 'PAID_INVOICE',
    'activities.operations.undo_mark_paid': 'UNDO_MARK_PAID',
    'activities.operations.refund_invoice': 'REFUND_INVOICE',
    'activities.operations.partial_payment': 'PARTIAL_PAYMENT',
    'activities.operations.mark_order_paid': 'MARK_ORDER_PAID',
    'activities.operations.mark_order_unpaid': 'MARK_ORDER_UNPAID',
    'activities.operations.mark_order_partially_paid': 'MARK_ORDER_PARTIALLY_PAID',
    'activities.operations.cancel': 'CANCEL',
    'activities.operations.send_email': 'SEND_EMAIL',
    'activities.operations.send_whatsapp': 'SEND_WHATSAPP',
    'activities.operations.download_invoice_pdf': 'DOWNLOAD_INVOICE_PDF',
    'activities.operations.download_summary_invoice_pdf': 'DOWNLOAD_SUMMARY_INVOICE_PDF',
    'activities.operations.download_period_summary_invoice_pdf': 'DOWNLOAD_PERIOD_SUMMARY_INVOICE_PDF',
    'activities.operations.download_pdf': 'DOWNLOAD_INVOICE_PDF',
    'activities.operations.download_summary_pdf': 'DOWNLOAD_SUMMARY_INVOICE_PDF',
    'activities.operations.download_period_summary_pdf': 'DOWNLOAD_PERIOD_SUMMARY_INVOICE_PDF',
    'activities.operations.download_invoice_spreadsheet': 'DOWNLOAD_INVOICE_SPREADSHEET',
    'activities.operations.upload_attachment': 'UPLOAD_ATTACHMENT',
    'activities.operations.delete_attachment': 'DELETE_ATTACHMENT',
    'activities.operations.export_account_statement': 'EXPORT_ACCOUNT_STATEMENT',
    'activities.operations.password_reset': 'PASSWORD RESET',
    'activities.operations.password_reset_request': 'PASSWORD RESET REQUEST',
    'activities.operations.wallet_recharge': 'WALLET_RECHARGE',
    'activities.operations.update_wallet_log_date': 'UPDATE_WALLET_LOG_DATE',
    'activities.operations.wallet_recharge_revert': 'WALLET_RECHARGE_REVERT',
    'activities.filters.module': 'Module',
    'activities.filters.ip': 'Device IP',
    'activities.filters.user_type': 'User type',
    'activities.filters.entity_id': 'Entity ID',
    'activities.table.module': 'Module',
    'activities.modules.assets': 'Assets',
    'activities.modules.auth': 'Authentication',
    'activities.modules.backoffice_auth': 'Back office authentication',
    'activities.modules.client_formula_type_prices': 'Client prices',
    'activities.modules.clients': 'Clients',
    'activities.modules.colors': 'Colors',
    'activities.modules.delivery_centers': 'Delivery centers',
    'activities.modules.expenses': 'Expenses',
    'activities.modules.formula_types': 'Formula types',
    'activities.modules.invoices': 'Invoices',
    'activities.modules.money_transfer_channels': 'Money transfer channels',
    'activities.modules.orders': 'Orders',
    'activities.modules.settings': 'Settings',
    'activities.modules.users': 'Users',
    'activities.modules.wallets': 'Wallets',
    'activities.properties.field': 'Field',
    'activities.properties.old': 'Old',
    'activities.properties.new': 'New',
    'activities.properties.no_changes': 'No old/new comparison data for this activity.',
    'activities.modal.properties_title': 'Changed properties',
    'activities.fields.id': 'ID',
    'activities.fields.name': 'Name',
    'activities.fields.email': 'Email',
    'activities.fields.phone': 'Phone',
    'activities.fields.notes': 'Notes',
    'activities.fields.address': 'Address',
    'activities.fields.whatsapp': 'WhatsApp',
    'activities.fields.client': 'Client',
    'activities.fields.client_id': 'Client',
    'activities.fields.client_name': 'Client',
    'activities.fields.client_address': 'Client Address',
    'activities.fields.dentist': 'Dentist',
    'activities.fields.dentist_id': 'Dentist',
    'activities.fields.dentist_name': 'Dentist',
    'activities.fields.dentist_email': 'Dentist Email',
    'activities.fields.dentist_phone': 'Dentist Phone',
    'activities.fields.technician': 'Technician',
    'activities.fields.technician_id': 'Technician',
    'activities.fields.technician_name': 'Technician Name',
    'activities.fields.technician_email': 'Technician Email',
    'activities.fields.courier': 'Courier',
    'activities.fields.courier_id': 'Courier',
    'activities.fields.orders': 'Orders',
    'activities.fields.units': 'Units',
    'activities.fields.units_count': 'Units Count',
    'activities.fields.attachments': 'Attachments',
    'activities.fields.requested_at': 'Requested At',
    'activities.fields.delivered_at': 'Delivered At',
    'activities.fields.code': 'Code',
    'activities.fields.color': 'Color',
   
    'activities.fields.delivery_type': 'Delivery Type',
    'activities.fields.delivery_type_name': 'Delivery Type',
    'activities.fields.user_type': 'User Type',
    'activities.fields.payment_method': 'Payment Method',
    'activities.fields.payment_method_id': 'Payment Method',
    'activities.fields.payment_status': 'Payment Status',
    'activities.fields.payment_status_id': 'Payment Status',
    'activities.fields.order_status': 'Order Status',
    'activities.fields.delivery_center': 'Delivery Center',
    'activities.fields.delivery_center_id': 'Delivery Center',
    'activities.fields.delivery_center_name': 'Delivery Center Name',
    'activities.fields.delivery_center_address': 'Delivery Center Address',
    'activities.fields.delivery_center_created_at': 'Delivery Center Created At',
    'activities.fields.delivery_center_updated_at': 'Delivery Center Updated At',
    'activities.fields.delivery_cost': 'Delivery Cost',
    'activities.fields.discount_amount': 'Discount Amount',
    'activities.fields.vat_percentage': 'VAT Percentage',
    'activities.fields.unit_price_override': 'Unit Price Override',
    'activities.fields.unit_price_source': 'Unit Price Source',
    'activities.fields.reference': 'Reference',
    'activities.fields.is_draft': 'Draft',
    'activities.fields.due_date': 'Due Date',
    'activities.fields.issue_date': 'Issue Date',
    'activities.fields.paid_at': 'Paid At',
    'activities.fields.paid_amount': 'Paid Amount',
    'activities.fields.total_amount': 'Total Amount',
    'activities.fields.subtotal_amount': 'Subtotal Amount',
    'activities.fields.remaining_amount': 'Remaining Amount',
    'activities.fields.created_at': 'Created At',
    'activities.fields.updated_at': 'Updated At',

    // Auth
    'auth.login.title': 'Login',
    'auth.login.backofficeTitle': 'Backoffice Portal',
    'auth.login.backofficeSubtitle': 'Sign in with your operator account',
    'auth.login.backofficeNotice': 'Internal use only. Vendor accounts cannot sign in here.',
    'auth.login.email.label': 'Email',
    'auth.login.email.required': 'Please enter the email address',
    'auth.login.email.invalid': 'Please enter a valid email address',
    'auth.login.email.placeholder': 'Enter the email address',
    'auth.login.password.label': 'Password',
    'auth.login.password.required': 'Please enter the password',
    'auth.login.password.placeholder': 'Enter the password',
    'auth.login.submit': 'Submit',
    'auth.login.backofficeOnly': 'This account cannot access the backoffice portal. Use a backoffice operator account.',

    // Assets
    'assets.table.name': 'Name',
    'assets.table.cost': 'Cost',
    'assets.table.notes': 'Notes',
    'assets.table.actions': 'Actions',
    'assets.button.add': 'Add Asset',
    'assets.modal.title': 'Assets',
    'assets.confirm.deleteTitle': 'Delete Asset',
    'assets.confirm.deleteMessage': 'Are you sure you want to delete this asset?',
    'assets.form.name.label': 'Asset Name',
    'assets.form.name.placeholder': 'Asset name',
    'assets.form.name.required': 'Please enter the asset name',
    'assets.form.cost.label': 'Cost',
    'assets.form.cost.placeholder': 'Enter cost',
    'assets.form.cost.required': 'Please enter the cost',
    'assets.form.cost.min': 'Cost must be at least 1',
    'assets.form.notes.label': 'Notes',
    'assets.form.notes.placeholder': 'Notes',
    'assets.search.namePlaceholder': 'Search by name',
    'assets.search.notesPlaceholder': 'Search by notes',
    'assets.alert.noAccess': 'You do not have access to view assets.',
    'assets.header.title': 'Assets',
    'assets.header.subtitle': 'Track laboratory equipment, fixed assets and their value',
    'assets.stats.total': 'Total Assets',
    'assets.stats.addedThisMonth': '{count} added this month',
    'assets.stats.totalValue': 'Total Value',
    'assets.stats.averageValue': 'Average Value',
    'assets.stats.mostValuable': 'Most Valuable',
    'assets.stats.latest': 'Latest Added',

    // Branchs
    'branchs.table.name': 'Branch Name',
    'branchs.table.address': 'Address',
    'branchs.table.phone': 'Phone Number',
    'branchs.table.whatsapp': 'WhatsApp Number',
    'branchs.table.email': 'Email',
    'branchs.table.notes': 'Notes',
    'branchs.table.actions': 'Actions',
    'branchs.button.add': 'Add Branch',
    'branchs.modal.title': 'Branches',
    'branchs.confirm.deleteTitle': 'Delete Branch',
    'branchs.confirm.deleteMessage': 'Are you sure you want to delete this branch?',
    'branchs.form.name.label': 'Branch Name',
    'branchs.form.name.placeholder': 'Enter branch name',
    'branchs.form.name.required': 'Please enter the branch name',
    'branchs.form.address.label': 'Address',
    'branchs.form.address.placeholder': 'Enter address',
    'branchs.form.address.max': 'Address must be at most 500 characters',
    'branchs.form.phone.label': 'Phone Number',
    'branchs.form.phone.placeholder': 'Enter phone number',
    'branchs.form.phone.max': 'Phone number must be at most 50 characters',
    'branchs.form.whatsapp.label': 'WhatsApp Number',
    'branchs.form.whatsapp.placeholder': 'Enter WhatsApp number',
    'branchs.form.whatsapp.max': 'WhatsApp number must be at most 50 characters',
    'branchs.form.email.label': 'Email',
    'branchs.form.email.placeholder': 'Enter email',
    'branchs.form.email.invalid': 'Please enter a valid email address',
    'branchs.form.notes.label': 'Notes',
    'branchs.form.notes.placeholder': 'Enter notes',
    'branchs.form.notes.max': 'Notes must be at most 1000 characters',
    'branchs.alert.noAccess': 'You do not have access to view branches.',

    // Delivery Centers
    'deliveryCenters.table.name': 'Center Name',
    'deliveryCenters.table.address': 'Address',
    'deliveryCenters.table.phone': 'Phone Number',
    'deliveryCenters.table.whatsapp': 'WhatsApp Number',
    'deliveryCenters.table.email': 'Email',
    'deliveryCenters.table.client': 'Assigned Client',
    'deliveryCenters.table.noClient': 'No client assigned',
    'deliveryCenters.table.actions': 'Actions',
    'deliveryCenters.button.add': 'Add Delivery Center',
    'deliveryCenters.modal.title': 'Delivery Centers',
    'deliveryCenters.confirm.deleteTitle': 'Delete Delivery Center',
    'deliveryCenters.confirm.deleteMessage': 'Are you sure you want to delete this delivery center?',
    'deliveryCenters.form.address.max': 'Address must be at most 500 characters',
    'deliveryCenters.form.phone.max': 'Phone number must be at most 50 characters',
    'deliveryCenters.form.whatsapp.max': 'WhatsApp number must be at most 50 characters',
    'deliveryCenters.form.notes.max': 'Notes must be at most 1000 characters',
    'deliveryCenters.form.client.label': 'Client',
    'deliveryCenters.form.client.placeholder': 'Select a client',
    'deliveryCenters.form.client.required': 'Please select a client',
    'deliveryCenters.alert.noAccess': 'You do not have access to view delivery centers.',
    'responses.delivery_center.updated': 'Delivery center updated successfully',

    // Clients
    'clients.alert.noAccess': 'You do not have access to view clients.',
    'clients.table.name': 'Client Name',
    'clients.table.type': 'Client Type',
    'clients.table.phone': 'Phone Number',
    'clients.table.whatsapp': 'WhatsApp Number',
    'clients.table.email': 'Email',
    'clients.table.dentists': 'Assigned Dentists',
    'clients.table.noDentists': 'No dentists assigned',
    'clients.table.noLabContacts': 'No lab contacts assigned',
    'clients.table.deliveryCenters': 'Delivery Centers',
    'clients.table.noDeliveryCenters': 'No delivery centers assigned',
    'clients.table.actions': 'Actions',
    'clients.formulaTypePrices.button': 'Formula type prices',
    'clients.formulaTypePrices.title': 'Formula type prices for',
    'clients.formulaTypePrices.help': 'Set a custom unit price per formula type for this client. Leave empty to use the default selling price.',
    'clients.formulaTypePrices.formulaType': 'Formula type',
    'clients.formulaTypePrices.defaultPrice': 'Default price',
    'clients.formulaTypePrices.customPrice': 'Custom unit price',
    'clients.formulaTypePrices.noChanges': 'No changes to save',
    'clients.tabs.dentists': 'Dentists',
    'clients.tabs.labContacts': 'Lab contacts',
    'clients.tabs.customPrices': 'Custom prices',
    'clients.accountStatement.positions': 'Positions',
    'clients.button.add': 'Add Client',
    'clients.modal.title': 'Clients',
    'clients.confirm.deleteTitle': 'Delete Client',
    'clients.confirm.deleteMessage': 'Are you sure you want to delete this client?',
    'clients.form.name.label': 'Client Name',
    'clients.form.name.placeholder': 'Enter client name',
    'clients.form.name.required': 'Please enter the client name',
    'clients.form.name.max': 'Name must be at most 255 characters',
    'clients.form.type.label': 'Client Type',
    'clients.form.type.placeholder': 'Select a client type',
    'clients.filter.type.placeholder': 'Client type',
    'clients.form.type.required': 'Please select a client type',
    'clients.form.type.options.clinic': 'Clinic',
    'clients.form.type.options.hospital': 'Hospital',
    'clients.form.type.options.lab': 'Lab',
    'clients.form.search.placeholder': 'Search by name, email, or phone',
    'clients.form.phone.label': 'Phone Number',
    'clients.form.phone.placeholder': 'Enter phone number',
    'clients.form.phone.max': 'Phone number must be at most 50 characters',
    'clients.form.whatsapp.label': 'WhatsApp Number',
    'clients.form.whatsapp.placeholder': 'Enter WhatsApp number',
    'clients.form.whatsapp.max': 'WhatsApp number must be at most 50 characters',
    'clients.form.email.label': 'Email',
    'clients.form.email.placeholder': 'Enter email',
    'clients.form.email.invalid': 'Please enter a valid email address',
    'clients.form.dentists.label': 'Dentists',
    'clients.form.dentists.placeholder': 'Select dentists',
    'clients.form.dentists.empty': 'No available dentists',
    'clients.form.dentists.labelLab': 'Lab contacts',
    'clients.form.dentists.placeholderLab': 'Select lab contacts',
    'clients.form.dentists.emptyLab': 'No available lab contacts',
    'clients.form.deliveryCenters.label': 'Delivery Centers',
    'clients.form.deliveryCenters.placeholder': 'Select or add delivery centers',
    'clients.form.deliveryCenters.empty': 'No available delivery centers',
    'clients.form.submit.createThenContacts': 'Create client & add contacts',
    'clients.form.submit.createWithContacts': 'Create client with contacts',
    'clients.form.contactMode.label': 'Contacts for this client',
    'clients.form.contactMode.required': 'Please choose how to add contacts',
    'clients.form.contactMode.mirror': 'Create a dentist with the same details',
    'clients.form.contactMode.mirrorLab': 'Create a lab contact with the same details',
    'clients.form.contactMode.mirrorHelp': 'Best when the clinic/hospital has one doctor — name, phone, WhatsApp, and email are copied from the client.',
    'clients.form.contactMode.mirrorHelpLab': 'Best when the lab has one contact — name, phone, WhatsApp, and email are copied from the client.',
    'clients.form.contactMode.list': 'Add multiple dentists',
    'clients.form.contactMode.listLab': 'Add multiple lab contacts',
    'clients.form.contactMode.listHelp': 'Expand this form to add one or more dentists now, then create everything together.',
    'clients.form.contactMode.listHelpLab': 'Expand this form to add one or more lab contacts now, then create everything together.',
    'clients.form.contactMode.dentistTypeMissing': 'Dentist user type is not available. Refresh and try again.',
    'clients.form.mirror.sectionTitle': 'Dentist login',
    'clients.form.mirror.sectionTitleLab': 'Lab contact login',
    'clients.form.mirror.hint': 'Name, phone, WhatsApp, and email are taken from the client. Email and username are optional.',
    'clients.form.mirror.createFailed': 'Client was created, but the dentist could not be created. Add them from the client page.',
    'clients.form.mirror.createFailedLab': 'Client was created, but the lab contact could not be created. Add them from the client page.',
    'clients.form.list.sectionTitle': 'Dentists',
    'clients.form.list.sectionTitleLab': 'Lab contacts',
    'clients.form.list.clientCreated': 'Client "{{name}}" was created',
    'clients.form.list.stepTitle': 'Add dentists — {{name}}',
    'clients.form.list.stepTitleLab': 'Add lab contacts — {{name}}',
    'clients.form.list.stepHelp': 'Add one or more dentists for this client. You can skip and add them later.',
    'clients.form.list.stepHelpLab': 'Add one or more lab contacts for this client. You can skip and add them later.',
    'clients.form.list.addAnother': 'Add another dentist',
    'clients.form.list.addAnotherLab': 'Add another lab contact',
    'clients.form.list.saveContacts': 'Save dentists',
    'clients.form.list.saveContactsLab': 'Save lab contacts',
    'clients.form.list.createFailed': 'Client was created, but some dentists could not be created. Add them from the client page.',
    'clients.form.list.createFailedLab': 'Client was created, but some lab contacts could not be created. Add them from the client page.',
    'clients.form.list.done': 'Done',
    'clients.type.clinic': 'Clinic',
    'clients.type.hospital': 'Hospital',
    'clients.type.lab': 'Lab',
    'clients.totalOrdersAmount': 'Total Orders Amount',
    'clients.totalOrdersPaidAmount': 'Total Orders Paid Amount',
    'clients.totalDueOrdersAmount': 'Total Due Orders Amount',
    'clients.wallet.title': 'Client Wallet',
    'clients.wallet.balance': 'Balance',
    'clients.wallet.recharge': 'Recharge',
    'clients.wallet.amount': 'Amount',
    'clients.wallet.amountPlaceholder': 'Enter amount',
    'clients.wallet.notes': 'Notes',
    'clients.wallet.notesPlaceholder': 'Optional notes for this recharge',
    'clients.wallet.rechargeSuccess': 'Wallet recharged successfully',
    'clients.wallet.rechargeError': 'Failed to recharge wallet',
    'clients.wallet.amountRequired': 'Amount is required',
    'clients.wallet.amountMin': 'Amount must be at least 0.01',
    'clients.wallet.paymentMethod': 'Payment Method',
    'clients.wallet.paymentMethodPlaceholder': 'Select payment method',
    'clients.wallet.attachments': 'Attachments',
    'clients.wallet.uploadImage': 'Upload image',
    'clients.wallet.history': 'Wallet History',
    'clients.wallet.historyDate': 'Date',
    'clients.wallet.transactionType': 'Type',
    'sidebar.clients': 'Clients',
    'sidebar.wallets': 'Wallets',
    'wallets.title': 'Wallets',
    'wallets.column.walletId': 'Wallet ID',
    'wallets.column.clientName': 'Client name',
    'wallets.column.balance': 'Balance',
    'wallets.viewTitle': 'Wallet #{{id}}',
    'wallets.backToList': 'Back to wallets',
    'wallets.openClient': 'Client profile',
    'wallets.walletIdLabel': 'Wallet ID',
    'wallets.alert.noAccess': 'You do not have access to wallets.',

    // Colors
    'colors.table.name': 'Color',
    'colors.table.actions': 'Actions',
    'colors.button.add': 'Add Color',
    'colors.modal.title': 'Colors',
    'colors.confirm.deleteTitle': 'Delete Color',
    'colors.confirm.deleteMessage': 'Are you sure you want to delete this color?',
    'colors.form.code.placeholder': 'Enter code',
    'colors.form.preview.label': 'Tooth Color Preview',
    'colors.alert.noAccess': 'You do not have access to view colors.',

    // Dentists
    'dentists.label.singular': 'Dentist',
    'dentists.label.singular.lab': 'Lab contact',
    'dentists.label.plural': 'Dentists',
    'dentists.label.plural.lab': 'Lab contacts',
    'dentists.table.name': 'Dentist Name',
    'dentists.table.username': 'Username',
    'dentists.table.email': 'Email',
    'dentists.table.address': 'Address',
    'dentists.table.phone': 'Phone Number',
    'dentists.table.whatsapp': 'WhatsApp Number',
    'dentists.table.client': 'Client',
    'dentists.table.noClient': 'No client',
    'dentists.table.actions': 'Actions',
    'dentists.button.add': 'Add Dentist',
    'dentists.button.addLabContact': 'Add Lab Contact',
    'dentists.modal.title': 'Dentists',
    'dentists.modal.titleLabContact': 'Lab Contacts',
    'dentists.confirm.deleteTitle': 'Delete Dentist',
    'dentists.confirm.deleteMessage': 'Are you sure you want to delete this dentist?',
    'dentists.confirm.removeTitle': 'Remove Dentist',
    'dentists.confirm.removeMessage': 'This dentist will be detached from this client and deactivated.',
    'dentists.confirm.deleteTitleLabContact': 'Delete Lab Contact',
    'dentists.confirm.deleteMessageLabContact': 'Are you sure you want to delete this lab contact?',
    'dentists.confirm.removeTitleLabContact': 'Remove Lab Contact',
    'dentists.confirm.removeMessageLabContact': 'This lab contact will be detached from this client and deactivated.',
    'dentists.form.client.label': 'Client',
    'dentists.form.client.placeholder': 'Select or add a client',
    'dentists.alert.noAccess': 'You do not have access to view dentists.',
    'dentists.alert.noDentistType': 'Dentist user type is missing. Please configure user types first.',
    'dentists.changeHistory': 'Change history',
    'dentists.versions.title': 'Dentist change history',
    'dentists.versions.empty': 'No change history yet',
    'dentists.versions.timelineTitle': 'Timeline',
    'dentists.versions.by': 'Updated by',
    'dentists.versions.fieldsChanged': 'Fields changed',
    'dentists.versions.compareTitle': 'Compare with current',
    'dentists.versions.selectVersion': 'Select a version',
    'dentists.versions.noFields': 'No changed fields captured',
    'dentists.versions.before': 'Before',
    'dentists.versions.after': 'After (Current)',

    // Expenses
    'expenses.table.expenseType': 'Expense Item',
    'expenses.table.cost': 'Cost',
    'expenses.table.date': 'Date',
    'expenses.table.notes': 'Notes',
    'expenses.table.assignedUser': 'Assigned to',
    'expenses.table.actions': 'Actions',
    'expenses.button.add': 'Add Expense',
    'expenses.modal.title': 'Expense Record',
    'expenses.confirm.deleteTitle': 'Delete Expense',
    'expenses.confirm.deleteMessage': 'Are you sure you want to delete this expense?',
    'expenses.form.type.label': 'Expense Item',
    'expenses.form.expense_type_id': 'Expense Type',
    'expenses.form.type.placeholder': 'Select expense item',
    'expenses.form.type.required': 'Please select an expense item',
    'expenses.form.cost.label': 'Cost',
    'expenses.form.cost.placeholder': '0',
    'expenses.form.cost.required': 'Please enter the cost',
    'expenses.form.notes.label': 'Notes',
    'expenses.form.notes.placeholder': 'Enter notes',
    'expenses.form.assignedUser.label': 'Assigned user',
    'expenses.form.assignedUser.placeholder': 'Select courier, technician, or admin',
    'expenses.form.assignedUser.unassigned': 'Unassigned',
    'expenses.filter.assignedUser.placeholder': 'Filter by assigned user',
    'expenses.search.notesPlaceholder': 'Search notes',
    'expenses.alert.noAccess': 'You do not have access to view expenses.',
    'expenses.header.title': 'Expenses',
    'expenses.header.subtitle': 'Record laboratory spending, payouts and operating costs',
    'expenses.stats.total': 'Total Expenses',
    'expenses.stats.average': 'Average {amount}',
    'expenses.stats.totalAmount': 'Total Spent',
    'expenses.stats.thisMonth': 'This Month',
    'expenses.stats.topType': 'Top Expense Item',
    'expenses.stats.paidToUsers': 'Paid to Staff',

    // Expense Types
    'expenseTypes.table.name': 'Item Name',
    'expenseTypes.table.description': 'Description',
    'expenseTypes.table.actions': 'Actions',
    'expenseTypes.button.add': 'Add Expense Item',
    'expenseTypes.modal.title': 'Expense Items',
    'expenseTypes.confirm.deleteTitle': 'Delete Expense Item',
    'expenseTypes.confirm.deleteMessage': 'Are you sure you want to delete this expense item?',
    'expenseTypes.form.name.label': 'Item Name',
    'expenseTypes.form.name.placeholder': 'Enter item name',
    'expenseTypes.form.name.required': 'Please enter the item name',
    'expenseTypes.form.description.label': 'Item Description',
    'expenseTypes.form.description.placeholder': 'Enter item description',
    'expenseTypes.search.namePlaceholder': 'Search by name',
    'expenseTypes.search.descriptionPlaceholder': 'Search by description',
    'expenseTypes.alert.noAccess': 'You do not have access to view expense types.',

    // Orders
    'orders.header.title': 'Orders',
    'orders.header.subtitle': 'Track laboratory orders, production workflow and delivery schedules',
    'orders.stats.total': 'Total Orders',
    'orders.stats.totalSubtitle': '{completed} completed · {cancelled} cancelled',
    'orders.stats.amount': 'Total Orders Amount',
    'orders.stats.amountSubtitle': 'Excluding cancelled orders',
    'orders.stats.paid': 'Paid Orders',
    'orders.stats.paidSubtitle': '{count} paid orders',
    'orders.stats.unpaid': 'Unpaid Orders',
    'orders.stats.unpaidSubtitle': '{count} unpaid orders',
    'orders.stats.active': 'In Progress',
    'orders.stats.activeSubtitle': '{count} due today',
    'orders.stats.overdue': 'Overdue',
    'orders.stats.overdueSubtitle': 'Past delivery date',
    'orders.stats.uninvoiced': 'Not Invoiced',
    'orders.stats.uninvoicedSubtitle': 'Awaiting an invoice',
    'orders.search.placeholder': 'Search patient, order # or reference',
    'orders.filter.title': 'Filter Orders',
    'orders.filter.clear': 'Reset Filters',
    'orders.filter.active': 'Active',
    'orders.filter.client': 'Client',
    'orders.filter.dentist': 'Dentist',
    'orders.filter.technicians': 'Technicians',
    'orders.filter.courier': 'Courier',
    'orders.filter.formulaType': 'Formula type',
    'orders.table.refresh': 'Refresh',
    'orders.table.notInvoiced': 'Not Invoiced',
    'orders.table.patientName': 'Patient Name',
    'orders.table.dentistName': 'Dentist',
    'orders.table.color': 'Color',
    'orders.table.formulaType': 'Formula Type',
    'orders.table.client': 'Client',
    'orders.table.invoice': 'Invoice',
    'orders.table.total': 'Total Amount',
    'orders.table.id': 'Order ID',
    'orders.table.paid': 'Paid Amount',
    'orders.table.remaining': 'Remaining Amount',
    'orders.table.paymentStatus': 'Payment Status',
    'orders.table.status': 'Order Status',
    'orders.summary.title': 'Order Summary',
    'orders.summary.itemsLabel': 'Items',
    'orders.summary.deliveryCenter': 'Delivery Center',
    'orders.summary.noDeliveryCenter': 'No delivery center',
    'orders.summary.color': 'Color',
    'orders.summary.noColor': '—',
    'orders.summary.subtotal': 'Subtotal',
    'orders.summary.discount': 'Discount',
   
    'orders.summary.discountClientFormulaType': 'Client formula type discount',
    'orders.summary.discountUnitOverride': 'Per-unit override discount',
    'orders.summary.discountOrderAmount': 'Order discount',
    'orders.summary.totalDiscount': 'Total discount',
    'orders.actions.workCard': ' Work Card',
    'orders.actions.workCardCreated': 'Work card created',
    'orders.actions.createWorkCard': 'Work Card',
    'orders.actions.downloadWorkCard': 'Download Work Card',
    'orders.calendar.title': 'Calendar',
    'orders.calendar.viewList': 'View Orders List',
    'orders.calendar.more': 'more',
    'orders.calendar.week': 'Week',
    'orders.calendar.month': 'Month',
    'orders.calendar.year': 'Year',
    'orders.calendar.ordersCount': 'orders',
    'orders.calendar.itemsCount': 'items',
    'orders.calendar.today': 'Today',
    'orders.calendar.noOrders': 'No orders',
    'orders.calendar.noItems': 'No items',
    'orders.calendar.patient': 'Patient',
    'orders.calendar.client': 'Client',
    'orders.calendar.ref': 'Serial',
    'orders.calendar.entity.order': 'Order',
    'orders.calendar.entity.invoice': 'Invoice',
    'orders.calendar.filter.title': 'Show on calendar',
    'orders.calendar.filter.orders': 'Orders',
    'orders.calendar.filter.invoices': 'Invoices',
    'orders.calendar.filter.orderDeliveryDate': 'Delivery date',
    'orders.calendar.filter.orderRequestedAt': 'Requested at',
    'orders.calendar.filter.invoiceIssueDate': 'Issue date',
    'orders.calendar.filter.invoiceDueDate': 'Due date',

    // UI labels for work card modal
    'ui.order.work_card': 'Work Card',
    'ui.order.order_id': 'Order ID',
    'ui.order.client': 'Client',
    'ui.order.dentist': 'Dentist',
    'ui.order.patient': 'Patient',
   
    'ui.order.formulaType': 'Formula type',
    'ui.order.color': 'Color',
    'ui.order.units': 'Units',
    'ui.order.units_positions': 'Units (positions)',
    'ui.order.units_count': 'Units count',
    'ui.order.items': 'Items',
    'ui.order.unit': 'Unit',
    'ui.order.no_qr_available': 'No QR available',
    'ui.order.order_barcode': 'Order Barcode',
    'ui.order.view_public_note': 'This is a public view of the order. No authentication required.',
    'ui.order.unit_types': 'Chosen Units (by position)',
    'ui.order.unit_positions': 'Unit positions',
    'ui.order.color_hex': 'Hex',
    // Arabic translation
    'ui.order.unit_positions_ar': 'مواضع الوحدات',
    'ui.order.unit_level': 'Level',
    'ui.order.unit_direction': 'Direction',
    'ui.order.unit_order': 'Order',
    'ui.order.unit_name': 'Type',
    'ui.order.tooth_picker': 'Tooth Picker',
    'ui.order.tooth_previewer': 'Tooth Previewer',
    'ui.order.tooth_picker_hint': 'Selected units are highlighted below',
    'ui.order.note': 'Note',
    'ui.order.view_title': 'Order View',
    'ui.order.switch_to_en': 'Switch to English',
    'ui.order.switch_to_ar': 'Switch to Arabic',
    'ui.order.lang_en_short': 'EN',
    'ui.order.lang_ar_short': 'ع',

    // Generic language toggler
    'ui.switch_to_en': 'Switch to English',
    'ui.switch_to_ar': 'Switch to Arabic',
    'ui.lang_en_short': 'EN',
    'ui.lang_ar_short': 'ع',
    'ui.copy_link': 'Copy link',
    'ui.copy_link_copied': 'Link copied',
    'ui.theme.lightMode': 'Light Mode',
    'ui.theme.darkMode': 'Dark Mode',
    'ui.menu.open': 'Open menu',
    'ui.menu.navigation': 'Navigation',
    'ui.date.startDate': 'Start Date',
    'ui.date.endDate': 'End Date',

    'userTypes.dentist': 'Dentist',
    'userTypes.lab_contact': 'Lab contact',
    'userTypes.technician': 'Technician',
    'userTypes.courier': 'Courier',
    'userTypes.admin': 'Admin',
    'userTypes.backoffice': 'Back office',

    'deliveryTypes.standard_delivery': 'Standard Delivery',
    'deliveryTypes.free_delivery': 'Free Delivery',
    'ui.order.units_list': 'Units',
    'ui.order.qr': 'QR',

    'orders.summary.vat': 'VAT ({{percent}}%)',

    // General UI
    'common.print': 'Print',
    'common.openNew': 'Open in New Page',
    'common.copy': 'Copy',
    'common.copied': 'Copied',
    'common.save': 'Save',
    'common.updated': 'Updated',
    'orders.summary.delivery': 'Delivery Cost',
    'orders.summary.total': 'Total',
    'orders.summary.noFormulaType': 'No formula type selected',
    'orders.summary.formulaType': 'Formula type',
    'orders.summary.unitUnknown': 'Unit',
    'orders.summary.noUnits': 'No units selected',
    'orders.summary.unitLabel': 'Unit',
    'orders.summary.formulaType': 'Formula Type',
    'orders.summary.price': 'Price',
    'orders.summary.formulaLineTitle': 'Formula {{n}}',
    'orders.summary.pricePerUnit': 'Price per unit',
    'orders.summary.unitsCount': 'Units count',
    'orders.summary.formulaLineTotal': 'Formula price',
    'orders.summary.vatLabel': 'VAT',
    'orders.summary.deliveryLabel': 'Delivery Cost',
    'orders.summary.deliveryLabelWithType': 'Delivery Cost ({type})',
    'orders.summary.free': 'Free',
    'orders.table.delivery': 'Delivery',
    'orders.table.createdAt': 'Created On',
    'orders.table.requestedAt': 'Requested At',
    'orders.table.deliveredAt': 'Delivered At',
    'orders.table.units': 'Units Count',
    'orders.table.actions': 'Actions',
    'orders.table.technician': 'Technician',
    'orders.table.courier': 'Courier',
    'orders.status.delivered': 'Delivered',
    'orders.status.pendingDelivery': 'Not delivered',
    'orders.status.paid': 'Paid',
    'orders.status.unpaid': 'Unpaid',
    'orders.status.unknown': 'Unknown',
    'orders.form.patientName.label': 'Patient Name',
    'orders.form.patientName.placeholder': 'Enter patient name',
    'orders.form.patientName.required': 'Please enter the patient name',
    'orders.form.dentist.label': 'Dentist',
    'orders.form.dentist.placeholder': 'Select or add a dentist',
    'orders.form.dentist.required': 'Please select a dentist',
    'orders.form.dentist.clientRequired': 'Select a client first to choose a dentist.',
    'orders.form.dentist.labelLabContact': 'Lab contact',
    'orders.form.dentist.placeholderLabContact': 'Select or add a lab contact',
    'orders.form.dentist.requiredLabContact': 'Please select a lab contact',
    'orders.form.dentist.clientRequiredLabContact': 'Select a client first to choose a lab contact.',
    'orders.form.client.label': 'Client',
    'orders.form.client.placeholder': 'Select or add a client',
    'orders.form.client.required': 'Please select a client',
    'orders.form.color.label': 'Color',
    'orders.form.color.defaultLabel': 'Default color (for new units)',
    'orders.form.color.defaultHelp': 'Applied when you add a new unit',
    'orders.form.color.placeholder': 'Select or add a color',
    'orders.form.color.required': 'Please select a color',
    'orders.form.unitColors.label': 'Color per unit',
    'orders.form.unitFormulaTypes.label': 'Formula type per unit',
    'orders.form.formulaType.defaultLabel': 'Default Formula Type (for new units)',
    'orders.form.formulaType.defaultHelp': 'Applied when you add a new unit',
    'orders.form.unitPriceOverride.placeholder': 'Price override',
    'orders.form.discountAmount.label': 'Order discount (amount)',
    'orders.form.discountAmount.help': 'Deduct this amount from the order subtotal.',
    'orders.form.discountAmount.placeholder': '0',
    'orders.form.formulaType.label': 'Formula Type',
    'orders.form.formulaType.placeholder': 'Select Formula Type',
    'orders.form.formulaType.required': 'Please select a Formula Type',
    'orders.form.requestedAt.label': 'Requested At',
    'orders.form.requestedAt.placeholder': 'Select date',
    'orders.form.issueDate.label': 'Issue Date',
    'orders.form.issueDate.placeholder': 'Select date',
    'orders.form.deliveryDate.label': 'Delivery Date',
    'orders.form.deliveryDate.placeholder': 'Select date',
    'orders.form.additionalCostItems.title': 'Additional cost items',
    'orders.form.additionalCostItems.labelPlaceholder': 'Item description',
    'orders.form.additionalCostItems.amountPlaceholder': 'Cost',
    'orders.form.additionalCostItems.add': 'Add cost item',
    'orders.form.additionalCostItems.remove': 'Remove',
    'orders.form.additionalCostItems.labelRequired': 'Enter a description for this item',
    'orders.form.additionalCostItems.amountRequired': 'Enter the cost amount',
    'orders.summary.additionalCostsTitle': 'Additional costs',
    'orders.summary.additionalCostItemFallback': 'Extra item',
    'orders.summary.additionalCosts': 'Additional costs total',
    'orders.form.notes.label': 'Notes',
    'orders.form.notes.placeholder': 'Notes',
    'orders.form.technician.label': 'Technicians',
    'orders.form.technician.placeholder': 'Select technicians',
    'orders.form.technician.required': 'Please select at least one technician',
    'orders.form.selectUnits.label': 'Select Units',
    'orders.form.selectUnits.required': 'Please select at least one unit',
    'orders.form.orderFormulas.title': 'Order formulas',
    'orders.form.orderFormulas.help': 'An order can include several formulas. On each line, first choose the formula type, then choose the units (teeth for unit scope, or upper and/or lower arch for arch scope). Only unit types that match the formula type are shown.',
    'orders.form.orderFormulas.lineTitle': 'Formula {{n}}',
    'orders.form.orderFormulas.formulaNumber': 'Formula #',
    'orders.form.orderFormulas.fdi': 'FDI',
    'orders.form.orderFormulas.stepFormulaType': 'Step 1: Formula type',
    'orders.form.orderFormulas.colorLabel': 'Color (this formula)',
    'orders.form.orderFormulas.stepUnits': 'Step 2: Units',
    'orders.form.orderFormulas.formulaTypePlaceholder': 'Select formula type first',
    'orders.form.orderFormulas.addLine': 'Add another formula',
    'orders.form.orderFormulas.formulaType': 'Formula type',
    'orders.form.orderFormulas.selectUnits': 'Teeth / units',
    'orders.form.orderFormulas.archChoice': 'Arch',
    'orders.form.orderFormulas.archUpper': 'Upper arch',
    'orders.form.orderFormulas.archLower': 'Lower arch',
    'orders.form.orderFormulas.pickTypeFirst': 'Choose a formula type to load matching units.',
    'orders.form.orderFormulas.required': 'Add at least one formula line with a type and selected units.',
    'orders.form.orderFormulas.incompleteLine': 'Each formula line with a selected type must include at least one unit (tooth or arch).',
    'orders.form.orderFormulas.duplicateFormulaType': 'You can only add one line per formula type on an order.',
    'orders.form.orderFormulas.perUnitFormulaRequired': 'Each selected unit must have a formula type before saving.',
    'orders.form.orderFormulas.summaryUnits': 'Units in this order',
    'orders.form.persistedFormulas.title': 'Formulas on this order',
    'orders.form.persistedFormulas.help': 'Each row is a saved formula (type, unit, and color). Adjust per-unit formula types and pricing in the summary when editing.',
    'orders.form.persistedFormulas.unit': 'Unit (FDI)',
    'orders.form.persistedFormulas.color': 'Color',
    'orders.form.persistedFormulas.detach': 'Remove from order',
    'orders.form.persistedFormulas.detachConfirm': 'Remove this formula line from the order? Linked teeth will lose this formula until you add a new line or set types in the summary.',
    'orders.form.persistedFormulas.detachSuccess': 'Formula line removed from the order.',
    'orders.form.persistedFormulas.detachError': 'Could not remove the formula line. Try again.',
    'orders.form.toothPreview.title': 'Teeth preview',
    'orders.form.toothPreview.help': 'Same chart as when creating an order. When editing, tap teeth to change the selection, then save.',
    'toothPicker.selectUpper': 'Select upper arch',
    'toothPicker.selectLower': 'Select lower arch',
    'toothPicker.clear': 'Clear',
    'orders.form.deliveryCenter.label': 'Delivery Center',
    'orders.form.deliveryCenter.placeholder': 'Select or add a delivery center',
    'orders.form.deliveryCenter.required': 'Please select a delivery center',
    'orders.form.deliveryCenter.clientRequired': 'Select a client first to choose a delivery center.',
    'orders.form.deliveryType.label': 'Delivery Type',
    'orders.form.deliveryType.placeholder': 'Select delivery type',
    'orders.form.attachment.label': 'Attachments',
    'orders.form.attachments.label': 'Attachments',
    'orders.form.attachments.hint': 'You can upload a Zip or multiple files unzipped with the next formats/extensions: *.stl, *.ply, *.obj, *.zip, *.pdf and all types of images & videos (max 20 MB per file).',
    'orders.form.attachments.choose': 'Choose files',
    'orders.form.attachments.existing': 'Existing attachments:',
    'orders.form.attachments.deleteConfirm': 'Remove attachment?',
    'orders.files.title': 'File Management',
    'orders.files.expand': 'Expand',
    'orders.files.collapse': 'Collapse',
    'orders.files.dropzone': 'Click or drop files here to upload',
    'orders.files.hint': '* You can upload a Zip or multiple files unzipped with the next formats/extensions: *.stl, *.ply, *.obj, *.zip, *.pdf and all types of images & videos (max 20 MB per file).',
    'orders.files.queueTitle': 'Upload queue',
    'orders.files.queueLength': 'Queue length: {{count}}',
    'orders.files.searchPlaceholder': 'Search filename or comment',
    'orders.files.col.name': 'File name',
    'orders.files.col.uploadDate': 'Upload date',
    'orders.files.col.size': 'Size',
    'orders.files.col.progress': 'Progress',
    'orders.files.col.actions': 'Actions',
    'orders.files.comment': 'Comment',
    'orders.files.editTitle': 'Edit file',
    'orders.files.downloadAll': 'Download all',
    'orders.files.total': '{{count}} Total',
    'orders.files.empty': 'No files uploaded yet',
    'orders.files.noComment': 'No comment',
    'orders.files.status.queued': 'Waiting',
    'orders.files.status.failed': 'Failed',
    'orders.files.retry': 'Retry',
    'orders.files.cancel': 'Cancel upload',
    'orders.files.remove': 'Remove from queue',
    'orders.files.preview': 'Preview',
    'orders.files.download': 'Download',
    'orders.files.edit': 'Edit',
    'orders.files.delete': 'Delete',
    'orders.files.deleteConfirm': 'Delete this file?',
    'orders.files.invalidType': '{{name}}: this file type is not allowed',
    'orders.files.tooLarge': '{{name}}: file is larger than 20 MB',
    'orders.files.downloadFailed': 'Could not download the file(s)',
    'orders.form.submit.create': 'Create Order',
    'orders.form.submit.save': 'Save Changes',
    'orders.create.section.primaryTitle': 'Order Details',
    'orders.create.section.secondaryTitle': 'Additional Details',
    'orders.create.section.secondaryPlaceholder': 'This section will be available soon.',
    'orders.update.section.primaryTitle': 'Order Details',
    'orders.update.section.secondaryTitle': 'Order Actions',
    'orders.update.section.secondaryPlaceholder': 'Additional order information will appear here soon.',
    'orders.changeHistory': 'Change history',
    'orders.versions.title': 'Order change history',
    'orders.versions.empty': 'No change history yet',
    'orders.versions.timelineTitle': 'Timeline',
    'orders.versions.by': 'Updated by',
    'orders.versions.fieldsChanged': 'Fields changed',
    'orders.versions.compareTitle': 'Compare with current',
    'orders.versions.selectVersion': 'Select a version',
    'orders.versions.noFields': 'No changed fields captured',
    'orders.versions.before': 'Before',
    'orders.versions.after': 'After (Current)',
    'orders.versions.unitLabel': 'Unit',
    'orders.versions.priceLabel': 'Price',
    'orders.actions.technician.label': 'Technicians',
    'orders.actions.technician.unassigned': 'Unassigned',
    'orders.actions.technician.change': 'Assign Technician',
    'orders.actions.viewInvoice': 'View Invoice',
    'orders.actions.technician.select': 'Select technicians',
    'orders.actions.technician.changeSuccess': 'Technicians updated',
    'orders.actions.technician.changeError': 'Failed to update technicians',
    'orders.actions.courier.label': 'Courier',
    'orders.actions.courier.unassigned': 'Unassigned',
    'orders.actions.courier.change': 'Assign Courier',
    'orders.actions.courier.select': 'Select courier',
    'orders.actions.courier.changeSuccess': 'Courier updated',
    'orders.actions.courier.changeError': 'Failed to update courier',
    'orders.actions.courier.unassign': 'Unassign',
    'orders.orderStatus.requested': 'Requested',
    'orders.orderStatus.review': 'Review',
    'orders.orderStatus.tx-review': 'Tx. Review',
    'orders.orderStatus.tx-approved': 'Tx. Approved',
    'orders.orderStatus.tx-replan': 'Tx. Replan',
    'orders.orderStatus.in-progress': 'In Progress',
    'orders.orderStatus.in-delivery': 'In Delivery',
    'orders.orderStatus.delivered': 'Delivered',
    'orders.orderStatus.finished': 'Finished',
    'orders.orderStatus.cancelled': 'Cancelled',
    'orders.orderStatus.dispute': 'Dispute',
    'orders.orderStatus.draft': 'Draft',
    'orders.orderStatus.pending_review': 'Pending Review',
    'orders.orderStatus.under_review': 'Under Review',
    'orders.orderStatus.more_info_required': 'More Info Required',
    'orders.orderStatus.resubmitted': 'Resubmitted',
    'orders.orderStatus.accepted': 'Accepted',
    'orders.orderStatus.rejected': 'Rejected',
    'orders.orderStatus.queued': 'Queued',
    'orders.orderStatus.ready_for_design': 'Ready for Design',
    'orders.orderStatus.design_in_progress': 'Design in Progress',
    'orders.orderStatus.pending_internal_design_review': 'Pending Internal Design Review',
    'orders.orderStatus.pending_design_approval': 'Pending Design Approval',
    'orders.orderStatus.design_revision_requested': 'Design Revision Requested',
    'orders.orderStatus.design_revision_in_progress': 'Design Revision in Progress',
    'orders.orderStatus.design_approved': 'Design Approved',
    'orders.orderStatus.design_rejected': 'Design Rejected',
    'orders.orderStatus.ready_for_try_in_production': 'Ready for Try-in Production',
    'orders.orderStatus.try_in_production_in_progress': 'Try-in Production in Progress',
    'orders.orderStatus.try_in_quality_check': 'Try-in Quality Check',
    'orders.orderStatus.ready_for_try_in': 'Ready for Try-in',
    'orders.orderStatus.out_for_try_in': 'Out for Try-in',
    'orders.orderStatus.pending_try_in_feedback': 'Pending Try-in Feedback',
    'orders.orderStatus.try_in_approved': 'Try-in Approved',
    'orders.orderStatus.try_in_revision_requested': 'Try-in Revision Requested',
    'orders.orderStatus.try_in_revision_in_progress': 'Try-in Revision in Progress',
    'orders.orderStatus.ready_for_repeat_try_in': 'Ready for Repeat Try-in',
    'orders.orderStatus.try_in_not_required': 'Try-in Not Required',
    'orders.orderStatus.in_progress': 'In Progress',
    'orders.orderStatus.manufacturing_try_in': 'Manufacturing Try-in',
    'orders.orderStatus.ready_for_final_production': 'Ready for Final Production',
    'orders.orderStatus.final_production': 'Final Production',
    'orders.orderStatus.ready_for_final_manufacturing': 'Ready for Final Manufacturing',
    'orders.orderStatus.final_manufacturing_in_progress': 'Final Manufacturing in Progress',
    'orders.orderStatus.manufacturing_paused': 'Manufacturing Paused',
    'orders.orderStatus.pending_external_work': 'Pending External Work',
    'orders.orderStatus.finishing_in_progress': 'Finishing in Progress',
    'orders.orderStatus.quality_control': 'Quality Control',
    'orders.orderStatus.quality_control_failed': 'Quality Control Failed',
    'orders.orderStatus.rework_in_progress': 'Rework in Progress',
    'orders.orderStatus.quality_control_passed': 'Quality Control Passed',
    'orders.orderStatus.ready_for_dispatch': 'Ready for Dispatch',
    'orders.orderStatus.awaiting_pickup': 'Awaiting Pickup',
    'orders.orderStatus.out_for_delivery': 'Out for Delivery',
    'orders.orderStatus.delivery_attempt_failed': 'Delivery Attempt Failed',
    'orders.orderStatus.delivery_disputed': 'Delivery Disputed',
    'orders.orderStatus.return_requested': 'Return Requested',
    'orders.orderStatus.returned_to_lab': 'Returned to Lab',
    'orders.orderStatus.pending_closure': 'Pending Closure',
    'orders.orderStatus.closed': 'Closed',
    'orders.orderStatus.on_hold': 'On Hold',
    'orders.orderStatus.awaiting_client_action': 'Awaiting Client Action',
    'orders.orderStatus.awaiting_payment': 'Awaiting Payment',
    'orders.orderStatus.cancel_requested': 'Cancel Requested',
    'orders.orderStatus.remake_requested': 'Remake Requested',
    'orders.orderStatus.remake_approved': 'Remake Approved',
    'orders.orderStatus.remake_in_progress': 'Remake in Progress',
    'orders.orderStatus.disputed': 'Disputed',
    'orders.actions.status.label': 'Order Status',
    'orders.actions.status.change': 'Change Status',
    'orders.actions.status.changeSuccess': 'Status updated',
    'orders.actions.status.changeError': 'Failed to update status',
    'orders.actions.status.cannotCancelPaid': 'Cannot change status to cancelled when order is attached to a paid invoice.',
    'orders.actions.createWorkOrder.title': 'Create Work Order',
    'orders.actions.createWorkOrder.assignedTo': 'Assign To',
    'orders.actions.createWorkOrder.notes': 'Notes',
    'orders.actions.createWorkOrder.cta': 'Create Work Order',
    'orders.actions.createWorkOrder.success': 'Work order created',
    'orders.actions.createWorkOrder.error': 'Failed to create work order',
    'orders.actions.createWorkOrder.byFormulaTypeTitle': 'Order items (by formula type)',
    'orders.actions.createWorkOrder.unitsCount': '{{count}} units',
    'orders.actions.createWorkOrder.unitLabel': 'Unit {{order}}',
    'orders.actions.createWorkOrder.noLineItems': 'No formula items in this order.',
    'orders.paymentStatus.draft': 'Draft',

    'orders.paymentStatus.unpaid': 'Unpaid',
    'orders.paymentStatus.paid': 'Paid',
    'orders.paymentStatus.void': 'Void',
    'orders.button.add': 'Add Order',
    'orders.empty.noOrdersYet': 'No orders yet',
    'orders.empty.noneMatchFilters': 'No orders match the current filters. Try changing payment status or other filters.',
    'orders.button.cancel': 'Cancel',
    'orders.confirm.cancelTitle': 'Cancel Order',
    'orders.confirm.cancelMessage': 'Are you sure you want to cancel this order? This will mark it as a draft and detach it from invoices.',
    'orders.confirm.cancelSuccess': 'Order cancelled',
    'orders.confirm.cancelError': 'Failed to cancel order',
    'orders.button.assignInvoice': 'Assign to Invoice',
    'orders.assign.title': 'Assign Order to Invoice',
    'orders.assign.selectExisting': 'Select an existing invoice for this order\'s client',
    'orders.assign.selectPlaceholder': 'Select an invoice',
    'orders.assign.selectInvoice': 'Please select an invoice to assign',
    'orders.assign.success': 'Order assigned to invoice',
    'orders.assign.attachExisting': 'Attach to existing invoice',
    'orders.assign.created': 'Invoice created and order attached',
    'orders.assign.error': 'Failed to assign order to invoice',
    'orders.assign.assign': 'Assign',
    'orders.assign.create': 'Create Invoice',

    'orders.button.viewEdit': 'View | Edit',
    'orders.button.view': 'View',
    'orders.confirm.deleteTitle': 'Delete Order',
    'orders.confirm.deleteMessage': 'Are you sure you want to delete this order?',
    'orders.update.collectPayment': 'Collect Payment',
    'orders.update.refundPayment': 'Refund Payment',
    'orders.update.markDelivered': 'Mark as Delivered',
    'orders.update.invoiceButton': 'Invoice',
    'invoice.addOrder.modalTitle': 'Attach Order to Invoice',
    'invoice.addOrder.chooseExisting': 'Attach to existing invoice',
    'invoice.addOrder.selectPlaceholder': 'Select invoice',
    'invoice.addOrder.attach': 'Attach to Invoice',
    'invoice.addOrder.createNew': 'Create New Invoice',
    'invoice.addOrder.attached': 'Order attached to invoice',
    'invoice.addOrder.attachedSuccess': 'Order attached successfully',
    'orders.alert.noAccess': 'You do not have access to view orders.',
    'orders.alert.noCreate': 'You do not have permission to create orders.',
    'orders.alert.noView': 'You do not have access to view this order.',
    'responses.permission.denied': 'You do not have permission to perform this action.',
    'responses.common.password_reset_link_sent': 'If an account exists for that email, a password reset link has been sent.',
    'responses.common.password_reset_success': 'Your password has been reset. You can now log in.',
    'colors.form.name.label': 'Color Name',
    'colors.form.name.placeholder': 'Enter color name',
    'colors.form.name.required': 'Please enter the color name',
    'colors.form.name.max': 'Color name must be 255 characters or fewer',
    'colors.form.code.label': 'Color Code',
    'colors.form.code.required': 'Color is required.',
    'colors.search.placeholder': 'Search colors by name',
    'colors.quickCreate.title': 'Add Color',
    'colors.quickCreate.button': 'Add new color',
    'colors.quickCreate.errorFallback': 'Unable to create color. Please try again.',
    'dentists.quickCreate.title': 'Add Dentist',
    'dentists.quickCreate.button': 'Add new dentist',
    'dentists.quickCreate.errorFallback': 'Unable to create dentist. Please try again.',
    'dentists.quickCreate.missingType': 'Unable to detect dentist user type. Please refresh and try again.',
    'dentists.quickCreate.titleLabContact': 'Add Lab Contact',
    'dentists.quickCreate.buttonLabContact': 'Add new lab contact',
    'dentists.quickCreate.errorFallbackLabContact': 'Unable to create lab contact. Please try again.',
    'dentists.form.name.label': 'Dentist Name',
    'dentists.form.name.placeholder': 'Enter dentist name',
    'dentists.form.name.required': 'Please enter the dentist name',
    'dentists.form.name.labelLabContact': 'Lab Contact Name',
    'dentists.form.name.placeholderLabContact': 'Enter lab contact name',
    'dentists.form.name.requiredLabContact': 'Please enter the lab contact name',
    'dentists.form.email.label': 'Email',
    'dentists.form.email.placeholder': 'Enter email',
    'dentists.form.email.required': 'Please enter the email',
    'dentists.form.email.invalid': 'Please enter a valid email address',
    'dentists.form.username.label': 'Username',
    'dentists.form.username.placeholder': 'Enter username',
    'dentists.form.username.hint': 'Required if the dentist has no email',
    'dentists.form.username.optionalHint': 'Optional. Leave email and username empty to generate a username automatically.',
    'dentists.form.password.label': 'Password',
    'dentists.form.password.placeholder': 'Enter password',
    'dentists.form.password.required': 'Please enter the password',
    'dentists.form.password.min': 'Password must be at least 6 characters',
    'dentists.form.password.tempHint': 'Leave empty to use the default temporary password (temp123)',
    'dentists.form.phone.label': 'Phone Number',
    'dentists.form.phone.placeholder': 'Enter phone number',
    'dentists.form.whatsapp.label': 'WhatsApp Number',
    'dentists.form.whatsapp.placeholder': 'Enter WhatsApp number',
    'dentists.form.address.label': 'Address',
    'dentists.form.address.placeholder': 'Enter address',

    // Transactions
    'transactions.table.type': 'Type',
    'transactions.table.reference': 'Reference',
    'transactions.table.amount': 'Amount',
    'transactions.table.notes': 'Notes',
    'transactions.table.createdAt': 'Created On',
    'transactions.types.invoice': 'Invoice',
    'transactions.types.expense': 'Expense',
    'transactions.types.wallet_recharge': 'Wallet Recharge',
    'transactions.types.wallet': 'Wallet',
    'transactions.types.wallet_deduction': 'Wallet Deduction',
    'transactions.types.invoice_refund': 'Invoice Refund',
    'transactions.alert.noAccess': 'You do not have access to view transactions.',

    // Formula Types
    'formulaTypes.table.name': 'Name',
    'formulaTypes.search.placeholder': 'Search by name or description',
    'formulaTypes.filter.unit.placeholder': 'Filter by unit or arch',
    'formulaTypes.table.cost': 'Unit Cost',
    'formulaTypes.table.description': 'Description',
    'formulaTypes.table.actions': 'Actions',
    'formulaTypes.button.add': 'Add Formula Type',
    'formulaTypes.modal.title': 'Formula Types',
    'formulaTypes.confirm.deleteTitle': 'Delete Formula Type',
    'formulaTypes.confirm.deleteMessage': 'Are you sure you want to delete this formula_type?',
    'formulaTypes.form.name.label': 'Formula Type Name',
    'formulaTypes.form.name.placeholder': 'Enter formula type name',
    'formulaTypes.form.name.required': 'Please enter the formula_type name',
    'formulaTypes.form.name.max': 'Name must be at most 255 characters',
    'formulaTypes.form.cost.label': 'Unit Cost',
    'formulaTypes.form.cost.placeholder': '0',
    'formulaTypes.form.cost.required': 'Please enter the unit cost',
    'formulaTypes.form.materialCostPerUnit.label': 'Material cost per unit',
    'formulaTypes.form.materialCostPerUnit.placeholder': '0',
    'formulaTypes.form.sellingPrice.label': 'Selling price per unit',
    'formulaTypes.form.sellingPrice.placeholder': '0',
    'formulaTypes.form.technicianCostPerUnit.label': 'Technician cost per unit',
    'formulaTypes.form.technicianCostPerUnit.placeholder': '0',
    'formulaTypes.form.scope.label': 'Applies to',
    'formulaTypes.form.scope.placeholder': 'Unit or arch',
    'formulaTypes.scope.unit': 'Unit',
    'formulaTypes.scope.arch': 'Arch',
    'formulaTypes.table.materialCostPerUnit': 'Material cost / unit',
    'formulaTypes.table.sellingPrice': 'Selling price',
    'formulaTypes.table.technicianCostPerUnit': 'Technician cost / unit',
    'formulaTypes.table.scope': 'Unit / arch',
    'formulaTypes.form.description.label': 'Formula Type Description',
    'formulaTypes.form.description.placeholder': 'Enter formula type description',
    'formulaTypes.form.attachments.label': 'Attachments',
    'formulaTypes.form.attachments.hint': 'You can upload a Zip or multiple files unzipped with the next formats/extensions: *.stl, *.ply, *.obj, *.zip, *.pdf and all types of images & videos (max 20 MB per file).',
    'formulaTypes.form.attachments.choose': 'Choose files',
    'formulaTypes.form.attachments.existing': 'Existing attachments:',
    'formulaTypes.form.attachments.deleteConfirm': 'Remove attachment?',
    'formulaTypes.attachment.deleted': 'Attachment removed',
    'formulaTypes.attachment.deleteError': 'Failed to remove attachment',
    'formulaTypes.quickCreate.title': 'Add Formula Type',
    'formulaTypes.quickCreate.button': 'Add new formula type',
    'deliveryCenters.quickCreate.title': 'Add Delivery Center',
    'deliveryCenters.quickCreate.button': 'Add new delivery center',
    'deliveryCenters.quickCreate.errorFallback': 'Unable to create delivery center. Please try again.',
    'deliveryCenters.form.name.label': 'Delivery Center Name',
    'deliveryCenters.form.name.placeholder': 'Enter delivery center name',
    'deliveryCenters.form.name.required': 'Please enter the delivery center name',
    'deliveryCenters.form.address.label': 'Address',
    'deliveryCenters.form.address.placeholder': 'Enter address',
    'deliveryCenters.form.phone.label': 'Phone Number',
    'deliveryCenters.form.phone.placeholder': 'Enter phone number',
    'deliveryCenters.form.whatsapp.label': 'WhatsApp Number',
    'deliveryCenters.form.whatsapp.placeholder': 'Enter WhatsApp number',
    'deliveryCenters.form.email.label': 'Email',
    'deliveryCenters.form.email.placeholder': 'Enter email',
    'deliveryCenters.form.email.invalid': 'Please enter a valid email address',
    'deliveryCenters.form.notes.label': 'Notes',
    'deliveryCenters.form.notes.placeholder': 'Add notes (optional)',

    // Lab Profile
    'lab.title': 'Lab Information',
    'lab.table.field': 'Field',
    'lab.table.value': 'Value',
    'lab.table.actions': 'Actions',
    'lab.table.branches': 'Branches',
    'lab.delivery.title': 'Delivery',
    'lab.delivery.col.name': 'Name',
    'lab.delivery.col.amount': 'Amount',
    'lab.delivery.default': 'Default',
    'lab.delivery.setDefault': 'Set as default',
    'lab.delivery.setDefaultSuccess': 'Set as default.',
    'lab.delivery.editValue': 'Change value',
    'lab.delivery.editStandardTitle': 'Change Standard Delivery value',
    'lab.delivery.amountForCurrency': 'Amount ({currency})',
    'lab.delivery.updateSuccess': 'Updated.',
    'lab.field.name': 'Lab Name',
    'lab.field.logo': 'Logo',
    'lab.field.phone': 'Lab Phone',
    'lab.field.contactPhone': 'Contact Phone',
    'lab.field.vatPercentage': 'VAT %',
    'lab.field.delivery': 'Delivery',
    'lab.field.currency': 'Currency',
    'lab.field.whatsapp': 'Lab WhatsApp',
    'orders.orderStatus.on-hold': 'On Hold',
    'lab.button.edit': 'Edit',
    'lab.modal.title': 'Edit Lab Information',
    'lab.form.name.label': 'Lab Name',
    'lab.form.name.placeholder': 'Enter lab name',
    'lab.form.name.required': 'Please enter the lab name',
    'lab.form.phone.label': 'Phone Number',
    'lab.form.phone.placeholder': 'Enter phone number',
    'lab.form.contactPhone.label': 'Contact Phone',
    'lab.form.contactPhone.placeholder': 'Enter contact phone',
    'lab.form.vatPercentage.label': 'VAT Percentage',
    'lab.form.vatPercentage.placeholder': '0',
    'lab.form.delivery.label': 'Delivery',
    'lab.form.delivery.placeholder': '0',
    'lab.form.currency.label': 'Currency',
    'lab.form.currency.placeholder': 'USD',
    'lab.form.currency.lockedHint': 'Currency cannot be changed after setup.',
    'lab.form.whatsapp.label': 'WhatsApp Number',
    'lab.form.whatsapp.placeholder': 'Enter WhatsApp number',
    'lab.form.notes.label': 'Lab Description',
    'lab.form.notes.placeholder': 'Enter lab description',
    'lab.form.logo.label': 'Logo (navbar)',
    'lab.form.logo.hint': 'PNG, JPG, GIF or WebP. Max 4 MB.',
    'lab.form.logo.uploadButton': 'Choose logo file',
    'lab.form.removeLogo': 'Remove current logo',
    'lab.saveSuccess': 'Settings saved',
    'lab.saveError': 'Could not save settings',
    'lab.button.save': 'Save',

    // Home
    'home.currency.egp': 'EGP',
    'home.welcome': 'Welcome {{labName}},',
    'home.summary': 'Summary of lab activity and performance.',
    'home.invoices_amount': 'Invoices Amount',
    'home.paid_invoices': 'Paid Invoices',
    'home.orders': 'Orders',
    'home.dentists': 'Dentists',
    'home.invoices': 'Invoices',
    'home.unpaid_amount': 'Unpaid Amount',
    'home.statistics': 'Statistics',
    'home.recent_clinics': 'Top Clinics',
    'home.activity_overview': 'Activity Overview',
    'home.activity_subtitle': 'Overview of orders, invoices and revenue',
    'home.view_reports': 'View Reports',
    'home.dental_clinic': 'Dental Clinic',
    'home.active_invoices': 'Active Invoices',
    'home.active_expenses': 'Active Expenses',
    'home.invoices_label': 'Invoices',
    'home.expenses_label': 'Expenses',
    'home.amount': 'Amount',
    'home.count': 'Count',
    'home.revenue': 'Revenue',
    'home.paid_invoices_amount': 'Paid Invoices Amount',
    'home.unpaid_invoices_amount': 'Unpaid Invoices Amount',
    'home.expenses_amount': 'Total Expenses',
    'home.paid_invoices_count': 'Paid Invoices Count',
    'home.unpaid_invoices_count': 'Unpaid Invoices Count',
    'home.invoices_count': 'Invoices Count',
    'home.clients_count': 'Clients Count',
    'home.orders_count': 'Orders Count',
    'home.units_count': 'Units Count',
    'home.orders_trend': 'Orders Trend',
    'home.revenue_by_month': 'Revenue (6 months)',
    'home.invoices_breakdown': 'Invoices Breakdown',
    'home.active_clients': 'Active Clients',
    'home.active_orders': 'Active Orders',
    'home.active_dentists': 'Active Dentists',
    'home.clients_label': 'Clients',
    'home.orders_label': 'Orders',
    'home.full_period': 'Full period',

    // New home keys
    'home.new_orders': 'New Orders',
    'home.latest_orders': 'Latest Orders',
    'home.latest_invoices': 'Latest Invoices',
    'home.view_all_invoices': 'View All Invoices',
    'home.orders_tracker': 'Orders Tracker',
    'home.invoices_tracker': 'Invoices Tracker',
    'home.formula_types_tracker': 'Formula Types Tracker',
    'home.formula_type': 'Formula Type',
    'home.units_amount': 'Units Amount',
    'home.total_units_amount': 'Total Units Amount',
    'home.this_week': 'This week',
    'home.this_month': 'This month',
    'home.last_month': 'Last month',
    'home.last_3_months': 'Last 3 months',
    'home.last_6_months': 'Last 6 months',
    'home.last_year': 'Last year',
    'home.custom_range': 'Custom range',
    'home.revenue_tracker': 'Revenue Tracker',
    'home.total_invoices': 'Total Invoices',
    'home.total_invoices_amount': 'Total Invoices Amount',
    'home.total_expenses': 'Total Expenses',
    'home.net': 'Net',
    'home.invoices_vs_expenses': 'Invoices vs Expenses',
    'home.order': 'Order',
    'home.client': 'Client',
    'home.status': 'Status',
    'home.date': 'Date',
    'home.total': 'Total',
    'home.total_orders': 'Total Orders',
    'home.requested': 'Requested',
    'home.in_progress': 'In Progress',
    'home.closed': 'Closed',
    'home.completed_percentage': 'Completed',
    'home.closed_orders': 'Closed Orders',
    'home.view_all_orders': 'View All Orders',

    // Profile
    'profile.title': 'Profile',
    'profile.error.title': 'Unable to load profile',
    'profile.avatar.upload': 'Upload photo',
    'profile.avatar.remove': 'Remove photo',
    'profile.avatar.hint': 'PNG, JPG, GIF or WebP. Max 4 MB.',
    'profile.avatar.tooLarge': 'The uploaded image is too large. Please use an image up to 4 MB.',
    'profile.field.avatar': 'Photo',
    'profile.field.name': 'Name',
    'profile.field.email': 'Email',
    'profile.field.userType': 'User Type',
    'profile.field.vendorName': 'Vendor Name',
    'profile.menu.profile': 'Profile',
    'profile.menu.settings': 'Settings',
    'profile.field.password': 'Password',
    'profile.field.passwordConfirm': 'Confirm Password',
    'profile.field.phone': 'Phone',
    'profile.field.currentPassword': 'Current Password',
    'profile.changePassword': 'Change Password',
    'profile.menu.logout': 'Log out',
    'profile.section.accountDetails': 'Account Details',
    'profile.stats.memberSince': 'Member Since',
    'profile.stats.memberDays': '{count} days with us',
    'profile.stats.lastLogin': 'Last Login',
    'profile.stats.activities': 'Activities',
    'profile.stats.activitiesRecent': '{count} in the last 30 days',
    'profile.stats.ordersAssigned': 'Assigned Orders',
    'profile.stats.ordersCreated': 'Orders Created',
    'profile.stats.ordersActive': '{count} still active',
    'profile.stats.invoicesCreated': 'Invoices Created',
    'profile.stats.paidToUser': 'Paid to You',

    // Users
    'users.page.title': 'Users',
    'users.button.addUser': 'Add User',
    'users.filter.search.placeholder': 'Search by name, email, phone, address or WhatsApp',
    'users.modal.title': 'Users',
    'users.table.name': 'Name',
    'users.table.username': 'Username',
    'users.table.email': 'Email',
    'users.table.userType': 'User Type',
    'users.table.phone': 'Phone Number',
    'users.table.whatsapp': 'WhatsApp Number',
    'users.table.address': 'Address',
    'users.table.actions': 'Actions',
    'users.confirm.deleteTitle': 'Delete User',
    'users.confirm.deleteMessage': 'Are you sure you want to delete this user?',

    // Invitation
    'users.invitation.copyLink': 'Copy Invitation Link',
    'users.invitation.linkCopied': 'Invitation link copied to clipboard',
    'users.invitation.copyFailed': 'Failed to copy invitation link',
    'users.invitation.regenerate': 'Regenerate Invitation Link',
    'users.invitation.regeneratedAndCopied': 'Invitation link regenerated and copied',
    'users.invitation.regenerateFailed': 'Failed to regenerate invitation link',
    'users.invitation.title': 'Invitation',
    'users.invitation.invalidToken': 'Invalid or expired form token',
    'users.invitation.completed': 'Account verified successfully! You can now log in.',
    'users.invitation.completeFailed': 'Failed to complete invitation',
    'users.invitation.error': 'Error',
    'users.invitation.backToLogin': 'Back to Login',
    'users.invitation.setPassword': 'Set Your Password',
    'users.invitation.welcome': 'Welcome!',
    'users.invitation.welcomeMessage': 'Please set a password for {{name}} ({{email}})',
    'users.invitation.complete': 'Complete Setup',
    'users.modal.createTitle': 'Add User',
    'users.modal.editTitle': 'Edit User',
    'users.changeHistory': 'Change history',
    'users.versions.title': 'User change history',
    'users.versions.empty': 'No change history yet',
    'users.versions.by': 'Updated by',
    'users.versions.noFields': 'No changed fields captured',
    'users.versions.timelineTitle': 'Timeline',
    'users.versions.compareTitle': 'Compare with current',
    'users.versions.selectVersion': 'Select a version',
    'users.versions.fieldsChanged': 'Fields changed',
    'users.versions.field': 'Field',
    'users.versions.versionValue': 'Version value',
    'users.versions.currentValue': 'Current value',
    'users.versions.current': 'Current',
    'users.versions.before': 'Before',
    'users.versions.after': 'After (Current)',
    'users.versions.status': 'Status',
    'users.versions.changed': 'Changed',
    'users.versions.same': 'Same',
    'users.form.name.label': 'Name',
    'users.form.name.placeholder': 'Enter name',
    'users.form.name.required': 'Please enter the name',
    'users.form.email.label': 'Email',
    'users.form.email.placeholder': 'Enter email',
    'users.form.email.required': 'Please enter the email',
    'users.form.email.invalid': 'Please enter a valid email',
    'users.form.username.label': 'Username',
    'users.form.username.placeholder': 'Enter username',
    'users.form.username.hint': 'Required if the user has no email',
    'users.form.password.label': 'Password',
    'users.form.password.placeholder': 'Enter password',
    'users.form.password.required': 'Please enter the password',
    'users.form.password.invitationHint': 'Leave empty to send invitation link instead',
    'users.form.password.tempHint': 'Leave empty to use the default temporary password (temp123)',
    'users.form.password.minLength': 'Password must be at least 8 characters',
    'users.form.password.confirm': 'Confirm Password',
    'users.form.password.confirmRequired': 'Please confirm your password',
    'users.form.password.mismatch': 'Passwords do not match',
    'users.form.password.confirmPlaceholder': 'Confirm your password',
    'users.resetPassword.button': 'Reset password',
    'users.resetPassword.confirmTitle': 'Reset to temporary password?',
    'users.resetPassword.confirmMessage': 'This sets the password to temp123. Share it with the user so they can log in and change it.',
    'users.resetPassword.successTitle': 'Temporary password ready',
    'users.resetPassword.successHint': 'Give this password to the user. They should log in and change it from their profile.',
    'users.resetPassword.failed': 'Unable to reset the password',
    'users.forceLogout.button': 'Log out',
    'users.forceLogout.confirmTitle': 'Log this user out?',
    'users.forceLogout.confirmMessage': 'This ends all of the user\'s active sessions on every device. They will need to log in again.',
    'users.forceLogout.success': 'User logged out from all devices',
    'users.forceLogout.failed': 'Unable to log the user out',
    'users.form.phone.label': 'Phone Number',
    'users.form.phone.placeholder': 'Enter phone number',
    'users.form.whatsapp.label': 'WhatsApp Number',
    'users.form.whatsapp.placeholder': 'Enter WhatsApp number',
    'users.form.address.label': 'Address',
    'users.form.address.placeholder': 'Enter address',
    'users.form.userType.label': 'User Type',
    'users.form.userType.placeholder': 'Select a user type',
    'users.form.userType.required': 'Please select a user type',
    'users.form.permissions.label': 'Permissions',
    'users.form.permissions.placeholder': 'Select permissions',
    'users.form.permissions.selectAll': 'Select all',
    'users.permissions.groups.asset': 'Assets',
    'users.permissions.groups.branch': 'Branches',
    'users.permissions.groups.delivery_center': 'Delivery Centers',
    'users.permissions.groups.color': 'Colors',
    'users.permissions.groups.dentist': 'Dentists',
    'users.permissions.groups.expense': 'Expenses',
    'users.permissions.groups.expense_type': 'Expense Types',
    'users.permissions.groups.invoice': 'Invoices',
    'users.permissions.groups.formula_type': 'Formula Types',
    'users.permissions.groups.formula_type': 'Formula Types',
    'users.permissions.groups.order': 'Orders',
    'users.permissions.groups.client': 'Clients',
    'users.permissions.groups.transaction': 'Transactions',
    'users.permissions.groups.unit': 'Units',
    'users.permissions.groups.unit_type': 'Unit Types',
    'users.permissions.groups.user': 'Users',
    'users.permissions.groups.dashboard': 'Dashboard',
    'users.permissions.groups.vendor': 'Vendors',
    'users.permissions.groups.vendor_bank_accounts': 'Bank Accounts',
    'users.permissions.groups.vendor_money_transfer_channels': 'Money Transfer Channels',
    'users.permissions.groups.setting': 'Settings',

    'users.permissions.items.view_dashboard_kpi_orders': 'View Orders KPI',
    'users.permissions.items.view_dashboard_kpi_invoices': 'View Invoices KPI',
    'users.permissions.items.view_dashboard_kpi_clients': 'View Clients KPI',
    'users.permissions.items.view_dashboard_kpi_units': 'View Units KPI',
    'users.permissions.items.view_dashboard_kpi_expenses': 'View Expenses KPI',
    'users.permissions.items.view_dashboard_collection_tracker': 'View Collection Tracker',
    'users.permissions.items.view_dashboard_revenue_tracker': 'View Revenue Tracker',
    'users.permissions.items.view_dashboard_latest_orders': 'View Latest Orders',
    'users.permissions.items.view_dashboard_orders_tracker': 'View Orders Tracker',
    'users.permissions.items.view_dashboard_latest_invoices': 'View Latest Invoices',
    'users.permissions.items.view_dashboard_invoices_tracker': 'View Invoices Tracker',
    'users.permissions.items.view_dashboard_formula_types_tracker': 'View Formula Types Tracker',
    'users.permissions.items.view_dashboard_active_clients': 'View Active Clients',
    'users.permissions.items.view_dashboard_active_orders': 'View Active Orders',
    'users.permissions.items.view_dashboard_active_invoices': 'View Active Invoices',
    'users.permissions.items.view_dashboard_active_expenses': 'View Active Expenses',

    // Invoice extra permissions
    'users.permissions.items.download_invoice_pdf': 'Download Invoice (PDF)',
    'users.permissions.items.send_invoice_whatsapp': 'Send Invoice via WhatsApp',
    'users.permissions.items.send_invoice_email': 'Send Invoice via Email',
    'users.permissions.items.detach_order_from_invoice': 'Detach Order from Invoice',

    // Vendor-related permissions
    'users.permissions.items.view_vendor': 'View Vendors',
    'users.permissions.items.add_vendor': 'Add Vendors',
    'users.permissions.items.edit_vendor': 'Edit Vendors',
    'users.permissions.items.delete_vendor': 'Delete Vendors',

    'users.permissions.items.view_vendor_bank_accounts': 'View Bank Accounts',
    'users.permissions.items.add_vendor_bank_accounts': 'Add Bank Accounts',
    'users.permissions.items.edit_vendor_bank_accounts': 'Edit Bank Accounts',
    'users.permissions.items.delete_vendor_bank_accounts': 'Delete Bank Accounts',

    'users.permissions.items.view_vendor_money_transfer_channels': 'View Money Transfer Channels',
    'users.permissions.items.add_vendor_money_transfer_channels': 'Add Money Transfer Channels',
    'users.permissions.items.edit_vendor_money_transfer_channels': 'Edit Money Transfer Channels',
    'users.permissions.items.delete_vendor_money_transfer_channels': 'Delete Money Transfer Channels',

    // Settings (lab profile)
    'users.permissions.items.view_settings': 'View Settings',
    'users.permissions.items.edit_settings': 'Edit Settings',

    'users.permissions.items.view_asset': 'View Assets',
    'users.permissions.items.add_asset': 'Add Assets',
    'users.permissions.items.edit_asset': 'Edit Assets',
    'users.permissions.items.delete_asset': 'Delete Assets',
    'users.permissions.items.view_branch': 'View Branches',
    'users.permissions.items.add_branch': 'Add Branches',
    'users.permissions.items.edit_branch': 'Edit Branches',
    'users.permissions.items.delete_branch': 'Delete Branches',
    'users.permissions.items.view_delivery_center': 'View Delivery Centers',
    'users.permissions.items.add_delivery_center': 'Add Delivery Centers',
    'users.permissions.items.edit_delivery_center': 'Edit Delivery Centers',
    'users.permissions.items.delete_delivery_center': 'Delete Delivery Centers',
    'users.permissions.items.view_color': 'View Colors',
    'users.permissions.items.add_color': 'Add Colors',
    'users.permissions.items.edit_color': 'Edit Colors',
    'users.permissions.items.delete_color': 'Delete Colors',
    'users.permissions.items.view_dentist': 'View Dentists',
    'users.permissions.items.add_dentist': 'Add Dentists',
    'users.permissions.items.edit_dentist': 'Edit Dentists',
    'users.permissions.items.delete_dentist': 'Delete Dentists',
    'users.permissions.items.view_expense': 'View Expenses',
    'users.permissions.items.add_expense': 'Add Expenses',
    'users.permissions.items.edit_expense': 'Edit Expenses',
    'users.permissions.items.delete_expense': 'Delete Expenses',
    'users.permissions.items.view_expense_type': 'View Expense Types',
    'users.permissions.items.add_expense_type': 'Add Expense Types',
    'users.permissions.items.edit_expense_type': 'Edit Expense Types',
    'users.permissions.items.delete_expense_type': 'Delete Expense Types',
    'users.permissions.items.view_invoice': 'View Invoices',
    'users.permissions.items.add_invoice': 'Add Invoices',
    'users.permissions.items.edit_invoice': 'Edit Invoices',
    'users.permissions.items.delete_invoice': 'Delete Invoices',

    // Order extra actions
    'users.permissions.items.create_invoice_from_order': 'Create Invoice From Order',
    'users.permissions.items.attach_order_to_invoice': 'Attach Order To Existing Invoice',
    'users.permissions.items.create_work_order': 'Work Order',
    'users.permissions.items.view_assigned_orders': 'View Assigned Orders',
    'users.permissions.items.view_order_public_page': 'View Order Public Page',

    // Orders actions UI text
    'orders.actions.createInvoice.title': 'Create Invoice',
    'orders.actions.createInvoice.description': 'Create an invoice using the current order.',
    'orders.actions.createInvoice.cta': 'Create Invoice',
    'orders.actions.createInvoice.success': 'Invoice created successfully',
    'orders.actions.createInvoice.error': 'Failed to create invoice',

    'orders.actions.attach.title': 'Attach to Existing Invoice',
    'orders.actions.attach.selectPlaceholder': 'Select an invoice',
    'orders.actions.attach.cta': 'Attach',
    'orders.actions.attach.success': 'Order attached to invoice',
    'orders.actions.attach.error': 'Failed to attach to invoice',

    'orders.actions.workOrder.title': 'Work Order',
    'orders.actions.workOrder.assignedTo': 'Assign To',
    'orders.actions.workOrder.notes': 'Notes',
    'orders.actions.workOrder.cta': 'Work Order',
    'orders.actions.workOrder.success': 'Work order created',
    'orders.actions.workOrder.error': 'Failed to create work order',
    'users.permissions.items.view_formula_type': 'View Formula Types',
    'users.permissions.items.add_formula_type': 'Add Formula Types',
    'users.permissions.items.edit_formula_type': 'Edit Formula Types',
    'users.permissions.items.delete_formula_type': 'Delete Formula Types',
    'users.permissions.items.view_formula_type': 'View Formula Types',
    'users.permissions.items.view_all_formula_types': 'View All Formula Types',
    'users.permissions.items.add_formula_type': 'Add Formula Types',
    'users.permissions.items.edit_formula_type': 'Edit Formula Types',
    'users.permissions.items.delete_formula_type': 'Delete Formula Types',
    'users.permissions.items.view_client': 'View Clients',
    'users.permissions.items.add_client': 'Add Clients',
    'users.permissions.items.edit_client': 'Edit Clients',
    'users.permissions.items.delete_client': 'Delete Clients',
    'users.permissions.items.view_order': 'View Orders',
    'users.permissions.items.add_order': 'Add Orders',
    'users.permissions.items.edit_order': 'Edit Orders',
    'users.permissions.items.delete_order': 'Delete Orders',
    'users.permissions.items.view_transaction': 'View Transactions',
    'users.permissions.items.add_transaction': 'Add Transactions',
    'users.permissions.items.edit_transaction': 'Edit Transactions',
    'users.permissions.items.delete_transaction': 'Delete Transactions',
    'users.permissions.items.view_unit': 'View Units',
    'users.permissions.items.add_unit': 'Add Units',
    'users.permissions.items.edit_unit': 'Edit Units',
    'users.permissions.items.delete_unit': 'Delete Units',
    'users.permissions.items.view_unit_type': 'View Unit Types',
    'users.permissions.items.add_unit_type': 'Add Unit Types',
    'users.permissions.items.edit_unit_type': 'Edit Unit Types',
    'users.permissions.items.delete_unit_type': 'Delete Unit Types',
    'users.permissions.items.view_user': 'View Users',
    'users.permissions.items.add_user': 'Add Users',
    'users.permissions.items.edit_user': 'Edit Users',
    'users.permissions.items.delete_user': 'Delete Users',
    'users.form.submit.add': 'Add',
    'users.form.submit.edit': 'Update',
    'users.alert.noAccess': 'You do not have access to view users.',

    // Invoice page
    'invoice.title': 'Invoice',
    'invoice.detailsTitle': 'Invoice Details',
    'invoice.placeholder': 'Invoice view placeholder — awaiting layout specification.',
    'invoice.alert.noView': 'You do not have access to view this invoice.',
    'invoice.button.print': 'Print',
    'invoice.button.addOrder': 'Add Order',
    'invoice.field.dentistName': "Dentist's Name",
    'invoice.field.date': 'Invoice Date',
    'invoice.field.client': 'Client',
    'invoice.field.status': 'Status',
    'invoice.field.units': 'Units Count',
    'invoice.field.orders': 'Orders',
    'invoice.field.unitCost': 'Unit Cost',
    'invoice.field.issueDate': 'Issue Date',
    'invoice.field.dueDate': 'Due Date',
    'invoice.field.paidAt': 'Paid At',
    'invoice.field.paymentMethod': 'Payment Method',
    'invoice.field.paymentStatus': 'Payment Status',
    'invoice.field.transferReference': 'Transfer reference',
    'invoice.field.moneyTransferChannel': 'Money Transfer Channel',
    'invoice.field.deliveredAt': 'Delivered At',
    'invoice.orders.viewFormulas': 'View Formulas',
    'invoice.orders.hideFormulas': 'Hide Formulas',
    'invoice.orders.expandAll': 'Expand All Formulas',
    'invoice.orders.collapseAll': 'Collapse All Formulas',
    'invoice.orders.formulasCount': '{{count}} Formulas',
    'invoice.orders.unitsCount': '{{count}} Units',
    'invoice.orders.formulaList': 'Formulas & Shades',
    'invoice.orders.financialSummary': 'Amount Breakdown',
    'invoice.orders.teeth': 'Teeth',
    'invoice.button.detach': 'Detach from invoice',
    'invoice.detach.confirmMessage': 'Are you sure you want to detach this order from the invoice?',
    'invoice.detach.success': 'Order detached successfully',


    'invoice.detach.error': 'Failed to detach order',
    'invoice.cancel.confirmMessage': 'Detaching the last order will convert this invoice to a draft. Continue?',
    'invoice.cancel.success': 'Invoice converted to draft',
    'invoice.cancel.error': 'Failed to cancel invoice',
    'invoice.alert.draft': 'This invoice is a draft',
    'invoice.alert.paidReadOnly': 'This invoice is paid. Editing is disabled; use Undo Payment below if it was marked paid by mistake, or Refund to credit the client wallet.',
    'invoice.button.cancel': 'Cancel Invoice',
    'invoice.button.downloadPdf': 'Download PDF',
    'invoice.button.downloadSummaryPdf': 'Download Invoice PDF',
    'invoice.button.downloading': 'Downloading...',
    'invoice.summary.downloadError': 'Unable to download summary invoice',
    'invoice.button.sendWhatsapp': 'Send WhatsApp',
    'invoice.button.sendEmail': 'Send Email',
    'invoice.changeHistory': 'Change history',
    'invoice.versions.title': 'Invoice change history',
    'invoice.versions.empty': 'No change history yet',
    'invoice.versions.timelineTitle': 'Timeline',
    'invoice.versions.by': 'Updated by',
    'invoice.versions.fieldsChanged': 'Fields changed',
    'invoice.versions.compareTitle': 'Compare with current',
    'invoice.versions.selectVersion': 'Select a version',
    'invoice.versions.noFields': 'No changed fields captured',
    'invoice.versions.currentVersion': 'Current version',
    'invoice.versions.before': 'Before',
    'invoice.versions.after': 'After (Current)',
    'invoice.field.phone': 'Phone',
    'invoice.field.message': 'Message',
    'invoice.button.markPaid': 'Mark as Paid',
    'invoice.markPaid.title': 'Record Payment',
    'invoice.markPaid.paymentMethod': 'Payment Method',
    'invoice.markPaid.channel': 'Money Transfer Channel',
    'invoice.markPaid.channelOther': 'Other Channel',
    'invoice.markPaid.notes': 'Notes',
    'invoice.markPaid.attachment': 'Attachment (image)',
    'invoice.markPaid.success': 'Invoice marked as paid',
    'invoice.markPaid.error': 'Failed to mark invoice as paid',
    'invoice.button.refund': 'Refund',
    'invoice.refund.confirmTitle': 'Refund invoice?',
    'invoice.refund.confirmMessage': 'The paid amount will be credited to the client wallet and the invoice will be marked as unpaid.',
    'invoice.refund.success': 'Invoice refunded successfully',
    'invoice.refund.error': 'Failed to refund invoice',
    'invoice.button.undoMarkPaid': 'Undo Payment',
    'invoice.undoMarkPaid.confirmTitle': 'Undo payment?',
    'invoice.undoMarkPaid.confirmMessage': 'This will reverse the mark-as-paid action as if it never happened. Related payment transactions will be soft-deleted and the invoice will return to unpaid.',
    'invoice.undoMarkPaid.success': 'Invoice payment undone',
    'invoice.undoMarkPaid.error': 'Failed to undo invoice payment',
    'invoice.paymentSummary.toggle': 'Amounts',
    'invoice.paymentSummary.hide': 'Hide Amounts',
    'invoice.paymentSummary.show': 'Show Amounts',
    'invoice.seller.title': 'Seller',
    'invoice.dentist.title': 'Dentist',
    'invoice.deliveryCenter.title': 'Delivery Centers',
    'invoice.customer.title': 'Customer',
    'invoice.client.title': 'Client',
    'invoice.paymentSummary.title': 'Payment Summary',
    'invoice.notes.title': 'Notes',
    'invoice.notes.edit': 'Edit',
    'invoice.notes.save': 'Save',
    'invoice.notes.cancel': 'Cancel',
    'invoice.summary.title': 'Invoice Summary',
    'invoice.summary.subtotal': 'Subtotal',
    'invoice.summary.vat': 'VAT ({{percent}}%)',
    'invoice.summary.totalVat': 'Total VAT',
    'invoice.summary.discount': 'Discount',
    'invoice.summary.delivery': 'Delivery',
    'invoice.summary.total': 'Total',
    'invoice.attachments.title': 'Attachments',
    'invoice.addOrder.selectRequired': 'Please select at least one order',

    // UI invoice labels (used by public invoice view)
    'ui.invoice.number': 'Invoice',
    'ui.invoice.status': 'Status',
    'ui.invoice.issue_date': 'Issue Date',
    'ui.invoice.due_date': 'Due Date',
    'ui.invoice.section_vendor': 'Seller',
    'ui.invoice.section_client': 'Client',
    'ui.invoice.section_dentist': 'Dentist',
    'ui.invoice.section_delivery_center': 'Delivery Center',
    'ui.delivery_cost': 'Delivery Cost',
    'ui.invoice.table.order_ref': 'Order Ref',
    'ui.invoice.table.formula_type': 'Formula Type',
    'ui.invoice.table.units': 'Units',
    'ui.invoice.table.shipment_date': 'Shipment Date',
    'ui.invoice.table.patient': 'Patient',
    'ui.invoice.table.amount': 'Amount',
    'ui.invoice.table.discount': 'Discount',
    'ui.invoice.table.vat': 'VAT',
    'ui.invoice.table.total': 'Total',
    'ui.invoice.status_paid': 'Paid',
    'ui.invoice.status_past_due': 'Past Due',
    'ui.invoice.status_unpaid': 'Unpaid',

    // Generic error messages
    'errors.fetchFailed': 'Failed to load data',
    'invoice.addOrder.added': 'Orders added to invoice',
    'invoice.addOrder.fetchError': 'Unable to fetch orders',
    'invoice.addOrder.attachedHint': 'Attached to Invoice #{id} ({status}) — will be detached if selected',
    'invoice.addOrder.detachConfirmTitle': 'Detach orders from other invoices?',
    'invoice.addOrder.detachConfirmMessage': 'Some selected orders belong to other invoices. Selecting them will detach them from their current invoice(s). Do you want to continue?',

    'invoices.detach.title': 'Detach Orders',
    'invoices.detach.noInvoice': 'Invoice not found',
    'invoice.addOrder.attachError': 'Unable to attach orders',
    'invoice.addOrder.issueDateFrom': 'Issue date from',
    'invoice.addOrder.issueDateTo': 'Issue date to',
    'invoice.addOrder.loadByIssueDate': 'Load by issue date',
    'invoice.addOrder.selectAllInRange': 'Select all',
    'invoice.addOrder.clearIssueDateFilter': 'Clear date filter',
    'invoice.addOrder.issueDateRangeRequired': 'Please select an issue date range',
    'invoice.addOrder.noMatches': 'تعذر العثور على فواتير غير مدفوعة مطابقة لهذا العميل/الطبيب',

    'invoices.button.add': 'Add Invoice',
    'invoice.create.title': 'Create Invoice',
    'invoice.form.clientPlaceholder': 'Select a client to load unpaid orders',
    'invoice.field.formula_type': 'Formula Type Type',
    'invoice.field.color': 'Color',
    'invoice.field.subtotal': 'Subtotal',
    'invoice.field.discountType': 'Discount Type',
    'invoice.field.discountValue': 'Discount Value',
    'invoice.field.total': 'Total Due',
    'invoice.field.paid': 'Total Paid',

    // Not Found
    'notFound.title': 'Page Not Found',

    // Backoffice — vendors (platform admin)
    'sidebar.backoffice_vendors': 'Vendors (admin)',
    'backoffice.vendors.title': 'Vendors',
    'backoffice.vendors.create': 'Create vendor',
    'backoffice.vendors.createTitle': 'Create vendor',
    'backoffice.vendors.editTitle': 'Edit vendor',
    'backoffice.vendors.col.id': 'ID',
    'backoffice.vendors.col.name': 'Name',
    'backoffice.vendors.col.phone': 'Phone',
    'backoffice.vendors.col.users': 'Users',
    'backoffice.vendors.field.name': 'Vendor name',
    'backoffice.vendors.submitCreate': 'Create vendor',
    'backoffice.vendors.loadError': 'Could not load vendors',
    'backoffice.vendors.saveError': 'Could not save vendor',
    'backoffice.vendors.deleteError': 'Could not delete vendor',
    'backoffice.vendors.deleteConfirm': 'Delete this vendor? This cannot be undone.',
    'backoffice.vendors.deleted': 'Vendor deleted',
    'backoffice.vendors.created': 'Vendor created',
    'backoffice.vendors.updated': 'Vendor updated',
    'backoffice.vendors.notFound': 'Vendor not found',
    'backoffice.vendors.tabs.general': 'General',
    'backoffice.vendors.tabs.users': 'Users',
    'backoffice.vendors.tabs.orders': 'Orders',
    'backoffice.vendors.tabs.invoices': 'Invoices',
    'backoffice.vendors.tabs.settings': 'Settings (vendor portal)',
    'backoffice.vendors.users.add': 'Add user',
    'backoffice.vendors.users.addTitle': 'Add vendor user',
    'backoffice.vendors.users.created': 'User created',
    'backoffice.vendors.users.loadError': 'Could not load vendor users',
    'backoffice.vendors.users.saveError': 'Could not save user',
    'backoffice.vendors.users.sendInvitation': 'Send invitation',
    'backoffice.vendors.users.verified': 'Verified',
    'backoffice.vendors.users.pending': 'Pending setup',
    'backoffice.vendors.settings.loadError': 'Could not load vendor settings',
    'backoffice.vendors.settings.labProfile': 'Lab profile',
    'backoffice.vendors.formulaTypeCosts.title': 'Formula Types Cost Calculations',
    'backoffice.vendors.formulaTypeCosts.include': 'Include formula type costs:',
    'backoffice.vendors.formulaTypeCosts.material': 'Material',
    'backoffice.vendors.formulaTypeCosts.technician': 'Technician',
    'backoffice.vendors.formulaTypeCosts.additional': 'Additional',
    'backoffice.vendors.formulaTypeCosts.hint': 'Unchecked costs are left out of this vendor. They are not added as expense types or expenses, and they stay off the dashboard, collection and revenue reports, and formula type screens.',
    'backoffice.vendors.formulaTypeCosts.saved': 'Formula type costs saved',
    'backoffice.vendors.formulaTypeCosts.saveError': 'Could not save formula type costs',
    'backoffice.vendors.formulaTypeCosts.loadError': 'Could not load formula type costs',

    'backoffice.subscriptionPlans.title': 'Subscription plans',
    'backoffice.subscriptionPlans.editTitle': 'Edit subscription plan',
    'backoffice.subscriptionPlans.col.id': 'ID',
    'backoffice.subscriptionPlans.col.name': 'Name',
    'backoffice.subscriptionPlans.col.description': 'Description',
    'backoffice.subscriptionPlans.col.price': 'Price',
    'backoffice.subscriptionPlans.col.highlighted': 'Highlighted',
    'backoffice.subscriptionPlans.field.name': 'Name',
    'backoffice.subscriptionPlans.field.description': 'Description',
    'backoffice.subscriptionPlans.field.price': 'Prices',
    'backoffice.subscriptionPlans.field.features': 'Features',
    'backoffice.subscriptionPlans.field.descriptionEn': 'Description (English)',
    'backoffice.subscriptionPlans.field.descriptionAr': 'Description (Arabic)',
    'backoffice.subscriptionPlans.field.featuresEn': 'Features (English)',
    'backoffice.subscriptionPlans.field.featuresAr': 'Features (Arabic)',
    'backoffice.subscriptionPlans.field.highlighted': 'Highlighted',
    'backoffice.subscriptionPlans.field.active': 'Active',
    'backoffice.subscriptionPlans.field.maxUsers': 'Max users',
    'backoffice.subscriptionPlans.field.maxOrders': 'Max orders / month',
    'backoffice.subscriptionPlans.create': 'Create plan',
    'backoffice.subscriptionPlans.created': 'Plan created',
    'backoffice.subscriptionPlans.deleted': 'Plan deleted',
    'backoffice.subscriptionPlans.deleteError': 'Could not delete plan',
    'backoffice.subscriptionPlans.featuresHint': 'One feature per line',
    'backoffice.subscriptionPlans.addPrice': 'Add price',
    'backoffice.subscriptionPlans.activate': 'Activate',
    'backoffice.subscriptionPlans.deactivate': 'Deactivate',
    'backoffice.subscriptionPlans.activated': 'Plan activated',
    'backoffice.subscriptionPlans.deactivated': 'Plan deactivated',
    'backoffice.subscriptionPlans.updated': 'Plan updated',
    'backoffice.subscriptionPlans.loadError': 'Could not load subscription plans',
    'backoffice.subscriptionPlans.saveError': 'Could not save subscription plan',
    'backoffice.subscriptionPlans.yes': 'Yes',
    'backoffice.subscriptionPlans.no': 'No',

    'backoffice.subscriptions.title': 'Subscriptions',
    'backoffice.subscriptions.loadError': 'Could not load subscriptions',
    'backoffice.subscriptions.filter.status': 'Filter by status',
    'backoffice.subscriptions.col.id': 'ID',
    'backoffice.subscriptions.col.vendor': 'Vendor',
    'backoffice.subscriptions.col.phone': 'Phone',
    'backoffice.subscriptions.col.admin': 'Admin',
    'backoffice.subscriptions.col.plan': 'Plan',
    'backoffice.subscriptions.col.billing': 'Billing',
    'backoffice.subscriptions.col.trialEndsAt': 'Trial ends',
    'backoffice.subscriptions.col.rejectionReason': 'Rejection reason',
    'backoffice.subscriptions.col.suspendedAt': 'Suspended at',
    'backoffice.subscriptions.col.createdAt': 'Created at',
    'backoffice.subscriptions.activate': 'Activate',
    'backoffice.subscriptions.activateConfirm':
      'Create the vendor and admin user, then send an activation email?',
    'backoffice.subscriptions.activated': 'Subscription activated. Invitation email queued.',
    'backoffice.subscriptions.activateError': 'Could not activate subscription',
    'backoffice.subscriptions.activatedLabel': 'Activated',
    'backoffice.subscriptions.reject': 'Reject',
    'backoffice.subscriptions.suspend': 'Suspend',
    'backoffice.subscriptions.reactivate': 'Reactivate',
    'backoffice.subscriptions.cancel': 'Cancel',
    'backoffice.subscriptions.create': 'Create subscription',
    'backoffice.subscriptions.status.pending': 'Pending',
    'backoffice.subscriptions.status.under_review': 'Under review',
    'backoffice.subscriptions.status.active': 'Active',
    'backoffice.subscriptions.status.suspended': 'Suspended',
    'backoffice.subscriptions.status.cancelled': 'Cancelled',
    'backoffice.subscriptions.status.rejected': 'Rejected',
    'backoffice.subscriptions.billing.trialing': 'Trialing',
    'backoffice.subscriptions.billing.active': 'Active',
    'backoffice.subscriptions.billing.past_due': 'Past due',
    'backoffice.subscriptions.billing.cancelled': 'Cancelled',
    'backoffice.subscriptions.billing.manual': 'Manual',

    'backoffice.planRequests.title': 'Plan requests',
    'backoffice.planRequests.loadError': 'Could not load plan requests',
    'backoffice.planRequests.actionError': 'Could not process the plan request',
    'backoffice.planRequests.col.currentPlan': 'Current plan',
    'backoffice.planRequests.col.requestedPlan': 'Requested plan',
    'backoffice.planRequests.col.requestedBy': 'Requested by',
    'backoffice.planRequests.col.note': 'Note',
    'backoffice.planRequests.col.requestedAt': 'Requested at',
    'backoffice.planRequests.col.reviewed': 'Reviewed',
    'backoffice.planRequests.approve': 'Approve',
    'backoffice.planRequests.approveConfirm': 'Approve and activate the {plan} plan for this vendor?',
    'backoffice.planRequests.approved': 'Plan request approved. The new plan is now active.',
    'backoffice.planRequests.reject': 'Reject',
    'backoffice.planRequests.rejectTitle': 'Reject plan request',
    'backoffice.planRequests.rejectReason': 'Reason (optional, shown to the vendor)',
    'backoffice.planRequests.rejected': 'Plan request rejected',
    'backoffice.planRequests.status.pending': 'Pending',
    'backoffice.planRequests.status.approved': 'Approved',
    'backoffice.planRequests.status.rejected': 'Rejected',
    'backoffice.planRequests.status.cancelled': 'Cancelled',
    'backoffice.demoRequests.title': 'Demo requests',
    'backoffice.demoRequests.subtitle': 'Visitors who opened a live demo from the website, with their contact details and device info.',
    'backoffice.demoRequests.loadError': 'Could not load demo requests',
    'backoffice.demoRequests.stats.total': 'Total demos',
    'backoffice.demoRequests.stats.uniqueContacts': 'Unique contacts',
    'backoffice.demoRequests.stats.lab': 'Lab demos',
    'backoffice.demoRequests.stats.clinic': 'Clinic demos',
    'backoffice.demoRequests.stats.last7Days': 'Last 7 days',
    'backoffice.demoRequests.col.contact': 'Contact',
    'backoffice.demoRequests.col.demo': 'Demo',
    'backoffice.demoRequests.col.device': 'Device',
    'backoffice.demoRequests.col.ip': 'IP address',
    'backoffice.demoRequests.col.requestedAt': 'Requested at',
    'backoffice.demoRequests.kind.lab': 'Dental lab',
    'backoffice.demoRequests.kind.clinic': 'Dental clinic',
    'backoffice.demoRequests.device.desktop': 'Desktop',
    'backoffice.demoRequests.device.mobile': 'Mobile',
    'backoffice.demoRequests.device.tablet': 'Tablet',
    'backoffice.demoRequests.device.bot': 'Bot',
    'backoffice.demoRequests.source.demo_section': 'Website demo section',
    'backoffice.demoRequests.source.footer': 'Website footer',
    'backoffice.demoRequests.filter.search': 'Search name, phone or IP',
    'backoffice.demoRequests.filter.kind': 'Demo type',
    'backoffice.demoRequests.filter.device': 'Device type',
    'backoffice.demoRequests.whatsapp': 'Chat on WhatsApp',
    'backoffice.demoRequests.repeat': '{count} demos',
    'backoffice.demoRequests.details': 'Details',
    'backoffice.demoRequests.detailsTitle': 'Demo request',
    'backoffice.demoRequests.field.name': 'Name',
    'backoffice.demoRequests.field.phone': 'Mobile number',
    'backoffice.demoRequests.field.source': 'Opened from',
    'backoffice.demoRequests.field.browser': 'Browser',
    'backoffice.demoRequests.field.os': 'Operating system',
    'backoffice.demoRequests.field.screen': 'Screen size',
    'backoffice.demoRequests.field.browserLanguage': 'Browser language',
    'backoffice.demoRequests.field.timezone': 'Time zone',
    'backoffice.demoRequests.field.referrer': 'Came from (referrer)',
    'backoffice.demoRequests.field.pageUrl': 'Page URL',
    'backoffice.demoRequests.field.userAgent': 'User agent',

    'backoffice.dashboard.title': 'Dashboard',
    'backoffice.dashboard.loadError': 'Could not load dashboard',
    'backoffice.dashboard.kpi.totalVendors': 'Total vendors',
    'backoffice.dashboard.kpi.activeVendors': 'Active vendors',
    'backoffice.dashboard.kpi.pendingSignups': 'Pending signups',
    'backoffice.dashboard.kpi.newThisMonth': 'New this month',
    'backoffice.dashboard.actionRequired': 'Action required',
    'backoffice.dashboard.pendingSignups': 'Pending subscriptions',
    'backoffice.dashboard.vendorsNoUsers': 'Vendors without users',
    'backoffice.dashboard.vendorGrowth': 'Vendor growth',
    'backoffice.dashboard.vendorsByPlan': 'Vendors by plan',
    'backoffice.dashboard.recentActivations': 'Recent activations',
    'backoffice.dashboard.revenue': 'Platform revenue',
    'backoffice.dashboard.revenueTotal': 'Total revenue',
    'backoffice.dashboard.revenueMonth': 'Revenue this month',
    'backoffice.dashboard.col.vendor': 'Vendor',
    'backoffice.dashboard.col.plan': 'Plan',
    'backoffice.dashboard.col.date': 'Date',

    'backoffice.vendors.tabs.overview': 'Overview',
    'backoffice.vendors.tabs.orderStatusFlow': 'Order workflow',
    'orderStatusFlow.title': 'Order Status Workflow',
    'orderStatusFlow.subtitle': 'Every workflow starts at Requested and ends at Closed. Choose the statuses in between and how orders move through them.',
    'orderStatusFlow.transitionsLabel': 'transitions',
    'orderStatusFlow.save': 'Save workflow',
    'orderStatusFlow.discard': 'Discard changes',
    'orderStatusFlow.reset': 'Reset to default',
    'orderStatusFlow.resetConfirmTitle': 'Reset the workflow to the default?',
    'orderStatusFlow.resetConfirmBody': 'All of this vendor\'s custom transitions will be replaced by the default workflow. Existing orders keep their current status.',
    'orderStatusFlow.saved': 'Workflow saved',
    'orderStatusFlow.resetDone': 'Workflow reset to the default',
    'orderStatusFlow.clear': 'Start from scratch',
    'orderStatusFlow.clearConfirmTitle': 'Clear the whole workflow?',
    'orderStatusFlow.clearConfirmBody': 'All statuses and transitions will be removed from this vendor\'s workflow so you can build a new one. Nothing changes until you save, and Discard changes brings the current workflow back. Existing orders keep their current status.',
    'orderStatusFlow.clearDone': 'Workflow cleared. Requested and Closed stay fixed — rebuild the steps in between, then save.',
    'orderStatusFlow.saveError': 'Could not save the workflow',
    'orderStatusFlow.loadError': 'Could not load the workflow',
    'orderStatusFlow.retry': 'Retry',
    'orderStatusFlow.readOnly': 'You can view the workflow but you do not have permission to change it.',
    'orderStatusFlow.unsaved': 'You have unsaved changes.',
    'orderStatusFlow.initialRequired': 'Choose the starting status first.',
    'orderStatusFlow.initialStatus': 'Starting status',
    'orderStatusFlow.initialStatusHint': 'Fixed: every new order starts as Requested.',
    'orderStatusFlow.anyStatus': 'Reachable from any status',
    'orderStatusFlow.anyStatusHint': 'Orders can move to these statuses from any status that is not final (for example On Hold or Cancel Requested).',
    'orderStatusFlow.billable.title': 'When the client owes the order amount',
    'orderStatusFlow.billable.hint': 'Choose the status from which the client owes the lab for an order. Until an order reaches it, it cannot be added to an invoice, and its amount is left out of the dashboard money (Revenue Tracker, Total Orders Amount, Unpaid Orders Amount, Formula Types Tracker), the orders list totals, client balances and statements, and the collection and revenue reports.',
    'orderStatusFlow.billable.enable': 'Count order amounts only from a specific status',
    'orderStatusFlow.billable.placeholder': 'Select a status',
    'orderStatusFlow.billable.countsIn': 'An order counts once it reaches:',
    'orderStatusFlow.billable.stickyNote': 'Once an order counts, it keeps counting while it moves on (for example On Hold or Rework). It stops counting if it is moved back before this status, cancelled, or rejected.',
    'orderStatusFlow.billable.disabledHint': 'Off: every order that is not cancelled or rejected counts as soon as it is created.',
    'orderStatusFlow.billable.restampNote': 'When you save, existing orders are re-checked using their current status.',
    'orderStatusFlow.billable.notInFlow': 'The status the client owes from must be part of the workflow.',
    'orderStatusFlow.paid.title': 'When the order is paid',
    'orderStatusFlow.paid.hint': 'Fixed: when an order is paid in full on an invoice, or selected to be paid in a partial payment, it automatically moves to Closed.',
    'orderStatusFlow.paid.placeholder': 'Select a status',
    'orderStatusFlow.paid.note': 'Cancelled or rejected orders are left unchanged. Undoing a payment does not move the order back.',
    'orderStatusFlow.paid.required': 'Choose the status paid orders should move to.',
    'orderStatusFlow.paid.notInPortal': 'The paid status must be one of the statuses used in the portal.',
    'orderStatusFlow.statusesTitle': 'Statuses and transitions',
    'orderStatusFlow.statusesHint': 'Each status points to the statuses an order can move to next. Click a status to jump to it.',
    'orderStatusFlow.comesFrom': 'From:',
    'orderStatusFlow.nextStatuses': 'Can move to',
    'orderStatusFlow.view.diagram': 'Diagram',
    'orderStatusFlow.view.list': 'List',
    'orderStatusFlow.diagram.hint': 'Build the flow from the start point down: drag from a status\'s bottom dot to another status to add a transition. Click a status to edit it, or click an arrow to remove it.',
    'orderStatusFlow.diagram.connectHint': 'Drag from the bottom dot of a status (or from the start point) onto another status to connect them.',
    'orderStatusFlow.diagram.selectHint': 'Select a status in the diagram to choose where it can move next.',
    'orderStatusFlow.diagram.addStatus': 'Add a status',
    'orderStatusFlow.diagram.autoArrange': 'Auto arrange',
    'orderStatusFlow.diagram.setInitial': 'Set as starting status',
    'orderStatusFlow.diagram.removeFromFlow': 'Remove from workflow',
    'orderStatusFlow.diagram.removeTransition': 'Remove transition',
    'orderStatusFlow.diagram.initialLocked': 'Choose another starting status before removing this one.',
    'orderStatusFlow.diagram.fixedLocked': 'Requested (start) and Closed (end) stay in every workflow.',
    'orderStatusFlow.addTransition': 'Add next',
    'orderStatusFlow.noTransitions': 'No next status yet',
    'orderStatusFlow.previousStatus': 'Previous status',
    'orderStatusFlow.searchPlaceholder': 'Search statuses',
    'orderStatusFlow.noResults': 'No statuses match your search',
    'orderStatusFlow.nextPlaceholder': 'Select statuses',
    'orderStatusFlow.resume': 'Return to previous',
    'orderStatusFlow.resumeHint': 'Allow orders in this status to go back to the status they were in before (useful for On Hold or Awaiting Payment).',
    'orderStatusFlow.ordersCount': '{count} orders',
    'orderStatusFlow.ordersCountHint': 'Orders currently in this status',
    'orderStatusFlow.updatedAt': 'Last updated {date}',
    'orderStatusFlow.badge.initial': 'Start',
    'orderStatusFlow.badge.terminal': 'Final',
    'orderStatusFlow.badge.unused': 'Not in workflow',
    'orderStatusFlow.badge.deadEnd': 'No next status',
    'orderStatusFlow.badge.unreachable': 'Unreachable',
    'orderStatusFlow.warnings.title': 'Review these workflow issues',
    'orderStatusFlow.warnings.unreachable': 'These statuses cannot be reached from the starting status:',
    'orderStatusFlow.warnings.deadEnds': 'Orders in these statuses cannot move anywhere:',
    'orderStatusFlow.warnings.stranded': 'Some orders are in statuses outside the workflow; they can be moved to any workflow status:',
    'orderStatusFlow.warnings.hiddenWithOrders': 'Some orders are in statuses the portal does not use; they keep their status but cannot be filtered by it until they are moved:',
    'orderStatusFlow.portal.title': 'Statuses used in the vendor portal',
    'orderStatusFlow.portal.hint': 'Only these statuses appear in the vendor portal: status lists and filters, "Jump to status", and the workflow below. Unchecking a status also removes its transitions.',
    'orderStatusFlow.portal.count': '{selected} of {total}',
    'orderStatusFlow.portal.workflowOnly': 'Keep workflow statuses only',
    'orderStatusFlow.portal.workflowOnlyHint': 'Unchecks every status that has no transition in the workflow.',
    'orderStatusFlow.portal.selectAll': 'Select all',
    'orderStatusFlow.portal.locked': 'Always used: Requested (start), Closed (end), and Cancelled (Cancel order action).',
    'orderStatusFlow.category.intake': 'Intake',
    'orderStatusFlow.category.design': 'Design',
    'orderStatusFlow.category.try_in': 'Try-in',
    'orderStatusFlow.category.manufacturing': 'Manufacturing',
    'orderStatusFlow.category.quality': 'Quality control',
    'orderStatusFlow.category.delivery': 'Delivery',
    'orderStatusFlow.category.closure': 'Closure',
    'orderStatusFlow.category.remake': 'Remake',
    'orderStatusFlow.category.exception': 'Exceptions',
    'orderStatusFlow.category.other': 'Other',
    'backoffice.vendors.col.status': 'Status',
    'backoffice.vendors.col.plan': 'Plan',
    'backoffice.vendors.col.orders30d': 'Orders (30d)',
    'backoffice.vendors.col.created': 'Created',
    'backoffice.vendors.search': 'Search vendors',
    'backoffice.vendors.export': 'Export CSV',
    'backoffice.vendors.health.loadError': 'Could not load vendor health',
    'backoffice.vendors.health.users': 'Users',
    'backoffice.vendors.health.clients': 'Clients',
    'backoffice.vendors.health.orders30d': 'Orders (30 days)',
    'backoffice.vendors.health.lastLogin': 'Last login',
    'backoffice.vendors.health.ordersTrend': 'Order trend',
    'backoffice.vendors.health.impersonate': 'Login as vendor',
    'backoffice.vendors.health.viewActivities': 'View activities',
    'backoffice.vendors.health.supportNotes': 'Support notes',
    'backoffice.vendors.health.newNote': 'New note',
    'backoffice.vendors.health.noNotes': 'No notes yet',
    'backoffice.vendors.health.noteSaved': 'Note saved',
    'backoffice.vendors.health.noteError': 'Could not save note',
    'backoffice.vendors.health.impersonationStarted': 'Vendor portal opened',
    'backoffice.vendors.health.impersonationError': 'Could not impersonate vendor',

    'backoffice.clients.title': 'All clients',
    'backoffice.clients.loadError': 'Could not load clients',
    'backoffice.clients.col.name': 'Client',
    'backoffice.clients.col.vendor': 'Vendor',
    'backoffice.clients.col.created': 'Created',

    'backoffice.orders.title': 'All orders',
    'backoffice.orders.loadError': 'Could not load orders',
    'backoffice.orders.col.vendor': 'Vendor',
    'backoffice.orders.col.client': 'Client',
    'backoffice.orders.col.status': 'Status',
    'backoffice.orders.col.total': 'Total',
    'backoffice.orders.col.date': 'Date',

    'backoffice.invoices.title': 'All invoices',
    'backoffice.invoices.subtitle': 'Browse invoices across every laboratory on the platform.',
    'backoffice.invoices.loadError': 'Could not load invoices',
    'backoffice.invoices.search': 'Search by invoice number or client',
    'backoffice.invoices.col.reference': 'Invoice',
    'backoffice.invoices.col.vendor': 'Vendor',
    'backoffice.invoices.col.client': 'Client',
    'backoffice.invoices.col.orders': 'Orders',
    'backoffice.invoices.col.status': 'Status',
    'backoffice.invoices.col.total': 'Total',
    'backoffice.invoices.col.remaining': 'Remaining',
    'backoffice.invoices.col.date': 'Date',

    'backoffice.platformUsers.title': 'Platform users',
    'backoffice.platformUsers.create': 'Add user',
    'backoffice.platformUsers.edit': 'Edit user',
    'backoffice.platformUsers.loadError': 'Could not load platform users',
    'backoffice.platformUsers.saveError': 'Could not save user',
    'backoffice.platformUsers.created': 'User created',
    'backoffice.platformUsers.updated': 'User updated',
    'backoffice.platformUsers.deleted': 'User deleted',
    'backoffice.platformUsers.deleteError': 'Could not delete user',
    'backoffice.platformUsers.col.permissions': 'Permissions',
    'backoffice.platformUsers.permissions': 'Permissions',
    'backoffice.platformUsers.passwordOptional': 'Leave blank to keep current',

    'backoffice.navbar.search': 'Search vendors & subscriptions',
    'backoffice.support.title': 'Support inbox',
    'backoffice.support.subtitle': 'Direct messages from vendor-portal users and landing-page visitors.',
    'backoffice.support.loadError': 'Could not load conversations',
    'backoffice.support.threadLoadError': 'Could not load this conversation',
    'backoffice.support.sendError': 'Could not send your reply',
    'backoffice.support.updateError': 'Could not update the conversation',
    'backoffice.support.stats.open': 'Open conversations',
    'backoffice.support.stats.unread': 'Awaiting reply',
    'backoffice.support.stats.vendorUsers': 'Vendor users',
    'backoffice.support.stats.visitors': 'Website visitors',
    'backoffice.support.filter.search': 'Search name, phone, email, vendor or message',
    'backoffice.support.filter.type': 'Sender type',
    'backoffice.support.filter.unreadOnly': 'Unread only',
    'backoffice.support.status.open': 'Open',
    'backoffice.support.status.closed': 'Closed',
    'backoffice.support.status.all': 'All',
    'backoffice.support.type.vendor_user': 'Vendor user',
    'backoffice.support.type.visitor': 'Website visitor',
    'backoffice.support.empty': 'No conversations',
    'backoffice.support.selectConversation': 'Select a conversation to read and reply',
    'backoffice.support.notFound': 'Conversation not found',
    'backoffice.support.startedAt': 'Started {date}',
    'backoffice.support.you': 'You',
    'backoffice.support.seen': 'Seen',
    'backoffice.support.whatsapp': 'Chat on WhatsApp',
    'backoffice.support.close': 'Mark as resolved',
    'backoffice.support.reopen': 'Reopen',
    'backoffice.support.closed': 'Conversation marked as resolved',
    'backoffice.support.reopened': 'Conversation reopened',
    'backoffice.support.closedNote': 'This conversation is resolved. It reopens automatically if the sender writes again.',
    'backoffice.support.replyPlaceholder': 'Write a reply… (Enter to send, Shift+Enter for a new line)',
    'backoffice.support.send': 'Send',
    'backoffice.support.files.attach': 'Attach images or files',
    'backoffice.support.files.remove': 'Remove',
    'backoffice.support.files.processing': 'Finishing…',
    'backoffice.support.files.invalidType': '{{name}}: this file type is not allowed',
    'backoffice.support.files.tooLarge': '{{name}}: file is larger than 20 MB',
    'backoffice.support.files.tooMany': 'You can attach up to {{count}} files per message',
    'backoffice.navbar.notifications': 'Notifications',
    'backoffice.forbidden.message': 'You do not have permission to access this page.',

    'common.name': 'Name',
    'common.password': 'Password',
    'common.success': 'Done successfully',
    'common.error': 'Something went wrong',
    'common.deleted': 'Deleted successfully',
    'common.filters': 'Filters',
    'common.resetFilters': 'Reset filters',
    'backoffice.common.refresh': 'Refresh',
    'backoffice.common.viewAll': 'View all',
    'backoffice.common.invalidEmail': 'Enter a valid email address',
    'backoffice.common.passwordMin': 'Password must be at least 8 characters',
    'backoffice.filter.vendor': 'Filter by vendor',
    'backoffice.dashboard.badge': 'Platform control center',
    'backoffice.dashboard.subtitle': 'Monitor vendor growth, subscriptions and platform revenue at a glance.',
    'backoffice.dashboard.suspendedCount': '{count} suspended',
    'backoffice.dashboard.planRequestsCount': '{count} pending plan requests',
    'backoffice.dashboard.thisWeekCount': '{count} this week',
    'backoffice.vendors.subtitle': 'Manage laboratories on the platform, their plans and account status.',
    'backoffice.vendors.createSubtitle': 'Register a new laboratory. You can add users and settings after creating it.',
    'backoffice.vendors.exportSelected': 'Export {count} selected',
    'backoffice.vendors.health.orders': 'Orders',
    'backoffice.vendors.health.addNote': 'Add note',
    'backoffice.subscriptions.subtitle': 'Review signups and manage the lifecycle of vendor subscriptions.',
    'backoffice.subscriptions.actionError': 'Could not update the subscription',
    'backoffice.subscriptions.rejected': 'Subscription rejected',
    'backoffice.subscriptions.created': 'Subscription created',
    'backoffice.subscriptions.createError': 'Could not create subscription',
    'backoffice.subscriptions.trialUntil': 'Until {date}',
    'backoffice.subscriptions.suspendConfirm': 'Suspend this subscription? The vendor will lose access until it is reactivated.',
    'backoffice.subscriptions.cancelConfirm': 'Cancel this subscription? This cannot be undone.',
    'backoffice.subscriptions.rejectTitle': 'Reject subscription',
    'backoffice.subscriptions.rejectReason': 'Reason (optional)',
    'backoffice.subscriptions.form.planPlaceholder': 'Select a plan',
    'backoffice.subscriptions.form.adminName': 'Admin name',
    'backoffice.subscriptions.form.adminEmail': 'Admin email',
    'backoffice.planRequests.subtitle': 'Approve or reject plan upgrade and downgrade requests from vendors.',
    'backoffice.planRequests.col.change': 'Plan change',
    'backoffice.subscriptionPlans.subtitle': 'Define the plans vendors can subscribe to, with pricing and usage limits.',
    'backoffice.subscriptionPlans.col.limits': 'Limits',
    'backoffice.subscriptionPlans.unlimited': 'Unlimited',
    'backoffice.subscriptionPlans.deleteConfirm': 'Delete this plan? Plans with active subscriptions cannot be deleted.',
    'backoffice.clients.subtitle': 'Browse clients across every laboratory on the platform.',
    'backoffice.clients.search': 'Search by name or phone',
    'backoffice.orders.subtitle': 'Browse orders across every laboratory on the platform.',
    'backoffice.platformUsers.subtitle': 'Manage backoffice staff accounts and their permissions.',
    'backoffice.platformUsers.deleteConfirm': 'Delete this user? They will lose backoffice access immediately.',

    'sidebar.dashboard': 'Dashboard',
    'sidebar.platform_clients': 'Clients',
    'sidebar.platform_orders': 'Orders',
    'sidebar.platform_invoices': 'Invoices',
    'sidebar.platform_users': 'Platform users',

    // Payment / bank accounts (settings + invoice payment section)
    'lab.payment.title': 'Payment Settings',
    'lab.payment.bank_accounts_title': 'Bank Accounts',
    'lab.payment.addAccount': 'Add Bank Account',
    'lab.payment.editAccount': 'Edit Bank Account',
    'lab.payment.accountHolder': 'Account Holder',
    'lab.payment.accountHolder.required': 'Account holder is required',
    'lab.payment.accountHolder.max': 'Account holder name is too long',
    'lab.payment.accountNumber': 'Account Number',
    'lab.payment.accountNumber.required': 'Account number is required',
    'lab.payment.accountNumber.invalid': 'Invalid account number',
    'lab.payment.accountNumber.min': 'Account number is too short',
    'lab.payment.iban': 'IBAN',
    'lab.payment.iban.invalid': 'Invalid IBAN',
    'lab.payment.swiftCode': 'Swift Code',
    'lab.payment.swiftCode.invalid': 'Invalid SWIFT/BIC',
    'lab.payment.bankName': 'Bank Name',
    'lab.payment.bankName.required': 'Bank name is required',
    'lab.payment.bankName.max': 'Bank name is too long',
    'lab.payment.branch': 'Bank Branch',
    'lab.payment.branch.max': 'Branch details are too long',
    'lab.payment.no_accounts': 'No bank accounts',
    'lab.payment.no_transfer': 'No active transfer channels',
    'lab.payment.addTransfer': 'Add Transfer Channel',
    'lab.payment.editTransfer': 'Edit Transfer Channel',
    'lab.payment.channel': 'Transfer Channel',
    'lab.payment.deactivate': 'Deactivate',
    'lab.payment.channel.required': 'Please select a transfer channel',
    'lab.payment.phone.invalid': 'Invalid phone number',
    'lab.payment.transfer_title': 'Money Transfer',
    'lab.payment.activate': 'Activate',
    'lab.payment.activated': 'Activated',
    'lab.payment.deactivated': 'Deactivated',
    'ui.invoice.bank_account': 'Bank Account',
    'ui.invoice.bank_account_numbered': 'Bank Account {{n}}',
    'ui.invoice.bank_name': 'Bank Name',
    'ui.invoice.bank_swift': 'Swift Code',
    'ui.invoice.bank_iban': 'IBAN',
    'ui.invoice.account_holder': 'Account Holder',
    'ui.invoice.account_number': 'Account Number',
    'ui.invoice.vendor_payment_data': 'Vendor Payment Data',
    'ui.invoice.money_transfer_channels': 'Money Transfer Channels',
    'ui.invoice.channel.instapay': 'Instapay',
    'ui.invoice.channel.vodafone_cash': 'Vodafone Cash',
    'ui.invoice.channel.vodafone-cash': 'Vodafone Cash',
    'ui.invoice.channel.etisalat_cash': 'Etisalat Cash',
    'ui.invoice.channel.etisalat-cash': 'Etisalat Cash',
    'ui.invoice.channel.we_pay': 'WE Pay',
    'ui.invoice.channel.we-pay': 'WE Pay',
    'ui.invoice.channel.fawry': 'Fawry',
    'ui.invoice.channel.bank_transfer': 'Bank Transfer',
    'ui.invoice.channel.bank-transfer': 'Bank Transfer',
    'ui.invoice.channel.meeza': 'Meeza',
    'ui.invoice.channel.masary': 'Masary',
  },
  ar: {
    'common.add': 'إضافة',
    'common.addNew': 'إضافة جديد',
    'common.edit': 'تعديل',
    'common.update': 'تحديث',
    'common.delete': 'حذف',
    'common.view': 'عرض',
    'common.cancel': 'إلغاء',
    'common.optional': 'اختياري',
    'common.close': 'إغلاق',
    'common.details': 'التفاصيل',
    'common.openDetailsPage': 'فتح الصفحة الكاملة',
    'common.createdAt': 'تاريخ الإنشاء',
    'common.updatedAt': 'تاريخ التحديث',
    'common.actions': 'العمليات',
    'common.confirmDeleteTitle': 'حذف عنصر',
    'common.confirmDeleteMessage': 'هل تريد حذف هذا العنصر؟',
    'common.back': 'رجوع',
    'common.deleteConfirm': 'حذف',
    'common.added': 'مضاف',
    'common.zeroPlaceholder': '٠',
    'common.notes': 'ملاحظات',
    'common.phone': 'رقم التليفون',
    'common.whatsapp': 'رقم الواتساب',
    'common.address': 'العنوان',
    'common.email': 'البريد الإلكتروني',
    'common.subject': 'الموضوع',
    'common.required': 'هذا الحقل مطلوب',
    'common.confirm': 'تأكيد',
    'common.validationError': 'خطأ في التحقق',
    'api.errors.validation_error': 'خطأ في التحقق من البيانات',
    'api.errors.invalid_credentials': 'بيانات الدخول غير صحيحة',
    'api.errors.unauthenticated': 'غير مصرح لك',
    'api.errors.permission_denied': 'ليس لديك صلاحية القيام بهذا الإجراء',
    'api.errors.invalid_current_password': 'كلمة المرور الحالية غير صحيحة',
    'api.errors.login_identifier_required': 'يرجى إدخال بريد إلكتروني أو اسم مستخدم.',
    'api.errors.email_invalid': 'يرجى إدخال بريد إلكتروني صالح.',
    'api.errors.email_taken': 'هذا البريد الإلكتروني مسجل بالفعل.',
    'api.errors.username_taken': 'اسم المستخدم مستخدم بالفعل.',
    'api.errors.already_taken': 'هذه القيمة مستخدمة بالفعل.',
    'api.errors.backoffice_access_denied': 'لا يمكن لهذا الحساب الوصول إلىصفحة دخول الإدارة.',
    'api.errors.vendor_portal_only': 'يجب تسجيل الدخول عبرصفحة دخول المعمل.',
    'api.errors.not_found': 'غير موجود',
    'api.errors.request_failed': 'حدث خطأ ما',
    'forms.whatsappSameAsPhone': 'الواتساب نفس رقم الهاتف',
    'forms.phone.placeholder': 'ادخل رقم الهاتف',
    'forms.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'forms.copyFromVendor.label': 'استخدام بيانات التواصل للمختبر',
    'forms.copyFromVendor.phone': 'هاتف المختبر',
    'forms.copyFromVendor.whatsapp': 'واتساب المختبر',
    'forms.copyFromVendor.address': 'عنوان المختبر',
    'forms.copyFromClient.label': 'استخدام بيانات التواصل للعميل',
    'forms.copyFromClient.phone': 'هاتف العميل',
    'forms.copyFromClient.whatsapp': 'واتساب العميل',
    'forms.copyFromClient.address': 'عنوان العميل',
    'common.clear': 'مسح',
    'common.general': 'عام',
    'validation.name.required': 'الاسم مطلوب',
    'validation.name.min': 'يجب أن يكون الاسم حرفين على الأقل',
    'validation.name.max': 'يجب ألا يزيد الاسم عن 255 حرفًا',
    'validation.email.required': 'البريد الإلكتروني مطلوب',
    'validation.email.invalid': 'يرجى إدخال بريد إلكتروني صالح',
    'validation.email.max': 'يجب ألا يزيد البريد الإلكتروني عن 255 حرفًا',
    'validation.username.required': 'اسم المستخدم مطلوب',
    'validation.username.min': 'يجب أن يكون اسم المستخدم 3 أحرف على الأقل',
    'validation.username.max': 'يجب ألا يزيد اسم المستخدم عن 50 حرفًا',
    'validation.username.invalid': 'اسم المستخدم يمكن أن يحتوي على حروف وأرقام ونقاط وشرطات سفلية وشرطات فقط',
    'validation.login.identifierRequired': 'أدخل بريدًا إلكترونيًا أو اسم مستخدم',
    'validation.phone.required': 'رقم الهاتف مطلوب',
    'validation.phone.invalid': 'يرجى إدخال رقم هاتف صالح',
    'validation.phone.max': 'يجب ألا يزيد رقم الهاتف عن 50 حرفًا',
    'validation.whatsapp.required': 'رقم الواتساب مطلوب',
    'validation.whatsapp.invalid': 'يرجى إدخال رقم واتساب صالح',
    'validation.whatsapp.max': 'يجب ألا يزيد رقم الواتساب عن 50 حرفًا',
    'common.loading': 'جاري التحميل...',
    'common.saved': 'تم الحفظ بنجاح',

    'sidebar.dashboard': 'لوحة التحكم',
    'sidebar.reports': 'التقارير',
    'sidebar.settings': 'الإعدادات',
    'sidebar.setting': 'إعدادت المعمل',
    'sidebar.orders': 'الطلبات',
    'sidebar.orders_calendar': 'التقويم',
    'sidebar.invoices': 'الفواتير',

    // Invoices
    'invoices.header.title': 'الفواتير',
    'invoices.header.subtitle': 'إدارة فواتير المعمل ومتابعة التحصيلات وحالات الدفع والسجلات المالية',
    'invoices.stats.total': 'إجمالي الفواتير',
    'invoices.stats.totalSubtitle': '{paid} مدفوعة · {partial} جزئية · {unpaid} غير مدفوعة',
    'invoices.stats.amount': 'إجمالي المبالغ',
    'invoices.stats.collected': 'المحصّل',
    'invoices.stats.collectedSubtitle': '{percent}% من إجمالي المبالغ',
    'invoices.stats.outstanding': 'المتبقي',
    'invoices.stats.outstandingSubtitle': '{count} فاتورة بانتظار الدفع',
    'invoices.stats.overdue': 'متأخرة السداد',
    'invoices.stats.overdueSubtitle': '{count} فاتورة تجاوزت تاريخ الاستحقاق',
    'invoices.filter.title': 'تصفية الفواتير',
    'invoices.filter.active': 'مفعل',
    'invoices.filter.clear': 'إعادة تعيين',
    'invoices.table.refresh': 'تحديث',
    'invoices.table.ordersCount': 'الطلبات',
    'invoices.table.number': 'رقم الفاتورة',
    'invoices.table.status': 'الحالة',
    'invoices.table.issueDate': 'تاريخ الإصدار',
    'invoices.table.client': 'العميل',
    'invoices.table.dentist': 'الطبيب',
    'invoices.table.dueDate': 'تاريخ الاستحقاق',
    'invoices.table.total': 'الإجمالي',
    'invoices.table.actions': 'الاجراءات',
    'invoices.table.draft': 'مؤرشفة',
    'invoices.table.draftLabel': 'مؤرشفة',
    'invoices.search.placeholder': 'بحث برقم الفاتورة، المرجع، العميل، الطبيب أو الملاحظات',
    'invoices.confirm.delete': 'هل أنت متأكد أنك تريد حذف هذه الفاتورة؟',
    'invoices.alert.noAccess': 'ليس لديك صلاحية لعرض الفواتير.',
    'sidebar.formula_types': 'المواد',
    'sidebar.formula_types': 'أنواع المواد',
    'sidebar.colors': 'الألوان',
    'sidebar.assets': 'الأصول',
    'sidebar.branchs': 'الفروع',
    'sidebar.delivery_centers': 'مراكز التوصيل',
    'sidebar.expenses': 'المصروفات',
    'sidebar.expense_types': 'بنود المصروفات',
    'sidebar.dentists': 'الأطباء',
    'sidebar.users': 'المستخدمون',
    'sidebar.roles': 'الأدوار والصلاحيات',
    'sidebar.transactions': 'المعاملات',
    'sidebar.activities': 'سجل العمليات',
    'sidebar.units': 'الوحدات',
    'sidebar.unit_types': 'أنواع الوحدات',

    // Activities
    'activities.subtitle': 'سجل تدقيق لعمليات المستخدمين عبر المنصة',
    'activities.table.vendor': 'المعمل',
    'activities.table.entity_affected': 'السجل المتأثر',
    'activities.table.user': 'اسم المستخدم',
    'activities.table.operation': 'العملية',
    'activities.table.ip': 'عنوان الجهاز',
    'activities.table.date': 'التاريخ',
    'activities.table.properties': 'الخصائص',
    'activities.filters.vendor': 'المعمل',
    'activities.filters.name': 'الاسم أو اسم المستخدم أو البريد',
    'activities.filters.entity': 'الكيان',
    'activities.filters.operation': 'العملية',
    'activities.operations.create': 'إنشاء',
    'activities.operations.created': 'إنشاء',
    'activities.operations.update': 'تحديث',
    'activities.operations.updated': 'تحديث',
    'activities.operations.delete': 'حذف',
    'activities.operations.deleted': 'حذف',
    'activities.operations.login': 'تسجيل الدخول',
    'activities.operations.logout': 'تسجيل الخروج',
    'activities.operations.impersonate': 'انتحال هوية',
    'activities.operations.force_logout': 'تسجيل خروج إجباري',
    'activities.operations.paid_invoice': 'دفع فاتورة',
    'activities.operations.undo_mark_paid': 'التراجع عن تعليم كمدفوعة',
    'activities.operations.refund_invoice': 'استرداد فاتورة',
    'activities.operations.partial_payment': 'دفع جزئي لفاتورة',
    'activities.operations.mark_order_paid': 'تعليم الطلب كمدفوع',
    'activities.operations.mark_order_unpaid': 'تعليم الطلب كغير مدفوع',
    'activities.operations.mark_order_partially_paid': 'تعليم الطلب كمدفوع جزئياً',
    'activities.operations.cancel': 'إلغاء',
    'activities.operations.send_email': 'إرسال بريد إلكتروني',
    'activities.operations.send_whatsapp': 'إرسال واتساب',
    'activities.operations.download_invoice_pdf': 'تحميل PDF الفاتورة',
    'activities.operations.download_summary_invoice_pdf': 'تحميل ملخص الفاتورة PDF',
    'activities.operations.download_period_summary_invoice_pdf': 'تحميل ملخص فترة الفاتورة PDF',
    'activities.operations.download_pdf': 'تحميل PDF الفاتورة',
    'activities.operations.download_summary_pdf': 'تحميل ملخص الفاتورة PDF',
    'activities.operations.download_period_summary_pdf': 'تحميل ملخص فترة الفاتورة PDF',
    'activities.operations.download_invoice_spreadsheet': 'تحميل الفاتورة Excel / CSV',
    'activities.operations.upload_attachment': 'رفع مرفق',
    'activities.operations.delete_attachment': 'حذف مرفق',
    'activities.operations.export_account_statement': 'تنزيل كشف الحساب',
    'activities.operations.password_reset': 'إعادة تعيين كلمة المرور',
    'activities.operations.password_reset_request': 'طلب إعادة تعيين كلمة المرور',
    'activities.operations.wallet_recharge': 'شحن محفظة',
    'activities.operations.update_wallet_log_date': 'تغيير تاريخ سجل المحفظة',
    'activities.operations.wallet_recharge_revert': 'تراجع عن شحن محفظة',
    'activities.filters.module': 'القسم',
    'activities.filters.ip': 'عنوان الجهاز',
    'activities.filters.user_type': 'نوع المستخدم',
    'activities.filters.entity_id': 'رقم السجل',
    'activities.table.module': 'القسم',
    'activities.modules.assets': 'الأصول',
    'activities.modules.auth': 'تسجيل الدخول',
    'activities.modules.backoffice_auth': 'دخول لوحة الإدارة',
    'activities.modules.client_formula_type_prices': 'أسعار العملاء',
    'activities.modules.clients': 'العملاء',
    'activities.modules.colors': 'الألوان',
    'activities.modules.delivery_centers': 'مراكز التوصيل',
    'activities.modules.expenses': 'المصروفات',
    'activities.modules.formula_types': 'أنواع التركيبات',
    'activities.modules.invoices': 'الفواتير',
    'activities.modules.money_transfer_channels': 'قنوات تحويل الأموال',
    'activities.modules.orders': 'الطلبات',
    'activities.modules.settings': 'الإعدادات',
    'activities.modules.users': 'المستخدمون',
    'activities.modules.wallets': 'المحافظ',
    'activities.properties.field': 'الحقل',
    'activities.properties.old': 'القيمة السابقة',
    'activities.properties.new': 'القيمة الجديدة',
    'activities.properties.no_changes': 'لا توجد بيانات مقارنة قديم/جديد لهذا النشاط.',
    'activities.modal.properties_title': 'الخصائص المتغيرة',
    'activities.fields.id': 'المعرف',
    'activities.fields.name': 'الاسم',
    'activities.fields.email': 'البريد الإلكتروني',
    'activities.fields.phone': 'رقم الهاتف',
    'activities.fields.notes': 'ملاحظات',
    'activities.fields.address': 'العنوان',
    'activities.fields.whatsapp': 'واتساب',
    'activities.fields.client': 'العميل',
    'activities.fields.client_id': 'العميل',
    'activities.fields.client_name': 'العميل',
    'activities.fields.client_address': 'عنوان العميل',
    'activities.fields.dentist': 'الطبيب',
    'activities.fields.dentist_id': 'الطبيب',
    'activities.fields.dentist_name': 'الطبيب',
    'activities.fields.dentist_email': 'البريد الإلكتروني للطبيب',
    'activities.fields.dentist_phone': 'هاتف الطبيب',
    'activities.fields.technician': 'الفني',
    'activities.fields.technician_id': 'الفني',
    'activities.fields.technician_name': 'اسم الفني',
    'activities.fields.technician_email': 'البريد الإلكتروني للفني',
    'activities.fields.courier': 'مندوب التوصيل',
    'activities.fields.courier_id': 'مندوب التوصيل',
    'activities.fields.orders': 'الطلبات',
    'activities.fields.units': 'الوحدات',
    'activities.fields.units_count': 'عدد الوحدات',
    'activities.fields.attachments': 'المرفقات',
    'activities.fields.requested_at': 'تاريخ الطلب',
    'activities.fields.delivered_at': 'تم التسليم',
    'activities.fields.code': 'الكود',
    'activities.fields.color': 'اللون',
    'activities.fields.formula_type': 'الخامة',
    'activities.fields.delivery_type': 'نوع التوصيل',
    'activities.fields.delivery_type_name': 'نوع التوصيل',
    'activities.fields.user_type': 'نوع المستخدم',
    'activities.fields.payment_method': 'طريقة الدفع',
    'activities.fields.payment_method_id': 'طريقة الدفع',
    'activities.fields.payment_status': 'حالة الدفع',
    'activities.fields.payment_status_id': 'حالة الدفع',
    'activities.fields.order_status': 'حالة الطلب',
    'activities.fields.delivery_center': 'مركز التوصيل',
    'activities.fields.delivery_center_id': 'مركز التوصيل',
    'activities.fields.delivery_center_name': 'اسم مركز التوصيل',
    'activities.fields.delivery_center_address': 'عنوان مركز التوصيل',
    'activities.fields.delivery_center_created_at': 'تاريخ إنشاء مركز التوصيل',
    'activities.fields.delivery_center_updated_at': 'تاريخ تحديث مركز التوصيل',
    'activities.fields.delivery_cost': 'تكلفة التوصيل',
    'activities.fields.discount_amount': 'قيمة الخصم',
    'activities.fields.vat_percentage': 'نسبة الضريبة',
    'activities.fields.unit_price_override': 'تجاوز سعر الوحدة',
    'activities.fields.unit_price_source': 'مصدر سعر الوحدة',
    'activities.fields.reference': 'المرجع',
    'activities.fields.is_draft': 'مسودة',
    'activities.fields.due_date': 'تاريخ الاستحقاق',
    'activities.fields.issue_date': 'تاريخ الإصدار',
    'activities.fields.paid_at': 'تاريخ الدفع',
    'activities.fields.paid_amount': 'المبلغ المدفوع',
    'activities.fields.total_amount': 'الإجمالي',
    'activities.fields.subtotal_amount': 'الإجمالي الفرعي',
    'activities.fields.remaining_amount': 'المبلغ المتبقي',
    'activities.fields.created_at': 'تاريخ الإنشاء',
    'activities.fields.updated_at': 'تاريخ التحديث',

    'auth.login.title': 'تسجيل الدخول',
    'auth.login.backofficeTitle': 'صفحة دخول الإدارة',
    'auth.login.backofficeSubtitle': 'سجّل الدخول بحساب المشغّل',
    'auth.login.backofficeNotice': 'للاستخدام الداخلي فقط. حسابات المعامل غير مدعومة هنا.',
    'auth.login.email.label': 'البريد الإلكتروني',
    'auth.login.email.required': 'من فضلك ادخل البريد الإلكتروني',
    'auth.login.email.invalid': 'من فضلك ادخل بريدًا إلكترونيًا صحيحًا',
    'auth.login.email.placeholder': 'ادخل البريد الإلكتروني',
    'auth.login.password.label': 'كلمة المرور',
    'auth.login.password.required': 'من فضلك ادخل كلمة المرور',
    'auth.login.password.placeholder': 'ادخل كلمة المرور',
    'auth.login.submit': 'تأكيد',
    'auth.login.backofficeOnly': 'لا يمكن لهذا الحساب الوصول إلىصفحة دخول الإدارة. استخدم حساب مشغّل الإدارة.',

    'assets.table.name': 'الاسم',
    'assets.table.cost': 'القيمة',
    'assets.table.notes': 'ملاحظات',
    'assets.table.actions': 'العمليات',
    'assets.button.add': 'إضافة أصل',
    'assets.modal.title': 'الأصول الثابتة',
    'assets.confirm.deleteTitle': 'حذف أصل',
    'assets.confirm.deleteMessage': 'هل تريد حذف هذا الأصل؟',
    'assets.form.name.label': 'اسم الأصل',
    'assets.form.name.placeholder': 'ادخل اسم الأصل',
    'assets.form.name.required': 'من فضلك أدخل اسم الأصل',
    'assets.form.cost.label': 'التكلفة',
    'assets.form.cost.placeholder': 'أدخل التكلفة',
    'assets.form.cost.required': 'من فضلك أدخل التكلفة',
    'assets.form.cost.min': 'يجب أن تكون التكلفة ١ على الأقل',
    'assets.form.notes.label': 'ملاحظات',
    'assets.form.notes.placeholder': 'ادخل الملاحظات',
    'assets.search.namePlaceholder': 'ابحث بالاسم',
    'assets.search.notesPlaceholder': 'ابحث بالملاحظات',
    'assets.alert.noAccess': 'ليس لديك صلاحية لعرض الأصول.',
    'assets.header.title': 'الأصول',
    'assets.header.subtitle': 'متابعة معدات المعمل والأصول الثابتة وقيمتها',
    'assets.stats.total': 'إجمالي الأصول',
    'assets.stats.addedThisMonth': '{count} أُضيفت هذا الشهر',
    'assets.stats.totalValue': 'القيمة الإجمالية',
    'assets.stats.averageValue': 'متوسط القيمة',
    'assets.stats.mostValuable': 'الأعلى قيمة',
    'assets.stats.latest': 'آخر إضافة',

    'branchs.table.name': 'اسم الفرع',
    'branchs.table.address': 'العنوان',
    'branchs.table.phone': 'رقم التليفون',
    'branchs.table.whatsapp': 'رقم الواتساب',
    'branchs.table.email': 'البريد الإلكتروني',
    'branchs.table.notes': 'ملاحظات',
    'branchs.table.actions': 'العمليات',
    'branchs.button.add': 'إضافة فرع',
    'branchs.modal.title': 'إعدادت الفروع',
    'branchs.confirm.deleteTitle': 'حذف فرع',
    'branchs.confirm.deleteMessage': 'هل تريد حذف هذا الفرع؟',
    'branchs.form.name.label': 'اسم الفرع',
    'branchs.form.name.placeholder': 'ادخل اسم الفرع',
    'branchs.form.name.required': 'من فضلك ادخل اسم الفرع',
    'branchs.form.address.label': 'العنوان',
    'branchs.form.address.placeholder': 'ادخل العنوان',
    'branchs.form.address.max': 'يجب ألا يتجاوز العنوان 500 حرف',
    'branchs.form.phone.label': 'رقم التليفون',
    'branchs.form.phone.placeholder': 'ادخل رقم التليفون',
    'branchs.form.phone.max': 'يجب ألا يتجاوز رقم التليفون 50 حرفًا',
    'branchs.form.whatsapp.label': 'رقم الواتساب',
    'branchs.form.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'branchs.form.whatsapp.max': 'يجب ألا يتجاوز رقم الواتساب 50 حرفًا',
    'branchs.form.email.label': 'البريد الإلكتروني',
    'branchs.form.email.placeholder': 'ادخل البريد الإلكتروني',
    'branchs.form.email.invalid': 'من فضلك ادخل بريدًا إلكترونيًا صحيحًا',
    'branchs.form.notes.label': 'ملاحظات',
    'branchs.form.notes.placeholder': 'ادخل الملاحظات',
    'branchs.form.notes.max': 'يجب ألا تتجاوز الملاحظات 1000 حرف',
    'branchs.alert.noAccess': 'ليس لديك صلاحية لعرض الفروع.',

    'deliveryCenters.table.name': 'اسم المركز',
    'deliveryCenters.table.address': 'العنوان',
    'deliveryCenters.table.phone': 'رقم التليفون',
    'deliveryCenters.table.whatsapp': 'رقم الواتساب',
    'deliveryCenters.table.email': 'البريد الإلكتروني',
    'deliveryCenters.table.client': 'العميل المعين',
    'deliveryCenters.table.noClient': 'لا يوجد عميل معين',
    'deliveryCenters.table.actions': 'العمليات',
    'deliveryCenters.button.add': 'إضافة مركز توصيل',
    'deliveryCenters.modal.title': 'مراكز التوصيل',
    'deliveryCenters.confirm.deleteTitle': 'حذف مركز توصيل',
    'deliveryCenters.confirm.deleteMessage': 'هل تريد حذف هذا المركز؟',
    'deliveryCenters.form.address.max': 'يجب ألا يتجاوز العنوان 500 حرف',
    'deliveryCenters.form.phone.max': 'يجب ألا يتجاوز رقم التليفون 50 حرفًا',
    'deliveryCenters.form.whatsapp.max': 'يجب ألا يتجاوز رقم الواتساب 50 حرفًا',
    'deliveryCenters.form.notes.max': 'يجب ألا تتجاوز الملاحظات 1000 حرف',
    'deliveryCenters.form.client.label': 'العميل',
    'deliveryCenters.form.client.placeholder': 'اختر العميل',
    'deliveryCenters.form.client.required': 'من فضلك اختر العميل',
    'deliveryCenters.alert.noAccess': 'ليس لديك صلاحية لعرض مراكز التوصيل.',
    'responses.delivery_center.updated': 'تم تحديث مركز التوصيل بنجاح',

    'clients.alert.noAccess': 'ليس لديك صلاحية لعرض العملاء.',
    'clients.table.name': 'اسم العميل',
    'clients.table.type': 'نوع العميل',
    'clients.table.phone': 'رقم التليفون',
    'clients.table.whatsapp': 'رقم الواتساب',
    'clients.table.email': 'البريد الإلكتروني',
    'clients.table.dentists': 'الأطباء المسؤولون ',
    'clients.table.noDentists': 'لا يوجد أطباء معينون',
    'clients.table.noLabContacts': 'لا توجد جهات اتصال مختبر معينة',
    'clients.table.deliveryCenters': 'مراكز التسليم',
    'clients.table.noDeliveryCenters': 'لا توجد مراكز تسليم معينة',
    'clients.table.actions': 'العمليات',
    'clients.formulaTypePrices.button': 'أسعار أنواع الصيغ',
    'clients.formulaTypePrices.title': 'أسعار أنواع الصيغ لـ',
    'clients.formulaTypePrices.help': 'حدد سعر الوحدة المخصص لكل نوع صيغة لهذا العميل. اتركه فارغًا لاستخدام سعر البيع الافتراضي.',
    'clients.formulaTypePrices.formulaType': 'نوع التركيبة',
    'clients.formulaTypePrices.defaultPrice': 'السعر الافتراضي',
    'clients.formulaTypePrices.customPrice': 'سعر الوحدة المخصص',
    'clients.formulaTypePrices.noChanges': 'لا توجد تغييرات للحفظ',
    'clients.tabs.dentists': 'الأطباء',
    'clients.tabs.labContacts': 'جهات اتصال المختبر',
    'clients.tabs.customPrices': 'الأسعار المخصصة',
    'clients.accountStatement.positions': 'المواضع',
    'clients.button.add': 'إضافة عميل',
    'clients.modal.title': 'العملاء',
    'clients.confirm.deleteTitle': 'حذف عميل',
    'clients.confirm.deleteMessage': 'هل تريد حذف هذا العميل؟',
    'clients.form.name.label': 'اسم العميل',
    'clients.form.name.placeholder': 'اسم العميل',
    'clients.form.name.required': 'من فضلك ادخل اسم العميل',
    'clients.form.name.max': 'يجب ألا يزيد الاسم عن 255 حرفًا',
    'clients.form.type.label': 'نوع العميل',
    'clients.form.type.placeholder': 'اختر نوع العميل',
    'clients.filter.type.placeholder': 'نوع العميل',
    'clients.form.type.required': 'من فضلك اختر نوع العميل',
    'clients.form.type.options.clinic': 'عيادة',
    'clients.form.type.options.hospital': 'مستشفى',
    'clients.form.type.options.lab': 'معمل',
    'clients.form.search.placeholder': 'ابحث بالاسم أو البريد أو الهاتف',
    'clients.form.phone.label': 'رقم الهاتف',
    'clients.form.phone.placeholder': 'ادخل رقم الهاتف',
    'clients.form.phone.max': 'يجب ألا يتجاوز رقم التليفون 50 حرفًا',
    'clients.form.whatsapp.label': 'رقم الواتساب',
    'clients.form.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'clients.form.whatsapp.max': 'يجب ألا يتجاوز رقم الواتساب 50 حرفًا',
    'clients.form.email.label': 'البريد الإلكتروني',
    'clients.form.email.placeholder': 'ادخل البريد الإلكتروني',
    'clients.form.email.invalid': 'من فضلك ادخل بريدًا إلكترونيًا صحيحًا',
    'clients.form.dentists.label': 'الأطباء',
    'clients.form.dentists.placeholder': 'اختر الأطباء',
    'clients.form.dentists.empty': 'لا يوجد أطباء متاحون',
    'clients.form.dentists.labelLab': 'جهات اتصال المختبر',
    'clients.form.dentists.placeholderLab': 'اختر جهات اتصال المختبر',
    'clients.form.dentists.emptyLab': 'لا توجد جهات اتصال مختبر متاحة',
    'clients.form.deliveryCenters.label': 'مراكز التسليم',
    'clients.form.deliveryCenters.placeholder': 'اختر أو أضف مراكز التسليم',
    'clients.form.deliveryCenters.empty': 'لا توجد مراكز تسليم متاحة',
    'clients.form.submit.createThenContacts': 'إنشاء العميل ثم إضافة جهات الاتصال',
    'clients.form.submit.createWithContacts': 'إنشاء العميل مع جهات الاتصال',
    'clients.form.contactMode.label': 'جهات الاتصال لهذا العميل',
    'clients.form.contactMode.required': 'من فضلك اختر طريقة إضافة جهات الاتصال',
    'clients.form.contactMode.mirror': 'إنشاء طبيب بنفس بيانات العميل',
    'clients.form.contactMode.mirrorLab': 'إنشاء جهة اتصال مختبر بنفس بيانات العميل',
    'clients.form.contactMode.mirrorHelp': 'مناسب عندما يكون للعيادة/المستشفى طبيب واحد — يتم نسخ الاسم والهاتف والواتساب والبريد من العميل.',
    'clients.form.contactMode.mirrorHelpLab': 'مناسب عندما يكون للمعمل جهة اتصال واحدة — يتم نسخ الاسم والهاتف والواتساب والبريد من العميل.',
    'clients.form.contactMode.list': 'إضافة عدة أطباء',
    'clients.form.contactMode.listLab': 'إضافة عدة جهات اتصال مختبر',
    'clients.form.contactMode.listHelp': 'سيتم توسيع هذا النموذج لإضافة طبيب أو أكثر الآن، ثم إنشاء الكل معًا.',
    'clients.form.contactMode.listHelpLab': 'سيتم توسيع هذا النموذج لإضافة جهة اتصال أو أكثر الآن، ثم إنشاء الكل معًا.',
    'clients.form.contactMode.dentistTypeMissing': 'نوع مستخدم الطبيب غير متاح. حدّث الصفحة وحاول مرة أخرى.',
    'clients.form.mirror.sectionTitle': 'بيانات دخول الطبيب',
    'clients.form.mirror.sectionTitleLab': 'بيانات دخول جهة اتصال المختبر',
    'clients.form.mirror.hint': 'يتم أخذ الاسم والهاتف والواتساب والبريد من العميل. البريد الإلكتروني واسم المستخدم اختياريان.',
    'clients.form.mirror.createFailed': 'تم إنشاء العميل، لكن تعذر إنشاء الطبيب. يمكنك إضافتهم من صفحة العميل.',
    'clients.form.mirror.createFailedLab': 'تم إنشاء العميل، لكن تعذر إنشاء جهة اتصال المختبر. يمكنك الإضافة من صفحة العميل.',
    'clients.form.list.sectionTitle': 'الأطباء',
    'clients.form.list.sectionTitleLab': 'جهات اتصال المختبر',
    'clients.form.list.clientCreated': 'تم إنشاء العميل "{{name}}"',
    'clients.form.list.stepTitle': 'إضافة أطباء — {{name}}',
    'clients.form.list.stepTitleLab': 'إضافة جهات اتصال مختبر — {{name}}',
    'clients.form.list.stepHelp': 'أضف طبيبًا أو أكثر لهذا العميل. يمكنك التخطي وإضافتهم لاحقًا.',
    'clients.form.list.stepHelpLab': 'أضف جهة اتصال أو أكثر لهذا العميل. يمكنك التخطي وإضافتهم لاحقًا.',
    'clients.form.list.addAnother': 'إضافة طبيب آخر',
    'clients.form.list.addAnotherLab': 'إضافة جهة اتصال أخرى',
    'clients.form.list.saveContacts': 'حفظ الأطباء',
    'clients.form.list.saveContactsLab': 'حفظ جهات اتصال المختبر',
    'clients.form.list.createFailed': 'تم إنشاء العميل، لكن تعذر إنشاء بعض الأطباء. يمكنك إضافتهم من صفحة العميل.',
    'clients.form.list.createFailedLab': 'تم إنشاء العميل، لكن تعذر إنشاء بعض جهات الاتصال. يمكنك إضافتهم من صفحة العميل.',
    'clients.form.list.done': 'تم',
    'clients.type.clinic': 'عيادة',
    'clients.type.hospital': 'مستشفى',
    'clients.type.lab': 'معمل',
    'clients.totalOrdersAmount': 'إجمالي مبالغ الطلبات',
    'clients.totalOrdersPaidAmount': 'إجمالي مبالغ الطلبات المدفوعة',
    'clients.totalDueOrdersAmount': 'إجمالي مبالغ الطلبات المستحقة',
    'clients.wallet.title': 'محفظة العميل',
    'clients.wallet.balance': 'الرصيد',
    'clients.wallet.recharge': 'إعادة الشحن',
    'clients.wallet.amount': 'المبلغ',
    'clients.wallet.amountPlaceholder': 'أدخل المبلغ',
    'clients.wallet.notes': 'ملاحظات',
    'clients.wallet.notesPlaceholder': 'ملاحظات اختيارية لعملية الشحن',
    'clients.wallet.rechargeSuccess': 'تم شحن المحفظة بنجاح',
    'clients.wallet.rechargeError': 'فشل في شحن المحفظة',
    'clients.wallet.amountRequired': 'المبلغ مطلوب',
    'clients.wallet.amountMin': 'يجب أن يكون المبلغ 0.01 على الأقل',
    'clients.wallet.paymentMethod': 'طريقة الدفع',
    'clients.wallet.paymentMethodPlaceholder': 'اختر طريقة الدفع',
    'clients.wallet.attachments': 'المرفقات',
    'clients.wallet.uploadImage': 'رفع صورة',
    'clients.wallet.history': 'سجل المحفظة',
    'clients.wallet.historyDate': 'التاريخ',
    'clients.wallet.transactionType': 'النوع',
    'sidebar.clients': 'العملاء',
    'sidebar.wallets': 'المحافظ',
    'wallets.title': 'المحافظ',
    'wallets.column.walletId': 'رقم المحفظة',
    'wallets.column.clientName': 'اسم العميل',
    'wallets.column.balance': 'الرصيد',
    'wallets.viewTitle': 'المحفظة #{{id}}',
    'wallets.backToList': 'العودة إلى المحافظ',
    'wallets.openClient': 'إعدادت العميل',
    'wallets.walletIdLabel': 'رقم المحفظة',
    'wallets.alert.noAccess': 'ليس لديك صلاحية لعرض المحافظ.',

    'colors.table.name': 'اللون',
    'colors.table.actions': 'العمليات',
    'colors.button.add': 'إضافة لون',
    'colors.modal.title': 'الألوان',
    'colors.confirm.deleteTitle': 'حذف لون',
    'colors.confirm.deleteMessage': 'هل تريد حذف هذا اللون؟',
    'colors.search.placeholder': 'بحث باسم اللون',
    'colors.form.code.placeholder': 'ادخل الكود',
    'colors.form.preview.label': 'معاينة لون السن',
    'colors.alert.noAccess': 'ليس لديك صلاحية لعرض الألوان.',

    'dentists.label.singular': 'طبيب أسنان',
    'dentists.label.singular.lab': 'جهة اتصال المختبر',
    'dentists.label.plural': 'الأطباء',
    'dentists.label.plural.lab': 'جهات اتصال المختبر',
    'dentists.table.name': 'اسم الطبيب',
    'dentists.table.username': 'اسم المستخدم',
    'dentists.table.email': 'البريد الإلكتروني',
    'dentists.table.address': 'العنوان',
    'dentists.table.phone': 'رقم التليفون',
    'dentists.table.whatsapp': 'رقم الواتساب',
    'dentists.table.client': 'العميل',
    'dentists.table.noClient': 'بدون عميل',
    'dentists.table.actions': 'العمليات',
    'dentists.button.add': 'إضافة طبيب',
    'dentists.button.addLabContact': 'إضافة جهة اتصال مختبر',
    'dentists.modal.title': 'الأطباء',
    'dentists.modal.titleLabContact': 'جهات اتصال المختبر',
    'dentists.confirm.deleteTitle': 'حذف طبيب',
    'dentists.confirm.deleteMessage': 'هل تريد حذف هذا الطبيب؟',
    'dentists.confirm.removeTitle': 'إزالة الطبيب',
    'dentists.confirm.removeMessage': 'سيتم فصل هذا الطبيب عن هذا العميل وإلغاء تفعيله.',
    'dentists.confirm.deleteTitleLabContact': 'حذف جهة اتصال المختبر',
    'dentists.confirm.deleteMessageLabContact': 'هل تريد حذف جهة اتصال المختبر هذه؟',
    'dentists.confirm.removeTitleLabContact': 'إزالة جهة اتصال المختبر',
    'dentists.confirm.removeMessageLabContact': 'سيتم فصل جهة اتصال المختبر عن هذا العميل وإلغاء تفعيلها.',
    'dentists.form.client.label': 'العميل',
    'dentists.form.client.placeholder': 'اختر أو أضف عميلًا',
    'dentists.alert.noAccess': 'ليس لديك صلاحية لعرض الأطباء.',
    'dentists.alert.noDentistType': 'نوع مستخدم الطبيب غير متوفر، يرجى مراجعة الإعدادات.',
    'dentists.changeHistory': 'سجل التغييرات',
    'dentists.versions.title': 'سجل تغييرات الطبيب',
    'dentists.versions.empty': 'لا يوجد سجل تغييرات حتى الآن',
    'dentists.versions.timelineTitle': 'الخط الزمني',
    'dentists.versions.by': 'تم التحديث بواسطة',
    'dentists.versions.fieldsChanged': 'عدد الحقول المتغيرة',
    'dentists.versions.compareTitle': 'مقارنة مع الحالة الحالية',
    'dentists.versions.selectVersion': 'اختر إصدارًا',
    'dentists.versions.noFields': 'لا توجد حقول تغيّرت',
    'dentists.versions.before': 'قبل',
    'dentists.versions.after': 'بعد (الحالية)',

    'expenses.table.expenseType': 'بند المصروفات',
    'expenses.table.cost': 'التكلفة',
    'expenses.table.date': 'التاريخ',
    'expenses.table.notes': 'ملاحظات',
    'expenses.table.assignedUser': 'مُعيَّن إلى',
    'expenses.table.actions': 'العمليات',
    'expenses.button.add': 'إضافة مصروف',
    'expenses.modal.title': 'إعدادت المصروفات',
    'expenses.confirm.deleteTitle': 'حذف مصروف',
    'expenses.confirm.deleteMessage': 'هل تريد حذف هذا المصروف؟',
    'expenses.form.type.label': 'بند المصروفات',
    'expenses.form.expense_type_id': 'نوع المصروف',
    'expenses.form.type.placeholder': 'اختر بند المصروفات',
    'expenses.form.type.required': 'من فضلك اختر بند المصروفات',
    'expenses.form.cost.label': 'التكلفة',
    'expenses.form.cost.placeholder': '٠',
    'expenses.form.cost.required': 'من فضلك ادخل التكلفة',
    'expenses.form.notes.label': 'ملاحظات',
    'expenses.form.notes.placeholder': 'ادخل الملاحظات',
    'expenses.form.assignedUser.label': 'المستخدم المعيّن',
    'expenses.form.assignedUser.placeholder': 'اختر مندوب توصيل أو فني أو مسؤول',
    'expenses.form.assignedUser.unassigned': 'غير معيّن',
    'expenses.filter.assignedUser.placeholder': 'تصفية حسب المستخدم المعيّن',
    'expenses.search.notesPlaceholder': 'ابحث بالملاحظات',
    'expenses.alert.noAccess': 'ليس لديك صلاحية لعرض المصروفات.',
    'expenses.header.title': 'المصروفات',
    'expenses.header.subtitle': 'تسجيل مصروفات المعمل والمدفوعات والتكاليف التشغيلية',
    'expenses.stats.total': 'عدد المصروفات',
    'expenses.stats.average': 'المتوسط {amount}',
    'expenses.stats.totalAmount': 'إجمالي المصروف',
    'expenses.stats.thisMonth': 'هذا الشهر',
    'expenses.stats.topType': 'أعلى بند مصروف',
    'expenses.stats.paidToUsers': 'مدفوع للموظفين',

    'expenseTypes.table.name': 'اسم البند',
    'expenseTypes.table.description': 'الوصف',
    'expenseTypes.table.actions': 'العمليات',
    'expenseTypes.button.add': 'إضافة بند مصروف',
    'expenseTypes.modal.title': 'إعدادت بنود المصروفات',
    'expenseTypes.confirm.deleteTitle': 'حذف بند',
    'expenseTypes.confirm.deleteMessage': 'هل تريد حذف هذا البند؟',
    'expenseTypes.form.name.label': 'اسم البند',
    'expenseTypes.form.name.placeholder': 'ادخل اسم البند',
    'expenseTypes.form.name.required': 'من فضلك ادخل اسم البند',
    'expenseTypes.form.description.label': 'وصف البند',
    'expenseTypes.form.description.placeholder': 'ادخل وصف البند',
    'expenseTypes.search.namePlaceholder': 'ابحث بالاسم',
    'expenseTypes.search.descriptionPlaceholder': 'ابحث بالوصف',
    'expenseTypes.alert.noAccess': 'ليس لديك صلاحية لعرض بنود المصروفات.',

    'orders.header.title': 'الطلبات',
    'orders.header.subtitle': 'متابعة طلبات المعمل ومراحل الإنتاج وجداول التسليم',
    'orders.stats.total': 'إجمالي الطلبات',
    'orders.stats.totalSubtitle': '{completed} مكتمل · {cancelled} ملغي',
    'orders.stats.amount': 'إجمالي قيمة الطلبات',
    'orders.stats.amountSubtitle': 'بدون الطلبات الملغاة',
    'orders.stats.paid': 'الطلبات المدفوعة',
    'orders.stats.paidSubtitle': '{count} طلب مدفوع',
    'orders.stats.unpaid': 'الطلبات غير المدفوعة',
    'orders.stats.unpaidSubtitle': '{count} طلب غير مدفوع',
    'orders.stats.active': 'قيد التنفيذ',
    'orders.stats.activeSubtitle': '{count} مستحق اليوم',
    'orders.stats.overdue': 'متأخرة',
    'orders.stats.overdueSubtitle': 'تجاوزت موعد التسليم',
    'orders.stats.uninvoiced': 'بدون فاتورة',
    'orders.stats.uninvoicedSubtitle': 'بانتظار إصدار فاتورة',
    'orders.search.placeholder': 'بحث باسم المريض أو رقم الطلب أو المرجع',
    'orders.filter.title': 'تصفية الطلبات',
    'orders.filter.clear': 'إعادة تعيين',
    'orders.filter.active': 'مفعل',
    'orders.filter.client': 'العميل',
    'orders.filter.dentist': 'الطبيب',
    'orders.filter.technicians': 'الفنيين',
    'orders.filter.courier': 'المندوب',
    'orders.filter.formulaType': 'نوع التركيبة',
    'orders.table.refresh': 'تحديث',
    'orders.table.notInvoiced': 'غير مفوتر',
    'orders.table.id': 'رقم الطلب',
    'orders.table.patientName': 'اسم المريض',
    'orders.table.client': 'العميل',
    'orders.table.invoice': 'الفاتورة',
    'orders.table.dentistName': 'الطبيب',
    'orders.table.color': 'اللون',
    'orders.table.formulaType': 'نوع المادة',
    'orders.table.total': 'إجمالي التكلفة',
    'orders.table.paid': 'المدفوع',
    'orders.table.remaining': 'المتبقي',
    'orders.table.paymentStatus': 'حالة الدفع',
    'orders.table.status': 'حالة الطلب',
    'orders.table.delivery': 'التوصيل',
    'orders.table.createdAt': 'تاريخ التسجيل',
    'orders.table.requestedAt': 'تاريخ الطلب',
    'orders.table.deliveredAt': 'تم التسليم',
    'orders.table.units': 'عدد الوحدات',
    'orders.table.actions': 'العمليات',
    'orders.table.technician': 'الفني',
    'orders.table.courier': 'المندوب',
    'orders.status.delivered': 'تم التوصيل',
    'orders.status.pendingDelivery': 'لم يتم التوصيل',
    'orders.status.paid': 'مدفوع',
    'orders.status.unpaid': 'غيرمدفوع',
    'orders.status.unknown': 'غير محدد',
    'orders.form.patientName.label': 'اسم المريض',
    'orders.form.patientName.placeholder': 'ادخل اسم المريض',
    'orders.form.patientName.required': 'من فضلك ادخال اسم المريض',
    'orders.form.dentist.label': 'اسم الطبيب',
    'orders.form.dentist.placeholder': 'اختر أو أضف طبيبًا',
    'orders.form.dentist.required': 'من فضلك اختر الطبيب',
    'orders.form.dentist.clientRequired': 'من فضلك اختر العميل أولاً لاختيار الطبيب.',
    'orders.form.dentist.labelLabContact': 'جهة اتصال المختبر',
    'orders.form.dentist.placeholderLabContact': 'اختر أو أضف جهة اتصال مختبر',
    'orders.form.dentist.requiredLabContact': 'من فضلك اختر جهة اتصال المختبر',
    'orders.form.dentist.clientRequiredLabContact': 'من فضلك اختر العميل أولاً لاختيار جهة اتصال المختبر.',
    'orders.form.client.label': 'اختر العميل',
    'orders.form.client.placeholder': 'اختر أو أضف عميلًا',
    'orders.form.client.required': 'من فضلك اختر العميل',
    'orders.form.color.label': 'اختار اللون',
    'orders.form.color.defaultLabel': 'اللون الافتراضي (لل وحدات الجديدة)',
    'orders.form.color.defaultHelp': 'يُطبق عند إضافة وحدة جديدة',
    'orders.form.color.placeholder': 'اختر أو أضف لونًا',
    'orders.form.color.required': 'من فضلك اختر اللون',
    'orders.form.unitColors.label': 'لون لكل وحدة',
    'orders.form.formulaType.defaultLabel': 'المادة الافتراضية (لل وحدات الجديدة)',
    'orders.form.formulaType.defaultHelp': 'تطبق عند إضافة وحدة جديدة',
    'orders.form.unitFormulaTypes.label': 'نوع التركيبة لكل وحدة',
    'orders.form.unitPriceOverride.placeholder': 'تخصيص سعر الوحدة',
    'orders.form.formulaType.label': 'اختار مادة التركيب',
    'orders.form.formulaType.placeholder': 'اختر المادة',
    'orders.form.formulaType.required': 'من فضلك اختر مادة التركيب',
    'orders.form.requestedAt.label': 'تاريخ الطلب',
    'orders.form.requestedAt.placeholder': 'اختر التاريخ',
    'orders.form.issueDate.label': 'تاريخ الإصدار',
    'orders.form.issueDate.placeholder': 'اختر التاريخ',
    'orders.form.deliveryDate.label': 'تاريخ التسليم',
    'orders.form.deliveryDate.placeholder': 'اختر التاريخ',
    'orders.form.additionalCostItems.title': 'بنود تكلفة إضافية',
    'orders.form.additionalCostItems.labelPlaceholder': 'وصف البند',
    'orders.form.additionalCostItems.amountPlaceholder': 'التكلفة',
    'orders.form.additionalCostItems.add': 'إضافة بند تكلفة',
    'orders.form.additionalCostItems.remove': 'حذف',
    'orders.form.additionalCostItems.labelRequired': 'أدخل وصف البند',
    'orders.form.additionalCostItems.amountRequired': 'أدخل مبلغ التكلفة',
    'orders.summary.additionalCostsTitle': 'تكاليف إضافية',
    'orders.summary.additionalCostItemFallback': 'بند إضافي',
    'orders.summary.additionalCosts': 'إجمالي التكاليف الإضافية',
    'orders.form.notes.label': 'ملاحظات',
    'orders.form.notes.placeholder': 'ملاحظات',
    'orders.form.technician.label': 'الفنيين',
    'orders.form.technician.placeholder': 'اختر فنيين',
    'orders.form.technician.required': 'من فضلك اختر فنيًا واحدًا على الأقل',
    'orders.form.selectUnits.label': 'اختر الوحدات',
    'orders.form.selectUnits.required': 'من فضلك اختر وحدة واحدة على الأقل',
    'orders.form.orderFormulas.title': 'صيغ الطلب',
    'orders.form.orderFormulas.help': 'يمكن أن يتضمن الطلب عدة صيغ. في كل سطر، اختر أولًا نوع التركيبة ثم الوحدات (الأسنان لنطاق الوحدة، أو الفك العلوي و/أو السفلي لنطاق الفك). تُعرض فقط أنواع الوحدات المطابقة لنوع التركيبة.',
    'orders.form.orderFormulas.lineTitle': 'صيغة {{n}}',
    'orders.form.orderFormulas.formulaNumber': 'رقم التركيبة',
    'orders.form.orderFormulas.fdi': 'FDI',
    'orders.form.orderFormulas.stepFormulaType': 'الخطوة 1: نوع التركيبة',
    'orders.form.orderFormulas.colorLabel': 'اللون (لهذه التركيبة)',
    'orders.form.orderFormulas.stepUnits': 'الخطوة 2: الوحدات',
    'orders.form.orderFormulas.formulaTypePlaceholder': 'اختر نوع التركيبة أولًا',
    'orders.form.orderFormulas.addLine': 'إضافة صيغة أخرى',
    'orders.form.orderFormulas.formulaType': 'نوع التركيبة',
    'orders.form.orderFormulas.selectUnits': 'الأسنان / الوحدات',
    'orders.form.orderFormulas.archChoice': 'الفك',
    'orders.form.orderFormulas.archUpper': 'الفك العلوي',
    'orders.form.orderFormulas.archLower': 'الفك السفلي',
    'orders.form.orderFormulas.pickTypeFirst': 'اختر نوع التركيبة لتحميل الوحدات المطابقة.',
    'orders.form.orderFormulas.required': 'أضف سطر صيغة واحد على الأقل مع النوع والوحدات المختارة.',
    'orders.form.orderFormulas.incompleteLine': 'يجب أن يتضمن كل سطر صيغة مع نوع مختار وحدة واحدة على الأقل (سن أو فك).',
    'orders.form.orderFormulas.duplicateFormulaType': 'يمكنك إضافة سطر واحد فقط لكل نوع صيغة في الطلب.',
    'orders.form.orderFormulas.perUnitFormulaRequired': 'يجب أن يكون لكل وحدة مختارة نوع صيغة قبل الحفظ.',
    'orders.form.orderFormulas.summaryUnits': 'وحدات هذا الطلب',
    'orders.form.persistedFormulas.title': 'صيغ هذا الطلب',
    'orders.form.persistedFormulas.help': 'كل سطر هو صيغة محفوظة (النوع، الوحدة، واللون). عند التعديل يمكن ضبط نوع التركيبة والأسعار لكل وحدة من الملخص.',
    'orders.form.persistedFormulas.unit': 'الوحدة (FDI)',
    'orders.form.persistedFormulas.color': 'اللون',
    'orders.form.persistedFormulas.detach': 'إزالة من الطلب',
    'orders.form.persistedFormulas.detachConfirm': 'إزالة سطر التركيبة هذا من الطلب؟ ستفقد الأسنان المرتبطة هذه التركيبة حتى تضيف سطرًا جديدًا أو تضبط الأنواع من الملخص.',
    'orders.form.persistedFormulas.detachSuccess': 'تمت إزالة سطر التركيبة من الطلب.',
    'orders.form.persistedFormulas.detachError': 'تعذرت إزالة سطر التركيبة. حاول مرة أخرى.',
    'orders.form.toothPreview.title': 'معاينة الأسنان',
    'orders.form.toothPreview.help': 'نفس مخطط الأسنان كما في إنشاء الطلب. عند التعديل، انقر الأسنان لتغيير الاختيار ثم احفظ.',
    'toothPicker.selectUpper': 'اختيار الفك العلوي',
    'toothPicker.selectLower': 'اختيار الفك السفلي',
    'toothPicker.clear': 'مسح',
    'orders.form.deliveryCenter.label': 'مركز التسليم',
    'orders.form.deliveryCenter.placeholder': 'اختر أو أضف مركز تسليم',
    'orders.form.deliveryCenter.required': 'من فضلك اختر مركز تسليم',
    'orders.form.deliveryCenter.clientRequired': 'من فضلك اختر العميل أولاً لاختيار مركز التسليم.',
    'orders.form.deliveryType.label': 'نوع التوصيل',
    'orders.form.deliveryType.placeholder': 'اختر نوع التوصيل',
    'orders.form.attachment.label': 'مرفقات',
    'orders.form.attachments.label': 'المرفقات',
    'orders.form.attachments.hint': 'يمكنك رفع إعدادت مضغوط Zip أو عدة ملفات غير مضغوطة بالصيغ: *.stl و *.ply و *.obj و *.zip و *.pdf وجميع أنواع الصور والفيديو (بحد أقصى 20 ميجابايت لكل إعدادت).',
    'orders.form.attachments.choose': 'اختر ملفات',
    'orders.form.attachments.existing': 'المرفقات الموجودة:',
    'orders.form.attachments.deleteConfirm': 'حذف المرفق؟',
    'orders.files.title': 'إدارة الملفات',
    'orders.files.expand': 'توسيع',
    'orders.files.collapse': 'طي',
    'orders.files.dropzone': 'انقر أو اسحب الملفات هنا لرفعها',
    'orders.files.hint': '* يمكنك رفع ملف مضغوط Zip أو عدة ملفات غير مضغوطة بالصيغ: *.stl و *.ply و *.obj و *.zip و *.pdf وجميع أنواع الصور والفيديو (بحد أقصى 20 ميجابايت لكل ملف).',
    'orders.files.queueTitle': 'قائمة الملفات',
    'orders.files.queueLength': 'عدد الملفات في الانتظار: {{count}}',
    'orders.files.searchPlaceholder': 'ابحث باسم الملف أو التعليق',
    'orders.files.col.name': 'اسم الملف',
    'orders.files.col.uploadDate': 'تاريخ الرفع',
    'orders.files.col.size': 'الحجم',
    'orders.files.col.progress': 'التقدم',
    'orders.files.col.actions': 'الإجراءات',
    'orders.files.comment': 'تعليق',
    'orders.files.editTitle': 'تعديل الملف',
    'orders.files.downloadAll': 'تنزيل الكل',
    'orders.files.total': 'الإجمالي: {{count}}',
    'orders.files.empty': 'لم يتم رفع أي ملفات بعد',
    'orders.files.noComment': 'لا يوجد تعليق',
    'orders.files.status.queued': 'في الانتظار',
    'orders.files.status.failed': 'فشل',
    'orders.files.retry': 'إعادة المحاولة',
    'orders.files.cancel': 'إلغاء الرفع',
    'orders.files.remove': 'إزالة من القائمة',
    'orders.files.preview': 'معاينة',
    'orders.files.download': 'تنزيل',
    'orders.files.edit': 'تعديل',
    'orders.files.delete': 'حذف',
    'orders.files.deleteConfirm': 'حذف هذا الملف؟',
    'orders.files.invalidType': '{{name}}: نوع الملف غير مسموح',
    'orders.files.tooLarge': '{{name}}: حجم الملف أكبر من 20 ميجابايت',
    'orders.files.downloadFailed': 'تعذر تنزيل الملف/الملفات',
    'orders.form.submit.create': 'إنشاء طلب',
    'orders.form.submit.save': 'حفظ التغييرات',
    'orders.create.section.primaryTitle': 'تفاصيل الطلب',
    'orders.create.section.secondaryTitle': 'تفاصيل إضافية',
    'orders.create.section.secondaryPlaceholder': 'سيتم إضافة هذا القسم لاحقاً.',
    'orders.update.section.primaryTitle': 'تفاصيل الطلب',
    'orders.update.section.secondaryTitle': 'إجراءات الطلب',
    'orders.update.section.secondaryPlaceholder': 'سيتم عرض تفاصيل إضافية عن الطلب هنا قريبًا.',
    'orders.actions.technician.label': 'الفنيين',
    'orders.actions.technician.unassigned': 'غير معين',
    'orders.actions.technician.change': 'تعيين الفنيين',
    'orders.actions.viewInvoice': 'عرض الفاتورة',
    'orders.actions.technician.select': 'اختر فنيين',
    'orders.actions.technician.changeSuccess': 'تم تحديث الفنيين',
    'orders.actions.technician.changeError': 'فشل تحديث الفنيين',
    'orders.actions.courier.label': 'المندوب',
    'orders.actions.courier.unassigned': 'غير معين',
    'orders.actions.courier.change': 'تعيين المندوب',
    'orders.actions.courier.select': 'اختر المندوب',
    'orders.actions.courier.changeSuccess': 'تم تحديث المندوب',
    'orders.actions.courier.changeError': 'فشل تحديث المندوب',
    'orders.actions.courier.unassign': 'إلغاء التعيين',
    'responses.permission.denied': 'ليس لديك صلاحية لإجراء هذا الإجراء.',
    'responses.common.password_reset_link_sent': 'إذا كان هناك حساب مرتبط بهذا البريد، فقد تم إرسال رابط إعادة تعيين كلمة المرور.',
    'responses.common.password_reset_success': 'تم إعادة تعيين كلمة المرور. يمكنك تسجيل الدخول الآن.',
    'orders.actions.status.label': 'حالة الطلب',
    'orders.actions.status.change': 'تغيير الحالة',
    'orders.actions.status.changeSuccess': 'تم تحديث الحالة',
    'orders.actions.status.changeError': 'فشل تحديث الحالة',
    'orders.actions.status.cannotCancelPaid': 'لا يمكن تغيير الحالة إلى "ملغى" لأن هناك فاتورة مدفوعة مرتبطة بهذا الطلب.',
    'orders.actions.downloadWorkCard': 'تنزيل بطاقة العمل',
    'orders.changeHistory': 'سجل التغييرات',
    'orders.versions.title': 'سجل تغييرات الطلب',
    'orders.versions.empty': 'لا يوجد سجل تغييرات حتى الآن',
    'orders.versions.timelineTitle': 'الخط الزمني',
    'orders.versions.by': 'تم التحديث بواسطة',
    'orders.versions.fieldsChanged': 'عدد الحقول المتغيرة',
    'orders.versions.compareTitle': 'مقارنة مع الحالة الحالية',
    'orders.versions.selectVersion': 'اختر إصدارًا',
    'orders.versions.noFields': 'لا توجد حقول تغيّرت',
    'orders.versions.before': 'قبل',
    'orders.versions.after': 'بعد (الحالية)',
    'orders.versions.unitLabel': 'الوحدة',
    'orders.versions.priceLabel': 'السعر',
    'orders.calendar.title': 'التقويم',
    'orders.calendar.viewList': 'عرض قائمة الطلبات',
    'orders.calendar.more': 'المزيد',
    'orders.calendar.week': 'أسبوع',
    'orders.calendar.month': 'شهر',
    'orders.calendar.year': 'سنة',
    'orders.calendar.ordersCount': 'طلبات',
    'orders.calendar.itemsCount': 'عناصر',
    'orders.calendar.today': 'اليوم',
    'orders.calendar.noOrders': 'لا توجد طلبات',
    'orders.calendar.noItems': 'لا توجد عناصر',
    'orders.calendar.patient': 'المريض',
    'orders.calendar.client': 'العميل',
    'orders.calendar.ref': 'الرقم التسلسلي',
    'orders.calendar.entity.order': 'طلب',
    'orders.calendar.entity.invoice': 'فاتورة',
    'orders.calendar.filter.title': 'عرض في الالتقويم',
    'orders.calendar.filter.orders': 'الطلبات',
    'orders.calendar.filter.invoices': 'الفواتير',
    'orders.calendar.filter.orderDeliveryDate': 'تاريخ التسليم',
    'orders.calendar.filter.orderRequestedAt': 'تاريخ الطلب',
    'orders.calendar.filter.invoiceIssueDate': 'تاريخ الإصدار',
    'orders.calendar.filter.invoiceDueDate': 'تاريخ الاستحقاق',

    // UI labels for work card modal
    'ui.order.work_card': 'بطاقة العمل',
    'ui.order.order_id': 'رقم الطلب',
    'ui.order.client': 'العميل',
    'ui.order.dentist': 'الطبيب',
    'ui.order.patient': 'المريض',
    'ui.order.formula_type': 'المادة',
    'ui.order.formulaType': 'نوع التركيبة',
    'ui.order.color': 'اللون',
    'ui.order.units': 'الوحدات',
    'ui.order.units_positions': 'مواضع الوحدات',
    'ui.order.units_count': 'عدد الوحدات',
    'ui.order.items': 'العناصر',
    'ui.order.unit': 'وحدة',
    'ui.order.no_qr_available': 'لا يوجد QR',
    'ui.order.order_barcode': 'باركود الطلب',
    'ui.order.view_public_note': 'هذه معاينة عامة للطلب. لا يلزم تسجيل دخول.',
    'ui.order.unit_types': 'الوحدات المختارة (حسب الموضع)',
    'ui.order.unit_level': 'المستوى',
    'ui.order.unit_direction': 'الاتجاه',
    'ui.order.unit_order': 'الموضع',
    'ui.order.unit_name': 'النوع',
    'ui.order.tooth_picker': 'محدد الأسنان',
    'ui.order.tooth_previewer': 'عارض الأسنان',
    'ui.order.unit_positions': 'مواضع الوحدات',
    'ui.order.tooth_picker_hint': 'الوحدات المحددة مظللة أدناه',
    'ui.order.note': 'ملاحظة',
    'ui.order.view_title': 'عرض الطلب',
    'ui.order.units_list': 'الوحدات',
    'ui.order.qr': 'QR',
    'ui.order.switch_to_en': 'التبديل إلى الإنجليزية',
    'ui.order.switch_to_ar': 'التبديل إلى العربية',
    'ui.order.lang_en_short': 'EN',
    'ui.order.lang_ar_short': 'ع',

    // Generic language toggler
    'ui.switch_to_en': 'التبديل إلى الإنجليزية',
    'ui.switch_to_ar': 'التبديل إلى العربية',
    'ui.lang_en_short': 'EN',
    'ui.lang_ar_short': 'ع',
    'ui.order.color_hex': 'رمز اللون',
    'ui.copy_link': 'نسخ الرابط',
    'ui.copy_link_copied': 'تم نسخ الرابط',
    'ui.theme.lightMode': 'الوضع الفاتح',
    'ui.theme.darkMode': 'الوضع الداكن',
    'ui.menu.open': 'فتح القائمة',
    'ui.menu.navigation': 'التنقل',
    'ui.date.startDate': 'تاريخ البداية',
    'ui.date.endDate': 'تاريخ النهاية',

    'userTypes.dentist': 'طبيب أسنان',
    'userTypes.lab_contact': 'جهة اتصال المختبر',
    'userTypes.technician': 'فني',
    'userTypes.courier': 'مندوب',
    'userTypes.admin': 'مدير',
    'userTypes.backoffice': 'لوحة الإدارة',

    'deliveryTypes.standard_delivery': 'التوصيل العادي',
    'deliveryTypes.free_delivery': 'التوصيل المجاني',

    'orders.summary.title': 'ملخص الطلب',

    // General UI
    'common.print': 'طباعة',
    'common.openNew': 'فتح في صفحة جديدة',
    'common.copy': 'نسخ',
    'common.copied': 'تم النسخ',
    'common.save': 'حفظ',
    'common.updated': 'تم التحديث',
    'common.active': 'نشط',
    'common.status': 'الحالة',
    'common.inactive': 'غير نشط',
    'orders.summary.itemsLabel': 'العناصر',
    'orders.summary.subtotal': 'المجموع الفرعي',
    'orders.summary.discountDentistFormulaType': 'خصم الطبيب حسب نوع التركيبة',
    'orders.summary.discountClientFormulaType': 'خصم العميل حسب نوع التركيبة',
    'orders.summary.discountUnitOverride': 'خصم تعديل سعر الوحدة',
    'orders.summary.discountOrderAmount': 'خصم الطلب',
    'orders.summary.totalDiscount': 'إجمالي الخصم',
    'orders.actions.createWorkCard': 'بطاقة العمل',
    'orders.actions.workCardCreated': 'تم إنشاء بطاقة العمل',
    'orders.summary.vat': 'الضريبة ({{percent}}%)',
    'orders.summary.delivery': 'تكلفة التوصيل',
    'orders.summary.deliveryCenter': 'مركز التسليم',
    'orders.summary.noDeliveryCenter': 'لا يوجد مركز تسليم',
    'orders.summary.total': 'الإجمالي',
    'orders.summary.noFormulaType': 'لا يوجد نوع صيغة محددة',
    'orders.summary.noFormulaType': 'لا يوجد نوع صيغة محدد',
    'orders.summary.formulaType': 'نوع التركيبة',
    'orders.summary.unitUnknown': 'وحدة',
    'orders.summary.noUnits': 'لا توجد وحدات',
    'orders.summary.color': 'اللون',
    'orders.summary.noColor': '—',
    'orders.summary.unitLabel': 'الوحدة',
    'orders.summary.formulaType': 'المادة',
    'orders.summary.price': 'السعر',
    'orders.summary.formulaLineTitle': 'التركيبة {{n}}',
    'orders.summary.pricePerUnit': 'السعر لكل وحدة',
    'orders.summary.unitsCount': 'عدد الوحدات',
    'orders.summary.formulaLineTotal': 'سعر التركيبة',
    'orders.summary.vatLabel': 'الضريبة',
    'orders.summary.deliveryLabel': 'تكلفة التوصيل',
    'orders.summary.deliveryLabelWithType': 'تكلفة التوصيل ({type})',
    'orders.summary.free': 'مجاني',
    'orders.orderStatus.requested': 'تم الطلب',
    'orders.orderStatus.review': 'قيد المراجعة',
    'orders.orderStatus.tx-review': 'مراجعة الخطة العلاجية',
    'orders.orderStatus.tx-approved': 'تم اعتماد الخطة',
    'orders.orderStatus.tx-replan': 'إعادة التخطيط',
    'orders.orderStatus.in-progress': 'قيد التنفيذ',
    'orders.orderStatus.in-delivery': 'قيد التسليم',
    'orders.orderStatus.delivered': 'تم التسليم',
    'orders.orderStatus.finished': 'مكتمل',
    'orders.orderStatus.cancelled': 'ملغي',
    'orders.orderStatus.dispute': 'نزاع',
    'orders.orderStatus.draft': 'مسودة',
    'orders.orderStatus.pending_review': 'بانتظار المراجعة',
    'orders.orderStatus.under_review': 'قيد المراجعة',
    'orders.orderStatus.more_info_required': 'مطلوب معلومات إضافية',
    'orders.orderStatus.resubmitted': 'أعيد الإرسال',
    'orders.orderStatus.accepted': 'مقبول',
    'orders.orderStatus.rejected': 'مرفوض',
    'orders.orderStatus.queued': 'في قائمة الانتظار',
    'orders.orderStatus.ready_for_design': 'جاهز للتصميم',
    'orders.orderStatus.design_in_progress': 'التصميم قيد التنفيذ',
    'orders.orderStatus.pending_internal_design_review': 'بانتظار المراجعة الداخلية للتصميم',
    'orders.orderStatus.pending_design_approval': 'بانتظار اعتماد التصميم',
    'orders.orderStatus.design_revision_requested': 'مطلوب تعديل التصميم',
    'orders.orderStatus.design_revision_in_progress': 'تعديل التصميم قيد التنفيذ',
    'orders.orderStatus.design_approved': 'تم اعتماد التصميم',
    'orders.orderStatus.design_rejected': 'تم رفض التصميم',
    'orders.orderStatus.ready_for_try_in_production': 'جاهز لتصنيع البروفة',
    'orders.orderStatus.try_in_production_in_progress': 'تصنيع البروفة قيد التنفيذ',
    'orders.orderStatus.try_in_quality_check': 'فحص جودة البروفة',
    'orders.orderStatus.ready_for_try_in': 'جاهز للبروفة',
    'orders.orderStatus.out_for_try_in': 'خرج للبروفة',
    'orders.orderStatus.pending_try_in_feedback': 'بانتظار ملاحظات البروفة',
    'orders.orderStatus.try_in_approved': 'تم اعتماد البروفة',
    'orders.orderStatus.try_in_revision_requested': 'مطلوب تعديل البروفة',
    'orders.orderStatus.try_in_revision_in_progress': 'تعديل البروفة قيد التنفيذ',
    'orders.orderStatus.ready_for_repeat_try_in': 'جاهز لإعادة البروفة',
    'orders.orderStatus.try_in_not_required': 'البروفة غير مطلوبة',
    'orders.orderStatus.in_progress': 'قيد التنفيذ',
    'orders.orderStatus.manufacturing_try_in': 'بروفة التصنيع',
    'orders.orderStatus.ready_for_final_production': 'جاهز للإنتاج النهائي',
    'orders.orderStatus.final_production': 'الإنتاج النهائي',
    'orders.orderStatus.ready_for_final_manufacturing': 'جاهز للتصنيع النهائي',
    'orders.orderStatus.final_manufacturing_in_progress': 'التصنيع النهائي قيد التنفيذ',
    'orders.orderStatus.manufacturing_paused': 'التصنيع متوقف مؤقتًا',
    'orders.orderStatus.pending_external_work': 'بانتظار عمل خارجي',
    'orders.orderStatus.finishing_in_progress': 'التشطيب قيد التنفيذ',
    'orders.orderStatus.quality_control': 'فحص الجودة',
    'orders.orderStatus.quality_control_failed': 'فشل فحص الجودة',
    'orders.orderStatus.rework_in_progress': 'إعادة العمل قيد التنفيذ',
    'orders.orderStatus.quality_control_passed': 'اجتاز فحص الجودة',
    'orders.orderStatus.ready_for_dispatch': 'جاهز للشحن',
    'orders.orderStatus.awaiting_pickup': 'بانتظار الاستلام',
    'orders.orderStatus.out_for_delivery': 'خرج للتوصيل',
    'orders.orderStatus.delivery_attempt_failed': 'فشلت محاولة التوصيل',
    'orders.orderStatus.delivery_disputed': 'نزاع على التسليم',
    'orders.orderStatus.return_requested': 'مطلوب الإرجاع',
    'orders.orderStatus.returned_to_lab': 'أعيد إلى المعمل',
    'orders.orderStatus.pending_closure': 'بانتظار الإغلاق',
    'orders.orderStatus.closed': 'مغلق',
    'orders.orderStatus.on_hold': 'معلق',
    'orders.orderStatus.awaiting_client_action': 'بانتظار إجراء العميل',
    'orders.orderStatus.awaiting_payment': 'بانتظار الدفع',
    'orders.orderStatus.cancel_requested': 'مطلوب الإلغاء',
    'orders.orderStatus.remake_requested': 'مطلوب إعادة التصنيع',
    'orders.orderStatus.remake_approved': 'تمت الموافقة على إعادة التصنيع',
    'orders.orderStatus.remake_in_progress': 'إعادة التصنيع قيد التنفيذ',
    'orders.orderStatus.disputed': 'نزاع',
    'orders.orderStatus.on-hold': 'معلق',
    'orders.paymentStatus.draft': 'مسودة',

    'orders.paymentStatus.unpaid': 'غيرمدفوع',
    'orders.paymentStatus.paid': 'مدفوع',
    'orders.paymentStatus.void': 'ملغى',
    'orders.button.add': 'إضافة طلب',
    'orders.empty.noOrdersYet': 'لا توجد حالات بعد',
    'orders.empty.noneMatchFilters': 'لا توجد حالات تطابق المرشحات الحالية. جرّب تغيير حالة الدفع أو المرشحات الأخرى.',
    'orders.button.cancel': 'إلغاء',
    'orders.confirm.cancelTitle': 'إلغاء الطلب',
    'orders.confirm.cancelMessage': 'هل تريد بالتأكيد إلغاء هذا الطلب؟ سيتم تحويله إلى مسودة وفصله عن الفواتير.',
    'orders.confirm.cancelSuccess': 'تم إلغاء الطلب',
    'orders.confirm.cancelError': 'فشل إلغاء الطلب',
    'orders.button.viewEdit': 'عرض | تعديل',
    'orders.button.view': 'عرض',
    'orders.confirm.deleteTitle': 'حذف حالة',
    'orders.confirm.deleteMessage': 'هل تريد حذف هذه الحالة؟',
    'orders.update.collectPayment': 'تحصيل الحساب',
    'orders.update.refundPayment': 'إرجاع الحساب',
    'orders.update.markDelivered': 'توصيل',
    'orders.update.invoiceButton': 'الفاتورة',
    'orders.alert.noAccess': 'ليس لديك صلاحية لعرض الحالات.',
    'orders.alert.noCreate': 'ليس لديك صلاحية لإضافة حالات.',
    'orders.alert.noView': 'ليس لديك صلاحية لعرض هذه الحالة.',
    'colors.form.name.label': 'اسم اللون',
    'colors.form.name.placeholder': 'ادخل اسم اللون',
    'colors.form.name.required': 'من فضلك ادخل اسم اللون',
    'colors.form.name.max': 'يجب ألا يزيد اسم اللون عن 255 حرفًا',
    'colors.form.code.label': 'رمز اللون',
    'colors.form.code.required': 'اللون مطلوب.',
    'colors.quickCreate.title': 'إضافة لون',
    'colors.quickCreate.button': 'إضافة لون جديد',
    'colors.quickCreate.errorFallback': 'تعذر إضافة اللون، حاول مرة أخرى.',
    'dentists.quickCreate.title': 'إضافة طبيب',
    'dentists.quickCreate.button': 'إضافة طبيب جديد',
    'dentists.quickCreate.errorFallback': 'تعذر إضافة الطبيب، حاول مرة أخرى.',
    'dentists.quickCreate.missingType': 'تعذر تحديد نوع مستخدم الطبيب، يرجى إعادة التحميل والمحاولة.',
    'dentists.quickCreate.titleLabContact': 'إضافة جهة اتصال مختبر',
    'dentists.quickCreate.buttonLabContact': 'إضافة جهة اتصال مختبر جديدة',
    'dentists.quickCreate.errorFallbackLabContact': 'تعذر إضافة جهة اتصال المختبر، حاول مرة أخرى.',
    'dentists.form.name.label': 'اسم الطبيب',
    'dentists.form.name.placeholder': 'ادخل اسم الطبيب',
    'dentists.form.name.required': 'من فضلك ادخل اسم الطبيب',
    'dentists.form.name.labelLabContact': 'اسم جهة اتصال المختبر',
    'dentists.form.name.placeholderLabContact': 'ادخل اسم جهة اتصال المختبر',
    'dentists.form.name.requiredLabContact': 'من فضلك ادخل اسم جهة اتصال المختبر',
    'dentists.form.email.label': 'البريد الإلكتروني',
    'dentists.form.email.placeholder': 'ادخل البريد الإلكتروني',
    'dentists.form.email.required': 'من فضلك ادخل البريد الإلكتروني',
    'dentists.form.email.invalid': 'من فضلك ادخل بريدًا إلكترونيًا صحيحًا',
    'dentists.form.username.label': 'اسم المستخدم',
    'dentists.form.username.placeholder': 'ادخل اسم المستخدم',
    'dentists.form.username.hint': 'مطلوب إذا لم يكن للطبيب بريد إلكتروني',
    'dentists.form.username.optionalHint': 'اختياري. اترك البريد الإلكتروني واسم المستخدم فارغين ليتم إنشاء اسم مستخدم تلقائيًا.',
    'dentists.form.password.label': 'كلمة المرور',
    'dentists.form.password.placeholder': 'ادخل كلمة المرور',
    'dentists.form.password.required': 'من فضلك ادخل كلمة المرور',
    'dentists.form.password.min': 'يجب ألا تقل كلمة المرور عن 6 أحرف',
    'dentists.form.password.tempHint': 'اتركه فارغًا لاستخدام كلمة المرور المؤقتة الافتراضية (temp123)',
    'dentists.form.phone.label': 'رقم الهاتف',
    'dentists.form.phone.placeholder': 'ادخل رقم الهاتف',
    'dentists.form.whatsapp.label': 'رقم الواتساب',
    'dentists.form.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'dentists.form.address.label': 'العنوان',
    'dentists.form.address.placeholder': 'ادخل العنوان',

    // Transactions
    'transactions.table.type': 'النوع',
    'transactions.table.reference': 'المرجع',
    'transactions.table.amount': 'القيمة',
    'transactions.table.notes': 'ملاحظات',
    'transactions.table.createdAt': 'تاريخ الإنشاء',
    'transactions.types.invoice': 'فاتورة',
    'transactions.types.expense': 'مصروف',
    'transactions.types.wallet_recharge': 'شحن المحفظة',
    'transactions.types.wallet': 'المحفظة',
    'transactions.types.wallet_deduction': 'خصم من المحفظة',
    'transactions.types.invoice_refund': 'استرداد الفاتورة',
    'transactions.alert.noAccess': 'ليست لديك صلاحية لعرض المعاملات.',

    'formulaTypes.table.name': 'الاسم',
    'formulaTypes.search.placeholder': 'بحث بالاسم أو الوصف',
    'formulaTypes.filter.unit.placeholder': 'فرز حسب الوحدة أو الفك',
    'formulaTypes.table.cost': 'التكلفة لكل وحدة',
    'formulaTypes.table.description': 'الوصف',
    'formulaTypes.table.actions': 'العمليات',
    'formulaTypes.button.add': 'إضافة مادة',
    'formulaTypes.modal.title': 'إعدادت مواد التركيبات',
    'formulaTypes.confirm.deleteTitle': 'حذف مادة',
    'formulaTypes.confirm.deleteMessage': 'هل تريد حذف هذه المادة؟',
    'formulaTypes.form.name.label': 'اسم المادة',
    'formulaTypes.form.name.placeholder': 'ادخل اسم المادة',
    'formulaTypes.form.name.required': 'من فضلك ادخل اسم المادة',
    'formulaTypes.form.name.max': 'يجب ألا يزيد الاسم عن 255 حرفًا',
    'formulaTypes.form.cost.label': 'التكلفة لكل وحدة',
    'formulaTypes.form.cost.placeholder': '٠',
    'formulaTypes.form.cost.required': 'من فضلك ادخل التكلفة',
    'formulaTypes.form.materialCostPerUnit.label': 'تكلفة الخامة لكل وحدة',
    'formulaTypes.form.materialCostPerUnit.placeholder': '٠',
    'formulaTypes.form.sellingPrice.label': 'سعر البيع للوحدة',
    'formulaTypes.form.sellingPrice.placeholder': '٠',
    'formulaTypes.form.technicianCostPerUnit.label': 'تكلفة الفني لكل وحدة',
    'formulaTypes.form.technicianCostPerUnit.placeholder': '٠',
    'formulaTypes.form.scope.label': 'النطاق',
    'formulaTypes.form.scope.placeholder': 'وحدة أو فك',
    'formulaTypes.scope.unit': 'وحدة',
    'formulaTypes.scope.arch': 'فك',
    'formulaTypes.table.materialCostPerUnit': 'تكلفة الخامة / وحدة',
    'formulaTypes.table.sellingPrice': 'سعر البيع',
    'formulaTypes.table.technicianCostPerUnit': 'تكلفة الفني / وحدة',
    'formulaTypes.table.scope': 'وحدة / فك',
    'formulaTypes.form.description.label': 'وصف المادة',
    'formulaTypes.form.description.placeholder': 'ادخل وصف المادة',
    'formulaTypes.form.attachments.label': 'المرفقات',
    'formulaTypes.form.attachments.hint': 'يمكنك رفع إعدادت مضغوط Zip أو عدة ملفات غير مضغوطة بالصيغ: *.stl و *.ply و *.obj و *.zip و *.pdf وجميع أنواع الصور والفيديو (بحد أقصى 20 ميجابايت لكل إعدادت).',
    'formulaTypes.form.attachments.choose': 'اختر ملفات',
    'formulaTypes.form.attachments.existing': 'المرفقات الموجودة:',
    'formulaTypes.form.attachments.deleteConfirm': 'حذف المرفق؟',
    'formulaTypes.attachment.deleted': 'تم حذف المرفق',
    'formulaTypes.attachment.deleteError': 'فشل حذف المرفق',
    'formulaTypes.quickCreate.title': 'إضافة مادة',
    'formulaTypes.quickCreate.button': 'إضافة مادة جديدة',
    'deliveryCenters.quickCreate.title': 'إضافة مركز تسليم',
    'deliveryCenters.quickCreate.button': 'إضافة مركز تسليم جديد',
    'deliveryCenters.quickCreate.errorFallback': 'تعذر إضافة مركز التسليم، حاول مرة أخرى.',
    'deliveryCenters.form.name.label': 'اسم مركز التسليم',
    'deliveryCenters.form.name.placeholder': 'ادخل اسم مركز التسليم',
    'deliveryCenters.form.name.required': 'من فضلك ادخل اسم مركز التسليم',
    'deliveryCenters.form.address.label': 'العنوان',
    'deliveryCenters.form.address.placeholder': 'ادخل العنوان',
    'deliveryCenters.form.phone.label': 'رقم الهاتف',
    'deliveryCenters.form.phone.placeholder': 'ادخل رقم الهاتف',
    'deliveryCenters.form.whatsapp.label': 'رقم الواتساب',
    'deliveryCenters.form.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'deliveryCenters.form.email.label': 'البريد الإلكتروني',
    'deliveryCenters.form.email.placeholder': 'ادخل البريد الإلكتروني',
    'deliveryCenters.form.email.invalid': 'من فضلك ادخل بريدًا إلكترونيًا صحيحًا',
    'deliveryCenters.form.notes.label': 'ملاحظات',
    'deliveryCenters.form.notes.placeholder': 'أضف ملاحظات (اختياري)',

    'lab.title': 'معلومات المعمل',
    'lab.table.field': 'البيان',
    'lab.table.value': 'القيمة',
    'lab.table.actions': 'إجراءات',
    'lab.table.branches': 'الفروع',
    'lab.delivery.title': 'التوصيل',
    'lab.delivery.col.name': 'الاسم',
    'lab.delivery.col.amount': 'المبلغ',
    'lab.delivery.default': 'افتراضي',
    'lab.delivery.setDefault': 'تعيين كافتراضي',
    'lab.delivery.setDefaultSuccess': 'تم التعيين كافتراضي.',
    'lab.delivery.editValue': 'تغيير القيمة',
    'lab.delivery.editStandardTitle': 'تغيير قيمة التوصيل العادي',
    'lab.delivery.amountForCurrency': 'المبلغ ({currency})',
    'lab.delivery.updateSuccess': 'تم التحديث.',
    'lab.field.name': 'اسم المعمل',
    'lab.field.logo': 'الشعار',
    'lab.field.phone': 'تليفون المعمل',
    'lab.field.contactPhone': 'هاتف التواصل',
    'lab.field.vatPercentage': 'نسبة الضريبة',
    'lab.field.delivery': 'التوصيل',
    'lab.field.currency': 'العملة',
    'lab.field.whatsapp': 'رقم واتساب المعمل',
    'lab.field.notes': 'وصف المعمل',
    'lab.button.edit': 'تعديل',
    'lab.modal.title': 'تعديل بيانات المعمل',
    'lab.form.name.label': 'اسم المعمل',
    'lab.form.name.placeholder': 'ادخل اسم المعمل',
    'lab.form.name.required': 'من فضلك ادخل اسم المعمل',
    'lab.form.phone.label': 'رقم التليفون',
    'lab.form.phone.placeholder': 'ادخل رقم التليفون',
    'lab.form.contactPhone.label': 'هاتف التواصل',
    'lab.form.contactPhone.placeholder': 'ادخل هاتف التواصل',
    'lab.form.vatPercentage.label': 'نسبة الضريبة',
    'lab.form.vatPercentage.placeholder': '٠',
    'lab.form.delivery.label': 'التوصيل',
    'lab.form.delivery.placeholder': '٠',
    'lab.form.currency.label': 'العملة',
    'lab.form.currency.placeholder': 'USD',
    'lab.form.currency.lockedHint': 'لا يمكن تغيير العملة بعد الإعداد.',
    'lab.form.whatsapp.label': 'رقم الواتساب',
    'lab.form.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'lab.form.notes.label': 'وصف المعمل',
    'lab.form.notes.placeholder': 'ادخل وصف المعمل',
    'lab.form.logo.label': 'الشعار (شريط التنقل)',
    'lab.form.logo.hint': 'PNG أو JPG أو GIF أو WebP. بحد أقصى 4 ميجابايت.',
    'lab.form.logo.uploadButton': 'اختر إعدادت الشعار',
    'lab.form.removeLogo': 'إزالة الشعار الحالي',
    'lab.saveSuccess': 'تم حفظ الإعدادات',
    'lab.saveError': 'تعذر حفظ الإعدادات',
    'lab.button.save': 'حفظ',

    'home.currency.egp': 'EGP',
    'home.welcome': 'مرحبا {{labName}},',
    'home.summary': 'ملخص نشاط وأداء المعمل.',
    'home.invoices_amount': 'إجمالي الفواتير',
    'home.paid_invoices': 'الفواتير المدفوعة',
    'home.orders': 'الحالات',
    'home.dentists': 'الأطباء',
    'home.invoices': 'الفواتير',
    'home.unpaid_amount': 'المبالغ غير المدفوعة',
    'home.statistics': 'إحصائيات',
    'home.recent_clinics': 'المختبرات الأعلى',
    'home.activity_overview': 'نظرة عامة على النشاط',
    'home.activity_subtitle': 'نظرة عامة على الحالات والفواتير والإيرادات',
    'home.view_reports': 'عرض التقارير',
    'home.dental_clinic': 'العيادة',
    'home.active_invoices': 'الفواتير النشطة',
    'home.active_expenses': 'المصروفات النشطة',
    'home.invoices_label': 'الفواتير',
    'home.expenses_label': 'المصروفات',
    'home.amount': 'المبلغ',
    'home.count': 'العدد',
    'home.revenue': 'الإيرادات',
    'home.paid_invoices_amount': 'قيمة الفواتير المدفوعة',
    'home.unpaid_invoices_amount': 'قيمة الفواتير غير المدفوعة',
    'home.paid_invoices_count': 'عدد الفواتير المدفوعة',
    'home.unpaid_invoices_count': 'عدد الفواتير غير المدفوعة',
    'home.invoices_count': 'عدد الفواتير',
    'home.clients_count': 'عدد العملاء',
    'home.orders_count': 'عدد الحالات',
    'home.units_count': 'عدد الوحدات',
    'home.expenses_amount': 'إجمالي المصروفات',
    'home.orders_trend': 'اتجاه الحالات',
    'home.revenue_by_month': 'الإيرادات (6 أشهر)',
    'home.invoices_breakdown': 'توزيع الفواتير',
    'home.active_clients': 'العملاء النشطون',
    'home.active_orders': 'الطلبات النشطة',
    'home.active_dentists': 'الأطباء النشطون',
    'home.clients_label': 'العملاء',
    'home.orders_label': 'الطلبات',
    'home.full_period': 'الفترة الكاملة',

    // New home keys
    'home.new_orders': 'طلبات جديدة',
    'home.latest_orders': 'أحدث الطلبات',
    'home.latest_invoices': 'أحدث الفواتير',
    'home.view_all_invoices': 'عرض جميع الفواتير',
    'home.orders_tracker': 'متعقب الطلبات',
    'home.invoices_tracker': 'متعقب الفواتير',
    'home.formula_types_tracker': 'متعقب أنواع التركيبات',
    'home.formula_type': 'نوع التركيبة',
    'home.units_amount': 'مبلغ الوحدات',
    'home.total_units_amount': 'إجمالي مبلغ الوحدات',
    'home.this_week': 'هذا الأسبوع',
    'home.this_month': 'هذا الشهر',
    'home.last_month': 'الشهر الماضي',
    'home.last_3_months': 'آخر 3 أشهر',
    'home.last_6_months': 'آخر 6 أشهر',
    'home.last_year': 'اخر عام',
    'home.custom_range': 'نطاق مخصص',
    'home.revenue_tracker': 'متعقب الإيرادات',
    'home.total_invoices': 'إجمالي الفواتير',
    'home.total_invoices_amount': 'إجمالي قيمة الفواتير',
    'home.total_expenses': 'إجمالي المصروفات',
    'home.net': 'الصافي',
    'home.invoices_vs_expenses': 'الفواتير مقابل المصروفات',
    'home.order': 'طلب',
    'home.client': 'عميل',
    'home.status': 'الحالة',
    'home.date': 'التاريخ',
    'home.total': 'الإجمالي',
    'home.total_orders': 'إجمالي الطلبات',
    'home.requested': 'مطلوب',
    'home.in_progress': 'قيد التنفيذ',
    'home.closed': 'مغلق',
    'home.completed_percentage': 'النسبة المكتملة',
    'home.closed_orders': 'الطلبات المغلقة',
    'home.no_data': 'لا توجد بيانات',
    'home.view_all_orders': 'عرض جميع الطلبات',

    // Profile
    'profile.title': 'الملف الشخصي',
    'profile.error.title': 'تعذر تحميل الملف الشخصي',
    'profile.avatar.upload': 'رفع صورة',
    'profile.avatar.remove': 'إزالة الصورة',
    'profile.avatar.hint': 'PNG أو JPG أو GIF أو WebP. بحد أقصى 4 ميجابايت.',
    'profile.avatar.tooLarge': 'الصورة المرفوعة كبيرة جدًا. يرجى استخدام صورة بحجم 4 ميجابايت كحد أقصى.',
    'profile.field.avatar': 'الصورة',
    'profile.field.name': 'الاسم',
    'profile.field.email': 'البريد الإلكتروني',
    'profile.field.userType': 'نوع المستخدم',
    'profile.field.vendorName': 'اسم المعمل',
    'profile.menu.profile': 'الملف الشخصي',
    'profile.menu.settings': 'الإعدادات',
    'profile.field.password': 'كلمة المرور',
    'profile.field.passwordConfirm': 'تأكيد كلمة المرور',
    'profile.field.phone': 'الهاتف',
    'profile.field.currentPassword': 'كلمة المرور الحالية',
    'profile.changePassword': 'تغيير كلمة المرور',
    'profile.menu.logout': 'تسجيل خروج',
    'profile.section.accountDetails': 'بيانات الحساب',
    'profile.stats.memberSince': 'عضو منذ',
    'profile.stats.memberDays': '{count} يوم معنا',
    'profile.stats.lastLogin': 'آخر تسجيل دخول',
    'profile.stats.activities': 'النشاطات',
    'profile.stats.activitiesRecent': '{count} خلال آخر 30 يوم',
    'profile.stats.ordersAssigned': 'الطلبات المسندة',
    'profile.stats.ordersCreated': 'الطلبات المُنشأة',
    'profile.stats.ordersActive': '{count} ما زالت نشطة',
    'profile.stats.invoicesCreated': 'الفواتير المُنشأة',
    'profile.stats.paidToUser': 'المدفوع لك',

    'users.page.title': 'المستخدمون',
    'users.button.addUser': 'إضافة مستخدم',
    'users.filter.search.placeholder': 'ابحث بالاسم أو البريد أو الهاتف أو العنوان أو واتساب',
    'users.modal.title': 'المستخدمون',
    'users.table.name': 'الاسم',
    'users.table.username': 'اسم المستخدم',
    'users.table.email': 'البريد الإلكتروني',
    'users.table.userType': 'نوع المستخدم',
    'users.table.phone': 'رقم التليفون',
    'users.table.whatsapp': 'رقم الواتساب',
    'users.table.address': 'العنوان',
    'users.table.actions': 'العمليات',
    'users.confirm.deleteTitle': 'حذف مستخدم',
    'users.confirm.deleteMessage': 'هل تريد حذف هذا المستخدم؟',
    'users.modal.createTitle': 'إضافة مستخدم',
    'users.modal.editTitle': 'تعديل مستخدم',
    'users.changeHistory': 'سجل التغييرات',
    'users.versions.title': 'سجل تغييرات المستخدم',
    'users.versions.empty': 'لا يوجد سجل تغييرات حتى الآن',
    'users.versions.by': 'تم التحديث بواسطة',
    'users.versions.noFields': 'لا توجد حقول تغيّرت',
    'users.versions.timelineTitle': 'الخط الزمني',
    'users.versions.compareTitle': 'مقارنة مع الحالة الحالية',
    'users.versions.selectVersion': 'اختر إصدارًا',
    'users.versions.fieldsChanged': 'عدد الحقول المتغيرة',
    'users.versions.field': 'الحقل',
    'users.versions.versionValue': 'قيمة الإصدار',
    'users.versions.currentValue': 'القيمة الحالية',
    'users.versions.current': 'الحالي',
    'users.versions.before': 'قبل',
    'users.versions.after': 'بعد (الحالية)',
    'users.versions.status': 'الحالة',
    'users.versions.changed': 'تم التغيير',
    'users.versions.same': 'بدون تغيير',
    'users.form.name.label': 'الاسم',
    'users.form.name.placeholder': 'ادخل الاسم',
    'users.form.name.required': 'من فضلك ادخل الاسم',
    'users.form.email.label': 'البريد الإلكتروني',
    'users.form.email.placeholder': 'ادخل البريد الإلكتروني',
    'users.form.email.required': 'من فضلك ادخل البريد الإلكتروني',
    'users.form.email.invalid': 'من فضلك ادخل بريدًا إلكترونيًا صحيحًا',
    'users.form.username.label': 'اسم المستخدم',
    'users.form.username.placeholder': 'ادخل اسم المستخدم',
    'users.form.username.hint': 'مطلوب إذا لم يكن للمستخدم بريد إلكتروني',
    'users.form.password.label': 'كلمة المرور',
    'users.form.password.placeholder': 'ادخل كلمة المرور',
    'users.form.password.required': 'من فضلك ادخل كلمة المرور',
    'users.form.password.invitationHint': 'اتركه فارغًا لإرسال رابط الدعوة',
    'users.form.password.tempHint': 'اتركه فارغًا لاستخدام كلمة المرور المؤقتة الافتراضية (temp123)',
    'users.form.password.confirm': 'تأكيد كلمة المرور',
    'users.form.password.confirmRequired': 'من فضلك أكد كلمة المرور',
    'users.form.password.mismatch': 'كلمتا المرور غير متطابقتين',
    'users.form.password.confirmPlaceholder': 'أعد إدخال كلمة المرور',
    'users.resetPassword.button': 'إعادة تعيين كلمة المرور',
    'users.resetPassword.confirmTitle': 'إعادة التعيين إلى الكلمة المؤقتة؟',
    'users.resetPassword.confirmMessage': 'سيتم تعيين كلمة المرور إلى temp123. شاركها مع المستخدم ليسجّل الدخول ثم يغيّرها.',
    'users.resetPassword.successTitle': 'كلمة المرور المؤقتة جاهزة',
    'users.resetPassword.successHint': 'أعطِ كلمة المرور هذه للمستخدم. عليه تسجيل الدخول ثم تغييرها من الملف الشخصي.',
    'users.resetPassword.failed': 'تعذر إعادة تعيين كلمة المرور',
    'users.forceLogout.button': 'تسجيل خروج',
    'users.forceLogout.confirmTitle': 'تسجيل خروج هذا المستخدم؟',
    'users.forceLogout.confirmMessage': 'سيتم إنهاء جميع جلسات المستخدم النشطة على كل الأجهزة، وسيحتاج إلى تسجيل الدخول مرة أخرى.',
    'users.forceLogout.success': 'تم تسجيل خروج المستخدم من جميع الأجهزة',
    'users.forceLogout.failed': 'تعذر تسجيل خروج المستخدم',
    'users.invitation.copyLink': 'نسخ رابط الدعوة',
    'users.invitation.linkCopied': 'تم نسخ رابط الدعوة',
    'users.invitation.copyFailed': 'تعذر نسخ رابط الدعوة',
    'users.invitation.regenerate': 'إعادة إنشاء رابط الدعوة',
    'users.invitation.regeneratedAndCopied': 'تمت إعادة إنشاء الرابط ونسخه',
    'users.invitation.regenerateFailed': 'تعذر إعادة إنشاء رابط الدعوة',
    'users.invitation.title': 'الدعوة',
    'users.invitation.invalidToken': 'رابط الدعوة غير صالح أو منتهي الصلاحية',
    'users.invitation.completed': 'تم تفعيل الحساب بنجاح! يمكنك تسجيل الدخول الآن.',
    'users.invitation.completeFailed': 'تعذر إكمال الدعوة',
    'users.invitation.error': 'خطأ',
    'users.invitation.backToLogin': 'العودة إلى تسجيل الدخول',
    'users.invitation.setPassword': 'تعيين كلمة المرور',
    'users.invitation.welcome': 'مرحبًا!',
    'users.invitation.welcomeMessage': 'يرجى تعيين كلمة مرور للحساب {{name}} ({{email}})',
    'users.invitation.complete': 'إكمال التفعيل',
    'users.form.phone.label': 'رقم التليفون',
    'users.form.phone.placeholder': 'ادخل رقم التليفون',
    'users.form.whatsapp.label': 'رقم الواتساب',
    'users.form.whatsapp.placeholder': 'ادخل رقم الواتساب',
    'users.form.address.label': 'العنوان',
    'users.form.address.placeholder': 'ادخل العنوان',
    'users.form.userType.label': 'نوع المستخدم',
    'users.form.userType.placeholder': 'اختر نوع المستخدم',
    'users.form.userType.required': 'من فضلك اختر نوع المستخدم',
    'users.form.permissions.label': 'الصلاحيات',
    'users.form.permissions.placeholder': 'اختر الصلاحيات',
    'users.form.permissions.selectAll': 'تحديد الكل',
    'users.permissions.groups.asset': 'الأصول',
    'users.permissions.groups.branch': 'الفروع',
    'users.permissions.groups.delivery_center': 'مراكز التوصيل',
    'users.permissions.groups.color': 'الألوان',
    'users.permissions.groups.dentist': 'الأطباء',
    'users.permissions.groups.expense': 'المصروفات',
    'users.permissions.groups.expense_type': 'بنود المصروفات',
    'users.permissions.groups.invoice': 'الفواتير',
    'users.permissions.groups.formula_type': 'المواد',
    'users.permissions.groups.formula_type': 'أنواع المواد',
    'users.permissions.groups.order': 'الطلبات',
    'users.permissions.groups.client': 'العملاء',
    'users.permissions.groups.transaction': 'المعاملات',
    'users.permissions.groups.unit': 'الوحدات',
    'users.permissions.groups.unit_type': 'أنواع الوحدات',
    'users.permissions.groups.user': 'المستخدمون',
    'users.permissions.groups.dashboard': 'لوحة التحكم',
    'users.permissions.groups.vendor': 'المعامل',
    'users.permissions.groups.vendor_bank_accounts': 'الحسابات البنكية',
    'users.permissions.groups.vendor_money_transfer_channels': 'طرق التحويل',
    'users.permissions.groups.setting': 'الإعدادات',
    'users.permissions.items.view_dashboard_kpi_orders': 'عرض مقياس الطلبات',
    'users.permissions.items.view_dashboard_kpi_invoices': 'عرض مقياس الفواتير',
    'users.permissions.items.view_dashboard_kpi_clients': 'عرض مقياس العملاء',
    'users.permissions.items.view_dashboard_kpi_units': 'عرض مقياس الوحدات',
    'users.permissions.items.view_dashboard_kpi_expenses': 'عرض مقياس المصروفات',
    'users.permissions.items.view_dashboard_collection_tracker': 'عرض متتبع التحصيل',
    'users.permissions.items.view_dashboard_revenue_tracker': 'عرض متتبع الإيرادات',
    'users.permissions.items.view_dashboard_latest_orders': 'عرض أحدث الطلبات',
    'users.permissions.items.view_dashboard_orders_tracker': 'عرض متتبع الطلبات',
    'users.permissions.items.view_dashboard_latest_invoices': 'عرض أحدث الفواتير',
    'users.permissions.items.view_dashboard_invoices_tracker': 'عرض متتبع الفواتير',
    'users.permissions.items.view_dashboard_formula_types_tracker': 'عرض متتبع أنواع التركيبات',
    'users.permissions.items.view_dashboard_active_clients': 'عرض العملاء النشطين',
    'users.permissions.items.view_dashboard_active_orders': 'عرض الطلبات النشطة',
    'users.permissions.items.view_dashboard_active_invoices': 'عرض الفواتير النشطة',
    'users.permissions.items.view_dashboard_active_expenses': 'عرض المصروفات النشطة',

    // Invoice extra permissions
    'users.permissions.items.download_invoice_pdf': 'تحميل الفاتورة (PDF)',
    'users.permissions.items.send_invoice_whatsapp': 'إرسال الفاتورة عبر واتساب',
    'users.permissions.items.send_invoice_email': 'إرسال الفاتورة عبر البريد الإلكتروني',
    'users.permissions.items.detach_order_from_invoice': 'فصل الطلب عن الفاتورة',

    // Vendor-related permissions
    'users.permissions.items.view_vendor': 'عرض المعامل',
    'users.permissions.items.add_vendor': 'إضافة معملين',
    'users.permissions.items.edit_vendor': 'تعديل المعامل',
    'users.permissions.items.delete_vendor': 'حذف المعامل',

    'users.permissions.items.view_vendor_bank_accounts': 'عرض الحسابات البنكية',
    'users.permissions.items.add_vendor_bank_accounts': 'إضافة حسابات بنكية',
    'users.permissions.items.edit_vendor_bank_accounts': 'تعديل الحسابات البنكية',
    'users.permissions.items.delete_vendor_bank_accounts': 'حذف الحسابات البنكية',

    'users.permissions.items.view_vendor_money_transfer_channels': 'عرض طرق التحويل',
    'users.permissions.items.add_vendor_money_transfer_channels': 'إضافة طرق التحويل',
    'users.permissions.items.edit_vendor_money_transfer_channels': 'تعديل طرق التحويل',
    'users.permissions.items.delete_vendor_money_transfer_channels': 'حذف طرق التحويل',

    // Settings (lab profile)
    'users.permissions.items.view_settings': 'عرض الإعدادات',
    'users.permissions.items.edit_settings': 'تعديل الإعدادات',

    'users.permissions.items.view_asset': 'عرض الأصول',
    'users.permissions.items.add_asset': 'إضافة الأصول',
    'users.permissions.items.edit_asset': 'تعديل الأصول',
    'users.permissions.items.delete_asset': 'حذف الأصول',
    'users.permissions.items.view_branch': 'عرض الفروع',
    'users.permissions.items.add_branch': 'إضافة الفروع',
    'users.permissions.items.edit_branch': 'تعديل الفروع',
    'users.permissions.items.delete_branch': 'حذف الفروع',
    'users.permissions.items.view_delivery_center': 'عرض مراكز التوصيل',
    'users.permissions.items.add_delivery_center': 'إضافة مراكز التوصيل',
    'users.permissions.items.edit_delivery_center': 'تعديل مراكز التوصيل',
    'users.permissions.items.delete_delivery_center': 'حذف مراكز التوصيل',
    'users.permissions.items.view_color': 'عرض الألوان',
    'users.permissions.items.add_color': 'إضافة الألوان',
    'users.permissions.items.edit_color': 'تعديل الألوان',
    'users.permissions.items.delete_color': 'حذف الألوان',
    'users.permissions.items.view_dentist': 'عرض الأطباء',
    'users.permissions.items.add_dentist': 'إضافة الأطباء',
    'users.permissions.items.edit_dentist': 'تعديل الأطباء',
    'users.permissions.items.delete_dentist': 'حذف الأطباء',
    'users.permissions.items.view_expense': 'عرض المصروفات',
    'users.permissions.items.add_expense': 'إضافة المصروفات',
    'users.permissions.items.edit_expense': 'تعديل المصروفات',
    'users.permissions.items.delete_expense': 'حذف المصروفات',
    'users.permissions.items.view_expense_type': 'عرض بنود المصروفات',
    'users.permissions.items.add_expense_type': 'إضافة بنود المصروفات',
    'users.permissions.items.edit_expense_type': 'تعديل بنود المصروفات',
    'users.permissions.items.delete_expense_type': 'حذف بنود المصروفات',
    'users.permissions.items.view_invoice': 'عرض الفواتير',
    'users.permissions.items.add_invoice': 'إضافة الفواتير',
    'users.permissions.items.edit_invoice': 'تعديل الفواتير',
    'users.permissions.items.delete_invoice': 'حذف الفواتير',

    // Order extra actions
    'users.permissions.items.create_invoice_from_order': 'إنشاء فاتورة من الطلب',
    'users.permissions.items.attach_order_to_invoice': 'ربط الطلب بفاتورة موجودة',
    'users.permissions.items.create_work_order': 'إنشاء أمر عمل',
    'users.permissions.items.view_assigned_orders': 'عرض الطلبات المسندة',
    'users.permissions.items.view_order_public_page': 'عرض صفحة الطلب العامة',

    // Orders actions UI text
    'orders.actions.createInvoice.title': 'إنشاء فاتورة',
    'orders.actions.createInvoice.description': 'إنشاء فاتورة باستخدام الطلب الحالي.',
    'orders.actions.createInvoice.cta': 'إنشاء فاتورة',
    'orders.actions.createInvoice.success': 'تم إنشاء الفاتورة بنجاح',
    'orders.actions.createInvoice.error': 'فشل في إنشاء الفاتورة',

    'orders.actions.attach.title': 'ربط بفاتورة موجودة',
    'orders.actions.attach.selectPlaceholder': 'اختر فاتورة',
    'orders.actions.attach.cta': 'ربط',
    'orders.actions.attach.success': 'تم ربط الطلب بالفاتورة',
    'orders.actions.attach.error': 'فشل في الربط',

    'orders.actions.createWorkOrder.title': 'إنشاء أمر عمل',
    'orders.actions.createWorkOrder.assignedTo': 'تعيين إلى',
    'orders.actions.createWorkOrder.notes': 'ملاحظات',
    'orders.actions.createWorkOrder.cta': 'إنشاء أمر عمل',
    'orders.actions.createWorkOrder.success': 'تم إنشاء أمر العمل',
    'orders.actions.createWorkOrder.error': 'فشل في إنشاء أمر العمل',
    'orders.actions.createWorkOrder.byFormulaTypeTitle': 'بنود الطلب (حسب نوع التركيبة)',
    'orders.actions.createWorkOrder.unitsCount': '{{count}} وحدة',
    'orders.actions.createWorkOrder.unitLabel': 'الوحدة {{order}}',
    'orders.actions.createWorkOrder.noLineItems': 'لا توجد صيغ في هذا الطلب.',
    'users.permissions.items.view_formula_type': 'عرض نوع التركيبة',
    'users.permissions.items.add_formula_type': 'إضافة نوع التركيبة',
    'users.permissions.items.edit_formula_type': 'تعديل نوع التركيبة',
    'users.permissions.items.delete_formula_type': 'حذف نوع التركيبة',
    'users.permissions.items.view_all_formula_types': 'عرض كل أنواع التركيبة',
    'users.permissions.items.view_client': 'عرض العملاء',
    'users.permissions.items.add_client': 'إضافة العملاء',
    'users.permissions.items.edit_client': 'تعديل العملاء',
    'users.permissions.items.delete_client': 'حذف العملاء',
    'users.permissions.items.view_order': 'عرض الطلبات',
    'users.permissions.items.add_order': 'إضافة الطلبات',
    'users.permissions.items.edit_order': 'تعديل الطلبات',
    'users.permissions.items.delete_order': 'حذف الطلبات',
    'users.permissions.items.view_transaction': 'عرض المعاملات',
    'users.permissions.items.add_transaction': 'إضافة المعاملات',
    'users.permissions.items.edit_transaction': 'تعديل المعاملات',
    'users.permissions.items.delete_transaction': 'حذف المعاملات',
    'users.permissions.items.view_unit': 'عرض الوحدات',
    'users.permissions.items.add_unit': 'إضافة الوحدات',
    'users.permissions.items.edit_unit': 'تعديل الوحدات',
    'users.permissions.items.delete_unit': 'حذف الوحدات',
    'users.permissions.items.view_unit_type': 'عرض أنواع الوحدات',
    'users.permissions.items.add_unit_type': 'إضافة أنواع الوحدات',
    'users.permissions.items.edit_unit_type': 'تعديل أنواع الوحدات',
    'users.permissions.items.delete_unit_type': 'حذف أنواع الوحدات',
    'users.permissions.items.view_user': 'عرض المستخدمين',
    'users.permissions.items.add_user': 'إضافة المستخدمين',
    'users.permissions.items.edit_user': 'تعديل المستخدمين',
    'users.permissions.items.delete_user': 'حذف المستخدمين',
    'users.form.submit.add': 'إضافة',
    'users.form.submit.edit': 'تحديث',
    'users.alert.noAccess': 'ليس لديك صلاحية لعرض المستخدمين.',

    'invoice.button.print': 'طباعة',
    'invoice.button.addOrder': 'إضافة طلب',
    'invoice.field.dentistName': 'اسم الطبيب',
    'invoice.field.date': 'تاريخ الفاتورة',
    'invoice.table.orderRef': 'رقم الطلب',
    'invoice.table.invoiceRef': 'رقم الفاتورة',
    'invoice.field.shipmentDate': 'تاريخ الشحنة',
    'invoice.field.vat': 'قيمة الضريبة',
    'invoice.field.deliveryCost': 'تكلفة التوصيل',
    'invoice.field.orderId': 'رقم الطلب',
    'invoice.field.amount': 'المبلغ',
    'invoice.field.client': 'العميل',
    'invoice.field.status': 'حالة الفاتورة',
    'invoice.field.orders': 'الطلبات',
    'invoice.field.units': 'عدد الوحدات',
    'invoice.field.unitCost': 'التكلفة لكل وحدة',
    'invoice.field.issueDate': 'تاريخ الإصدار',
    'invoice.field.dueDate': 'تاريخ الاستحقاق',
    'invoice.field.paidAt': 'تاريخ الدفع',
    'invoice.field.paymentMethod': 'طريقة الدفع',
    'invoice.field.paymentStatus': 'حالة الدفع',
    'invoices.button.showDrafts': 'عرض المؤرشفة',
    'invoices.button.hideDrafts': 'إخفاء المؤرشفة',
    'invoices.filter.all': 'عرض الكل',
    'invoices.filter.drafts': 'عرض المؤرشفة',
    'invoices.filter.nonDrafts': 'إخفاء المؤرشفة',
    'invoice.field.deliveredAt': 'تم التسليم',
    'invoice.orders.viewFormulas': 'عرض التركيبات ومخطط الأسنان',
    'invoice.orders.hideFormulas': 'إخفاء التركيبات ومخطط الأسنان',
    'invoice.orders.expandAll': 'توسيع كل التركيبات',
    'invoice.orders.collapseAll': 'طَيّ كل التركيبات',
    'invoice.orders.formulasCount': '{{count}} تركيبات',
    'invoice.orders.unitsCount': '{{count}} وحدات',
    'invoice.orders.formulaList': 'التركيبات والألوان',
    'invoice.orders.financialSummary': 'تفاصيل المبلغ',
    'invoice.orders.teeth': 'الأسنان',
    'invoice.button.detach': 'فصل عن الفاتورة',
    'invoice.detach.confirmMessage': 'هل تريد بالتأكيد فصل هذا الطلب عن الفاتورة؟',
    'invoice.detach.success': 'تم فصل الطلب بنجاح',
    'invoice.detach.error': 'فشل فصل الطلب',
    'invoice.cancel.confirmMessage': 'فصل آخر طلب سيحول الفاتورة إلى مسودة. المتابعة؟',
    'invoice.cancel.success': 'تم تحويل الفاتورة إلى مسودة',
    'invoice.cancel.error': 'فشل إلغاء الفاتورة',
    'invoice.alert.draft': 'الفاتورة في حالة مسودة',
    'invoice.alert.paidReadOnly': 'تم دفع هذه الفاتورة. لا يمكن تعديلها؛ استخدم التراجع عن الدفع أدناه إذا سُجّل الدفع بالخطأ، أو الاسترداد لإضافة المبلغ إلى محفظة العميل.',
    'invoice.button.cancel': 'إلغاء الفاتورة',
    'invoice.button.downloadPdf': 'تنزيل PDF',
    'invoice.button.downloadSummaryPdf': 'تنزيل الفاتورة PDF',
    'invoice.button.downloading': 'جاري التنزيل...',
    'invoice.summary.downloadError': 'تعذر تنزيل الفاتورة الملخصة',
    'invoice.button.sendWhatsapp': 'إرسال عبر واتساب',
    'invoice.button.sendEmail': 'إرسال عبر البريد',
    'invoice.button.markPaid': 'تسجيل كمدفوعة',
    'invoice.button.refund': 'استرداد',
    'invoice.markPaid.title': 'تسجيل الدفع',
    'invoice.markPaid.paymentMethod': 'طريقة الدفع',
    'invoice.markPaid.channel': 'قناة التحويل',
    'invoice.markPaid.channelOther': 'قناة أخرى',
    'invoice.markPaid.notes': 'ملاحظات',
    'invoice.markPaid.attachment': 'مرفق (صورة)',
    'invoice.markPaid.success': 'تم تسجيل الفاتورة كمدفوعة',
    'invoice.markPaid.error': 'فشل تسجيل الفاتورة كمدفوعة',
    'invoice.refund.confirmTitle': 'استرداد الفاتورة؟',
    'invoice.refund.confirmMessage': 'سيتم إضافة المبلغ المدفوع إلى محفظة العميل وستُعاد الفاتورة إلى غير مدفوعة.',
    'invoice.refund.success': 'تم استرداد الفاتورة بنجاح',
    'invoice.refund.error': 'فشل استرداد الفاتورة',
    'invoice.button.undoMarkPaid': 'التراجع عن الدفع',
    'invoice.undoMarkPaid.confirmTitle': 'التراجع عن الدفع؟',
    'invoice.undoMarkPaid.confirmMessage': 'سيتم إلغاء تسجيل الدفع كما لو لم يحدث. ستُحذف معاملات الدفع المرتبطة وتُعاد الفاتورة إلى غير مدفوعة.',
    'invoice.undoMarkPaid.success': 'تم التراجع عن دفع الفاتورة',
    'invoice.undoMarkPaid.error': 'فشل التراجع عن دفع الفاتورة',
    'invoice.changeHistory': 'سجل التغييرات',
    'invoice.versions.title': 'سجل تغييرات الفاتورة',
    'invoice.versions.empty': 'لا يوجد سجل تغييرات حتى الآن',
    'invoice.versions.timelineTitle': 'الخط الزمني',
    'invoice.versions.by': 'تم التحديث بواسطة',
    'invoice.versions.fieldsChanged': 'عدد الحقول المتغيرة',
    'invoice.versions.compareTitle': 'مقارنة مع الحالة الحالية',
    'invoice.versions.selectVersion': 'اختر إصدارًا',
    'invoice.versions.noFields': 'لا توجد حقول تغيّرت',
    'invoice.versions.currentVersion': 'الإصدار الحالي',
    'invoice.versions.before': 'قبل',
    'invoice.versions.after': 'بعد (الحالية)',
    'invoice.field.phone': 'رقم الهاتف',
    'invoice.field.message': 'الرسالة',
    'invoice.paymentSummary.toggle': 'المبالغ',
    'invoice.paymentSummary.hide': 'إخفاء المبالغ',
    'invoice.paymentSummary.show': 'إظهار المبالغ',
    'invoice.seller.title': 'المعمل',
    'invoice.dentist.title': 'الطبيب',
    'invoice.deliveryCenter.title': 'مراكز التسليم',
    'invoice.customer.title': 'العميل',
    'invoice.paymentSummary.title': 'ملخص الدفع',
    'invoice.notes.title': 'ملاحظات',
    'invoice.client.title': 'العميل',
    'invoice.notes.edit': 'تعديل',
    'invoice.notes.save': 'حفظ',
    'invoice.notes.cancel': 'إلغاء',
    'invoice.summary.title': 'ملخص الفاتورة',
    'invoice.summary.subtotal': 'الإجمالي قبل الضريبة',
    'invoice.summary.vat': 'ضريبة القيمة المضافة ({{percent}}%)',
    'invoice.summary.totalVat': 'إجمالي الضريبة',
    'invoice.summary.discount': 'الخصومات',
    'invoice.summary.delivery': 'التوصيل',
    'invoice.summary.total': 'الإجمالي',
    'invoice.attachments.title': 'المرفقات',
    'invoice.addOrder.selectRequired': 'الرجاء اختيار طلب واحد على الأقل',

    // UI invoice labels (عرض الفاتورة العام)
    'ui.invoice.number': 'رقم الفاتورة',
    'ui.invoice.status': 'الحالة',
    'ui.invoice.issue_date': 'تاريخ الإصدار',
    'ui.invoice.due_date': 'تاريخ الاستحقاق',
    'ui.invoice.section_vendor': 'المعمل',
    'ui.invoice.section_client': 'العميل',
    'ui.invoice.section_dentist': 'الطبيب',
    'ui.invoice.section_delivery_center': 'مركز التسليم',
    'ui.delivery_cost': 'تكلفة التوصيل',
    'ui.invoice.table.order_ref': 'مرجع الطلب',
    'ui.invoice.table.formula_type': 'المادة',
    'ui.invoice.table.units': 'الوحدات',
    'ui.invoice.table.shipment_date': 'تاريخ الشحنة',
    'ui.invoice.table.patient': 'المريض',
    'ui.invoice.table.amount': 'المبلغ',
    'ui.invoice.table.discount': 'الخصم',
    'ui.invoice.table.vat': 'ضريبة',
    'ui.invoice.table.total': 'الإجمالي',
    'ui.invoice.status_paid': 'مدفوع',


    // Channel names

    // Payment / Bank accounts (Arabic)
    'ui.invoice.status_past_due': 'غير مدفوع',
    'ui.invoice.status_unpaid': 'غيرمدفوع',

    // Generic error messages
    'errors.fetchFailed': 'فشل في تحميل البيانات',
    'invoice.addOrder.added': 'تمت إضافة الطلبات للفاتورة',
    'invoice.addOrder.fetchError': 'تعذر استرجاع الطلبات',
    'invoice.addOrder.attachedHint': 'مرتبط بالفاتورة #{id} ({status}) — سيتم فصله إن تم التحديد',
    'invoice.addOrder.detachConfirmTitle': 'هل تود فصل الطلبات عن الفواتير الأخرى؟',
    'invoice.addOrder.detachConfirmMessage': 'بعض الطلبات المحددة مرتبطة بفواتير أخرى. اختيارها سيؤدي إلى فصلها عن الفاتورة الحالية. هل تريد المتابعة؟',

    'invoices.detach.title': 'فصل الطلبات',
    'invoices.detach.noInvoice': 'الفاتورة غير موجودة',
    'invoice.addOrder.attachError': 'تعذر إضافة الطلبات',
    'invoice.addOrder.issueDateFrom': 'تاريخ الإصدار من',
    'invoice.addOrder.issueDateTo': 'تاريخ الإصدار إلى',
    'invoice.addOrder.loadByIssueDate': 'تحميل حسب تاريخ الإصدار',
    'invoice.addOrder.selectAllInRange': 'تحديد الكل',
    'invoice.addOrder.clearIssueDateFilter': 'مسح فلتر التاريخ',
    'invoice.addOrder.issueDateRangeRequired': 'يرجى اختيار نطاق تاريخ الإصدار',
    'invoice.addOrder.createNew': 'إنشاء فاتورة جديدة',
    'invoice.addOrder.chooseExisting': 'إرفاق بفاتورة موجودة',
    'invoice.addOrder.attach': 'إرفاق بفاتورة موجودة',
    'invoices.button.add': 'أنشئ فاتورة',
    'invoice.create.title': 'إنشاء فاتورة',
    'invoice.form.clientPlaceholder': 'اختر عميلًا لتحميل الطلبات غير المدفوعة',
    'invoice.field.formula_type': 'نوع مادة التركيب',
    'invoice.field.color': 'اللون',
    'invoice.field.subtotal': 'إجمالي التكلفة',
    'invoice.field.discountType': 'نوع الخصم',
    'invoice.field.discountValue': 'قيمة الخصم',
    'invoice.field.total': 'المبلغ المستحق',
    'invoice.field.paid': 'المبلغ المدفوع',

    // Payment / Bank accounts
    'lab.payment.title': 'إعدادات الدفع',
    'lab.payment.bank_accounts_title': 'الحسابات البنكية',
    'lab.payment.addAccount': 'إضافة حساب بنكي',
    'lab.payment.editAccount': 'تعديل حساب بنكي',
    'lab.payment.accountHolder': 'صاحب الحساب',
    'lab.payment.accountHolder.required': 'اسم صاحب الحساب مطلوب',
    'lab.payment.accountHolder.max': 'اسم صاحب الحساب طويل جداً',
    'lab.payment.accountNumber': 'رقم الحساب',
    'lab.payment.accountNumber.required': 'رقم الحساب مطلوب',
    'lab.payment.accountNumber.invalid': 'رقم الحساب غير صالح',
    'lab.payment.accountNumber.min': 'رقم الحساب قصير جداً',
    'lab.payment.iban': 'IBAN',
    'lab.payment.iban.invalid': 'Invalid IBAN',
    'lab.payment.swiftCode': 'Swift Code',
    'lab.payment.swiftCode.invalid': 'Invalid SWIFT/BIC',
    'lab.payment.bankName': 'Bank Name',
    'lab.payment.bankName.required': 'Bank name is required',
    'lab.payment.bankName.max': 'Bank name is too long',
    'lab.payment.branch': 'Bank Branch',
    'lab.payment.branch.max': 'Branch details are too long',
    'lab.payment.no_accounts': 'No bank accounts',
    'lab.payment.no_transfer': 'No active transfer channels',
    'lab.payment.addTransfer': 'Add Transfer Channel',
    'lab.payment.editTransfer': 'Edit Transfer Channel',
    'lab.payment.channel': 'Transfer Channel',
    'lab.payment.deactivate': 'Deactivate',
    'lab.payment.channel.required': 'Please select a transfer channel',
    'lab.payment.phone.invalid': 'Invalid phone number',
    'lab.payment.transfer_title': 'Money Transfer',
    'lab.payment.activate': 'Activate',
    'lab.payment.activated': 'Activated',
    'lab.payment.deactivated': 'Deactivated',

    'ui.invoice.bank_account': 'الحساب البنكي',
    'ui.invoice.bank_account_numbered': 'الحساب البنكي {{n}}',
    'ui.invoice.bank_name': 'اسم البنك',
    'ui.invoice.bank_swift': 'رمز السويفت',
    'ui.invoice.bank_iban': 'آيبان',
    'ui.invoice.account_holder': 'صاحب الحساب',
    'ui.invoice.account_number': 'رقم الحساب',
    'ui.invoice.vendor_payment_data': 'بيانات دفع المعمل',
    'ui.invoice.payment_method': 'طريقة الدفع',
    'ui.invoice.payment_method_wallet': 'المحفظة',
    'ui.invoice.payment_method_money_transfer': 'التحويل البنكي',
    'ui.invoice.payment_method_cash_on_delivery': 'دفع نقدي',
    'ui.invoice.payment_method_credit_card': 'بطاقة ائتمان',
    'ui.invoice.money_transfer_channel': 'قناة التحويل',
    'ui.invoice.public_link': 'عرض الفاتورة',
    'ui.invoice.money_transfer_channels': 'قنوات التحويل',
    'ui.invoice.paid_at': 'تاريخ الدفع',

    // Channel names (support both slug formats: vodafone-cash and vodafone_cash)
    'ui.invoice.channel.instapay': 'إنستاباي',
    'ui.invoice.channel.vodafone_cash': 'فودافون كاش',
    'ui.invoice.channel.vodafone-cash': 'فودافون كاش',
    'ui.invoice.channel.etisalat_cash': 'اتصالات كاش',
    'ui.invoice.channel.etisalat-cash': 'اتصالات كاش',
    'ui.invoice.channel.we_pay': 'وي باي',
    'ui.invoice.channel.we-pay': 'وي باي',
    'ui.invoice.channel.fawry': 'فوري',
    'ui.invoice.channel.bank_transfer': 'تحويل بنكي',
    'ui.invoice.channel.bank-transfer': 'تحويل بنكي',
    'ui.invoice.channel.meeza': 'ميزة',
    'ui.invoice.channel.masary': 'مصاري',

    // Enhanced Public Invoice UI (Arabic)
    'ui.invoice.view_title': 'فاتورة',
    'ui.invoice.loading_details': 'جاري تحميل تفاصيل الفاتورة...',
    'ui.invoice.financial_summary': 'الملخص المالي',
    'ui.invoice.payment_details': 'تعليمات الدفع والتحويل البنكي',
    'ui.invoice.scan_qr_hint': 'امسح رمز QR لعرض والتحقق من الفاتورة عبر الإنترنت',
    'ui.invoice.copy_iban': 'نسخ الآيبان',
    'ui.invoice.copy_account': 'نسخ رقم الحساب',
    'ui.invoice.copy_number': 'نسخ الرقم',
    'ui.invoice.copied': 'تم النسخ إلى الحافظة',
    'ui.invoice.public_disclaimer': 'هذه الفاتورة رسمية صادرة من معمل الأسنان لأغراض المطابقة والتحقق المالي. لا تتطلب تسجيل الدخول.',
    'ui.invoice.included_orders': 'الطلبات المشمولة',
    'ui.invoice.orders_count': '{{count}} طلبات',
    'ui.invoice.total_restorations': '{{count}} تركيبة',
    'ui.invoice.paid_in_full': 'مدفوع بالكامل',
    'ui.invoice.remaining_balance': 'المبلغ المتبقي',
    'ui.invoice.billing_signoff': 'اعتماد الفاتورة وتوقيع المعمل',
    'ui.invoice.accountant_signature': 'التوقيع المعتمد / الختم',
    'ui.invoice.accountant_name': 'إعداد بواسطة',
    'ui.invoice.verification_date': 'تاريخ الاعتماد',
    'ui.invoice.channel_transfer_notice': 'يرجى إرفاق رقم الفاتورة كمرجع عند إتمام عملية التحويل.',
    'ui.invoice.bank_details': 'بيانات الحسابات البنكية',
    'ui.invoice.no_bank_accounts': 'لا توجد بيانات حسابات بنكية مضافة.',
    'ui.invoice.no_transfer_channels': 'لا توجد قنوات تحويل مالية مضافة.',
    'ui.invoice.balance_cleared': 'تم تسوية الرصيد بالكامل',
    'ui.invoice.unpaid_balance_alert': 'الدفع معلق. يرجى استخدام تفاصيل الدفع أدناه لإتمام السداد.',
    'ui.invoice.past_due_alert': 'تجاوزت هذه الفاتورة تاريخ الاستحقاق. يرجى تسوية المبلغ المستحق في أقرب وقت.',

    'notFound.title': 'الصفحة غير موجودة',

    'sidebar.backoffice_vendors': 'المعامل (إدارة)',
    'backoffice.vendors.title': 'المعامل',
    'backoffice.vendors.create': 'إضافة معمل',
    'backoffice.vendors.createTitle': 'إنشاء معمل',
    'backoffice.vendors.editTitle': 'تعديل معمل',
    'backoffice.vendors.col.id': 'المعرّف',
    'backoffice.vendors.col.name': 'الاسم',
    'backoffice.vendors.col.phone': 'الهاتف',
    'backoffice.vendors.col.users': 'المستخدمون',
    'backoffice.vendors.field.name': 'اسم المعمل',
    'backoffice.vendors.submitCreate': 'إنشاء المعمل',
    'backoffice.vendors.loadError': 'تعذر تحميل المعامل',
    'backoffice.vendors.saveError': 'تعذر حفظ المعمل',
    'backoffice.vendors.deleteError': 'تعذر حذف المعمل',
    'backoffice.vendors.deleteConfirm': 'حذف هذا المعمل؟ لا يمكن التراجع.',
    'backoffice.vendors.deleted': 'تم حذف المعمل',
    'backoffice.vendors.created': 'تم إنشاء المعمل',
    'backoffice.vendors.updated': 'تم تحديث المعمل',
    'backoffice.vendors.notFound': 'المعمل غير موجود',
    'backoffice.vendors.tabs.general': 'عام',
    'backoffice.vendors.tabs.users': 'المستخدمون',
    'backoffice.vendors.tabs.orders': 'الطلبات',
    'backoffice.vendors.tabs.invoices': 'الفواتير',
    'backoffice.vendors.tabs.settings': 'الإعدادات (صفحة دخول المعمل)',
    'backoffice.vendors.users.add': 'إضافة مستخدم',
    'backoffice.vendors.users.addTitle': 'إضافة مستخدم للمعمل',
    'backoffice.vendors.users.created': 'تم إنشاء المستخدم',
    'backoffice.vendors.users.loadError': 'تعذر تحميل مستخدمي المعمل',
    'backoffice.vendors.users.saveError': 'تعذر حفظ المستخدم',
    'backoffice.vendors.users.sendInvitation': 'إرسال دعوة',
    'backoffice.vendors.users.verified': 'مفعّل',
    'backoffice.vendors.users.pending': 'بانتظار التفعيل',
    'backoffice.vendors.settings.loadError': 'تعذر تحميل إعدادات المعمل',
    'backoffice.vendors.settings.labProfile': 'إعدادت المختبر',
    'backoffice.vendors.formulaTypeCosts.title': 'حسابات تكاليف أنواع التركيبات',
    'backoffice.vendors.formulaTypeCosts.include': 'احتساب تكاليف أنواع التركيبات:',
    'backoffice.vendors.formulaTypeCosts.material': 'الخامة',
    'backoffice.vendors.formulaTypeCosts.technician': 'الفني',
    'backoffice.vendors.formulaTypeCosts.additional': 'الإضافية',
    'backoffice.vendors.formulaTypeCosts.hint': 'التكاليف غير المحددة لا تُضاف لهذا المعمل: لا تُنشأ كأنواع مصروفات ولا كمصروفات، وتبقى مخفية من لوحة التحكم وتقريري التحصيل والإيرادات وشاشات أنواع التركيبات.',
    'backoffice.vendors.formulaTypeCosts.saved': 'تم حفظ تكاليف أنواع التركيبات',
    'backoffice.vendors.formulaTypeCosts.saveError': 'تعذر حفظ تكاليف أنواع التركيبات',
    'backoffice.vendors.formulaTypeCosts.loadError': 'تعذر تحميل تكاليف أنواع التركيبات',

    'backoffice.subscriptionPlans.title': 'خطط الاشتراك',
    'backoffice.subscriptionPlans.editTitle': 'تعديل خطة الاشتراك',
    'backoffice.subscriptionPlans.col.id': 'المعرّف',
    'backoffice.subscriptionPlans.col.name': 'الاسم',
    'backoffice.subscriptionPlans.col.description': 'الوصف',
    'backoffice.subscriptionPlans.col.price': 'السعر',
    'backoffice.subscriptionPlans.col.highlighted': 'مميزة',
    'backoffice.subscriptionPlans.field.name': 'الاسم',
    'backoffice.subscriptionPlans.field.description': 'الوصف',
    'backoffice.subscriptionPlans.field.price': 'الأسعار',
    'backoffice.subscriptionPlans.field.features': 'المزايا',
    'backoffice.subscriptionPlans.field.descriptionEn': 'الوصف (بالإنجليزية)',
    'backoffice.subscriptionPlans.field.descriptionAr': 'الوصف (بالعربية)',
    'backoffice.subscriptionPlans.field.featuresEn': 'المزايا (بالإنجليزية)',
    'backoffice.subscriptionPlans.field.featuresAr': 'المزايا (بالعربية)',
    'backoffice.subscriptionPlans.field.highlighted': 'مميزة',
    'backoffice.subscriptionPlans.field.active': 'نشطة',
    'backoffice.subscriptionPlans.field.maxUsers': 'الحد الأقصى للمستخدمين',
    'backoffice.subscriptionPlans.field.maxOrders': 'الحد الأقصى للطلبات / شهر',
    'backoffice.subscriptionPlans.create': 'إنشاء خطة',
    'backoffice.subscriptionPlans.created': 'تم إنشاء الخطة',
    'backoffice.subscriptionPlans.deleted': 'تم حذف الخطة',
    'backoffice.subscriptionPlans.deleteError': 'تعذر حذف الخطة',
    'backoffice.subscriptionPlans.featuresHint': 'ميزة واحدة لكل سطر',
    'backoffice.subscriptionPlans.addPrice': 'إضافة سعر',
    'backoffice.subscriptionPlans.activate': 'تفعيل',
    'backoffice.subscriptionPlans.deactivate': 'إلغاء التفعيل',
    'backoffice.subscriptionPlans.activated': 'تم تفعيل الخطة',
    'backoffice.subscriptionPlans.deactivated': 'تم إلغاء تفعيل الخطة',
    'backoffice.subscriptionPlans.updated': 'تم تحديث الخطة',
    'backoffice.subscriptionPlans.loadError': 'تعذر تحميل خطط الاشتراك',
    'backoffice.subscriptionPlans.saveError': 'تعذر حفظ خطة الاشتراك',
    'backoffice.subscriptionPlans.yes': 'نعم',
    'backoffice.subscriptionPlans.no': 'لا',

    'backoffice.subscriptions.title': 'الاشتراكات',
    'backoffice.subscriptions.loadError': 'تعذر تحميل الاشتراكات',
    'backoffice.subscriptions.filter.status': 'تصفية حسب الحالة',
    'backoffice.subscriptions.col.id': 'المعرّف',
    'backoffice.subscriptions.col.vendor': 'المعمل',
    'backoffice.subscriptions.col.phone': 'الهاتف',
    'backoffice.subscriptions.col.admin': 'المسؤول',
    'backoffice.subscriptions.col.plan': 'الخطة',
    'backoffice.subscriptions.col.billing': 'الفوترة',
    'backoffice.subscriptions.col.trialEndsAt': 'نهاية التجربة',
    'backoffice.subscriptions.col.rejectionReason': 'سبب الرفض',
    'backoffice.subscriptions.col.suspendedAt': 'تاريخ الإيقاف',
    'backoffice.subscriptions.col.createdAt': 'تاريخ الإنشاء',
    'backoffice.subscriptions.activate': 'تفعيل',
    'backoffice.subscriptions.activateConfirm':
      'إنشاء المعمل ومستخدم المسؤول ثم إرسال بريد التفعيل؟',
    'backoffice.subscriptions.activated': 'تم تفعيل الاشتراك. تمت جدولة بريد الدعوة.',
    'backoffice.subscriptions.activateError': 'تعذر تفعيل الاشتراك',
    'backoffice.subscriptions.activatedLabel': 'مفعّل',
    'backoffice.subscriptions.reject': 'رفض',
    'backoffice.subscriptions.suspend': 'تعليق',
    'backoffice.subscriptions.reactivate': 'إعادة تفعيل',
    'backoffice.subscriptions.cancel': 'إلغاء',
    'backoffice.subscriptions.create': 'إنشاء اشتراك',
    'backoffice.subscriptions.status.pending': 'قيد الانتظار',
    'backoffice.subscriptions.status.under_review': 'قيد المراجعة',
    'backoffice.subscriptions.status.active': 'نشط',
    'backoffice.subscriptions.status.suspended': 'معلق',
    'backoffice.subscriptions.status.cancelled': 'ملغى',
    'backoffice.subscriptions.status.rejected': 'مرفوض',
    'backoffice.subscriptions.billing.trialing': 'تجريبي',
    'backoffice.subscriptions.billing.active': 'نشط',
    'backoffice.subscriptions.billing.past_due': 'متأخر',
    'backoffice.subscriptions.billing.cancelled': 'ملغى',
    'backoffice.subscriptions.billing.manual': 'يدوي',
    'backoffice.planRequests.title': 'طلبات تغيير الخطة',
    'backoffice.planRequests.loadError': 'تعذر تحميل طلبات تغيير الخطة',
    'backoffice.planRequests.actionError': 'تعذر معالجة طلب تغيير الخطة',
    'backoffice.planRequests.col.currentPlan': 'الخطة الحالية',
    'backoffice.planRequests.col.requestedPlan': 'الخطة المطلوبة',
    'backoffice.planRequests.col.requestedBy': 'مقدم الطلب',
    'backoffice.planRequests.col.note': 'ملاحظة',
    'backoffice.planRequests.col.requestedAt': 'تاريخ الطلب',
    'backoffice.planRequests.col.reviewed': 'المراجعة',
    'backoffice.planRequests.approve': 'موافقة',
    'backoffice.planRequests.approveConfirm': 'هل تريد الموافقة وتفعيل خطة {plan} لهذا المعمل؟',
    'backoffice.planRequests.approved': 'تمت الموافقة على الطلب. الخطة الجديدة مفعّلة الآن.',
    'backoffice.planRequests.reject': 'رفض',
    'backoffice.planRequests.rejectTitle': 'رفض طلب تغيير الخطة',
    'backoffice.planRequests.rejectReason': 'السبب (اختياري، يظهر للمعمل)',
    'backoffice.planRequests.rejected': 'تم رفض طلب تغيير الخطة',
    'backoffice.planRequests.status.pending': 'قيد المراجعة',
    'backoffice.planRequests.status.approved': 'تمت الموافقة',
    'backoffice.planRequests.status.rejected': 'مرفوض',
    'backoffice.planRequests.status.cancelled': 'ملغى',
    'backoffice.demoRequests.title': 'طلبات العرض التجريبي',
    'backoffice.demoRequests.subtitle': 'الزوار الذين فتحوا العرض التجريبي من الموقع مع بيانات التواصل ومعلومات الجهاز.',
    'backoffice.demoRequests.loadError': 'تعذر تحميل طلبات العرض التجريبي',
    'backoffice.demoRequests.stats.total': 'إجمالي العروض',
    'backoffice.demoRequests.stats.uniqueContacts': 'جهات اتصال فريدة',
    'backoffice.demoRequests.stats.lab': 'عروض المعامل',
    'backoffice.demoRequests.stats.clinic': 'عروض العيادات',
    'backoffice.demoRequests.stats.last7Days': 'آخر 7 أيام',
    'backoffice.demoRequests.col.contact': 'جهة الاتصال',
    'backoffice.demoRequests.col.demo': 'العرض',
    'backoffice.demoRequests.col.device': 'الجهاز',
    'backoffice.demoRequests.col.ip': 'عنوان IP',
    'backoffice.demoRequests.col.requestedAt': 'تاريخ الطلب',
    'backoffice.demoRequests.kind.lab': 'معمل أسنان',
    'backoffice.demoRequests.kind.clinic': 'عيادة أسنان',
    'backoffice.demoRequests.device.desktop': 'كمبيوتر',
    'backoffice.demoRequests.device.mobile': 'جوال',
    'backoffice.demoRequests.device.tablet': 'جهاز لوحي',
    'backoffice.demoRequests.device.bot': 'روبوت',
    'backoffice.demoRequests.source.demo_section': 'قسم العرض التجريبي بالموقع',
    'backoffice.demoRequests.source.footer': 'تذييل الموقع',
    'backoffice.demoRequests.filter.search': 'ابحث بالاسم أو الهاتف أو IP',
    'backoffice.demoRequests.filter.kind': 'نوع العرض',
    'backoffice.demoRequests.filter.device': 'نوع الجهاز',
    'backoffice.demoRequests.whatsapp': 'محادثة عبر واتساب',
    'backoffice.demoRequests.repeat': '{count} عروض',
    'backoffice.demoRequests.details': 'التفاصيل',
    'backoffice.demoRequests.detailsTitle': 'طلب عرض تجريبي',
    'backoffice.demoRequests.field.name': 'الاسم',
    'backoffice.demoRequests.field.phone': 'رقم الجوال',
    'backoffice.demoRequests.field.source': 'فُتح من',
    'backoffice.demoRequests.field.browser': 'المتصفح',
    'backoffice.demoRequests.field.os': 'نظام التشغيل',
    'backoffice.demoRequests.field.screen': 'حجم الشاشة',
    'backoffice.demoRequests.field.browserLanguage': 'لغة المتصفح',
    'backoffice.demoRequests.field.timezone': 'المنطقة الزمنية',
    'backoffice.demoRequests.field.referrer': 'جاء من (المُحيل)',
    'backoffice.demoRequests.field.pageUrl': 'رابط الصفحة',
    'backoffice.demoRequests.field.userAgent': 'وكيل المستخدم',
    'backoffice.dashboard.title': 'لوحة التحكم',
    'backoffice.dashboard.loadError': 'تعذر تحميل لوحة التحكم',
    'backoffice.dashboard.kpi.totalVendors': 'إجمالي المعامل',
    'backoffice.dashboard.kpi.activeVendors': 'المعامل النشطون',
    'backoffice.dashboard.kpi.pendingSignups': 'طلبات قيد الانتظار',
    'backoffice.dashboard.kpi.newThisMonth': 'جدد هذا الشهر',
    'backoffice.dashboard.actionRequired': 'يتطلب إجراء',
    'backoffice.dashboard.pendingSignups': 'اشتراكات قيد الانتظار',
    'backoffice.dashboard.vendorsNoUsers': 'معامل بدون مستخدمين',
    'backoffice.dashboard.vendorGrowth': 'نمو المعامل',
    'backoffice.dashboard.vendorsByPlan': 'المعامل حسب الخطة',
    'backoffice.dashboard.recentActivations': 'التفعيلات الأخيرة',
    'backoffice.dashboard.revenue': 'إيرادات المنصة',
    'backoffice.dashboard.revenueTotal': 'إجمالي الإيرادات',
    'backoffice.dashboard.revenueMonth': 'إيرادات هذا الشهر',
    'backoffice.dashboard.col.vendor': 'المعمل',
    'backoffice.dashboard.col.plan': 'الخطة',
    'backoffice.dashboard.col.date': 'التاريخ',
    'backoffice.vendors.tabs.overview': 'نظرة عامة',
    'backoffice.vendors.tabs.orderStatusFlow': 'سير عمل الطلبات',
    'orderStatusFlow.title': 'سير عمل حالات الطلب',
    'orderStatusFlow.subtitle': 'يبدأ كل سير عمل بحالة مطلوب وينتهي بمغلق. اختر الحالات بينهما وكيف تنتقل الطلبات بينها.',
    'orderStatusFlow.transitionsLabel': 'انتقال',
    'orderStatusFlow.save': 'حفظ سير العمل',
    'orderStatusFlow.discard': 'تجاهل التغييرات',
    'orderStatusFlow.reset': 'استعادة الافتراضي',
    'orderStatusFlow.resetConfirmTitle': 'استعادة سير العمل الافتراضي؟',
    'orderStatusFlow.resetConfirmBody': 'سيتم استبدال جميع الانتقالات المخصصة لهذا المعمل بسير العمل الافتراضي. تحتفظ الطلبات الحالية بحالتها الحالية.',
    'orderStatusFlow.saved': 'تم حفظ سير العمل',
    'orderStatusFlow.resetDone': 'تمت استعادة سير العمل الافتراضي',
    'orderStatusFlow.clear': 'البدء من جديد',
    'orderStatusFlow.clearConfirmTitle': 'مسح سير العمل بالكامل؟',
    'orderStatusFlow.clearConfirmBody': 'ستتم إزالة جميع الحالات والانتقالات من سير عمل هذا المعمل لتتمكن من بناء سير عمل جديد. لن يتغير شيء حتى تضغط حفظ، ويمكنك استرجاع سير العمل الحالي عبر تجاهل التغييرات. تحتفظ الطلبات الحالية بحالتها الحالية.',
    'orderStatusFlow.clearDone': 'تم مسح سير العمل. مطلوب ومغلق ثابتتان — أعد بناء الخطوات بينهما ثم احفظ.',
    'orderStatusFlow.saveError': 'تعذر حفظ سير العمل',
    'orderStatusFlow.loadError': 'تعذر تحميل سير العمل',
    'orderStatusFlow.retry': 'إعادة المحاولة',
    'orderStatusFlow.readOnly': 'يمكنك عرض سير العمل لكن ليست لديك صلاحية تعديله.',
    'orderStatusFlow.unsaved': 'لديك تغييرات غير محفوظة.',
    'orderStatusFlow.initialRequired': 'اختر الحالة الابتدائية أولاً.',
    'orderStatusFlow.initialStatus': 'الحالة الابتدائية',
    'orderStatusFlow.initialStatusHint': 'ثابتة: تبدأ كل الطلبات الجديدة بحالة مطلوب.',
    'orderStatusFlow.anyStatus': 'متاحة من أي حالة',
    'orderStatusFlow.anyStatusHint': 'يمكن نقل الطلبات إلى هذه الحالات من أي حالة غير نهائية (مثل معلق أو طلب إلغاء).',
    'orderStatusFlow.billable.title': 'متى يستحق مبلغ الطلب على العميل',
    'orderStatusFlow.billable.hint': 'اختر الحالة التي يصبح العميل مديناً للمعمل بمبلغ الطلب ابتداءً منها. قبل وصول الطلب إليها لا يمكن إضافته إلى فاتورة، ولا يُحتسب مبلغه في أرقام لوحة التحكم (متتبع الإيرادات، مجموع قيمة الطلبات، الطلبات غير المدفوعة، متعقب أنواع التركيبات)، ولا في إجماليات قائمة الطلبات، ولا في أرصدة العملاء وكشوف حساباتهم، ولا في تقريري التحصيل والإيرادات.',
    'orderStatusFlow.billable.enable': 'احتساب مبالغ الطلبات ابتداءً من حالة محددة فقط',
    'orderStatusFlow.billable.placeholder': 'اختر حالة',
    'orderStatusFlow.billable.countsIn': 'يُحتسب الطلب عند وصوله إلى:',
    'orderStatusFlow.billable.stickyNote': 'بعد أن يُحتسب الطلب يظل محتسباً أثناء انتقاله لاحقاً (مثل معلق أو إعادة العمل)، ويتوقف احتسابه إذا أُعيد إلى حالة قبل هذه الحالة أو أُلغي أو رُفض.',
    'orderStatusFlow.billable.disabledHint': 'متوقف: يُحتسب كل طلب غير ملغى أو مرفوض بمجرد إنشائه.',
    'orderStatusFlow.billable.restampNote': 'عند الحفظ ستتم إعادة فحص الطلبات الحالية بناءً على حالتها الحالية.',
    'orderStatusFlow.billable.notInFlow': 'يجب أن تكون الحالة التي يستحق منها المبلغ جزءاً من سير العمل.',
    'orderStatusFlow.paid.title': 'عند دفع الطلب',
    'orderStatusFlow.paid.hint': 'ثابتة: عندما يُدفع الطلب بالكامل ضمن فاتورة، أو يُختار لدفعه ضمن دفعة جزئية، ينتقل تلقائياً إلى مغلق.',
    'orderStatusFlow.paid.placeholder': 'اختر حالة',
    'orderStatusFlow.paid.note': 'الطلبات الملغاة أو المرفوضة تبقى كما هي. التراجع عن الدفع لا يعيد الطلب إلى حالته السابقة.',
    'orderStatusFlow.paid.required': 'اختر الحالة التي يجب أن ينتقل إليها الطلب عند الدفع.',
    'orderStatusFlow.paid.notInPortal': 'يجب أن تكون حالة الدفع إحدى الحالات المستخدمة في البوابة.',
    'orderStatusFlow.statusesTitle': 'الحالات والانتقالات',
    'orderStatusFlow.statusesHint': 'كل حالة تشير إلى الحالات التي يمكن أن ينتقل إليها الطلب بعدها. اضغط على أي حالة للانتقال إليها.',
    'orderStatusFlow.comesFrom': 'من:',
    'orderStatusFlow.nextStatuses': 'يمكن الانتقال إلى',
    'orderStatusFlow.view.diagram': 'مخطط',
    'orderStatusFlow.view.list': 'قائمة',
    'orderStatusFlow.diagram.hint': 'ابنِ سير العمل من نقطة البداية إلى الأسفل: اسحب من النقطة السفلية لأي حالة إلى حالة أخرى لإضافة انتقال. اضغط على حالة لتعديلها، أو على سهم لحذفه.',
    'orderStatusFlow.diagram.connectHint': 'اسحب من النقطة السفلية لأي حالة (أو من نقطة البداية) إلى حالة أخرى لربطهما.',
    'orderStatusFlow.diagram.selectHint': 'اختر حالة في المخطط لتحديد الحالات التي يمكن الانتقال إليها.',
    'orderStatusFlow.diagram.addStatus': 'إضافة حالة',
    'orderStatusFlow.diagram.autoArrange': 'ترتيب تلقائي',
    'orderStatusFlow.diagram.setInitial': 'تعيين كحالة ابتدائية',
    'orderStatusFlow.diagram.removeFromFlow': 'إزالة من سير العمل',
    'orderStatusFlow.diagram.removeTransition': 'حذف الانتقال',
    'orderStatusFlow.diagram.initialLocked': 'اختر حالة ابتدائية أخرى قبل إزالة هذه الحالة.',
    'orderStatusFlow.diagram.fixedLocked': 'مطلوب (البداية) ومغلق (النهاية) تبقيان في كل سير عمل.',
    'orderStatusFlow.addTransition': 'إضافة تالية',
    'orderStatusFlow.noTransitions': 'لا توجد حالة تالية بعد',
    'orderStatusFlow.previousStatus': 'الحالة السابقة',
    'orderStatusFlow.searchPlaceholder': 'ابحث في الحالات',
    'orderStatusFlow.noResults': 'لا توجد حالات مطابقة لبحثك',
    'orderStatusFlow.nextPlaceholder': 'اختر الحالات',
    'orderStatusFlow.resume': 'العودة للحالة السابقة',
    'orderStatusFlow.resumeHint': 'السماح للطلبات في هذه الحالة بالعودة إلى الحالة التي كانت عليها قبلها (مفيد لحالات مثل معلق أو بانتظار الدفع).',
    'orderStatusFlow.ordersCount': '{count} طلب',
    'orderStatusFlow.ordersCountHint': 'الطلبات الموجودة حالياً في هذه الحالة',
    'orderStatusFlow.updatedAt': 'آخر تحديث {date}',
    'orderStatusFlow.badge.initial': 'البداية',
    'orderStatusFlow.badge.terminal': 'نهائية',
    'orderStatusFlow.badge.unused': 'خارج سير العمل',
    'orderStatusFlow.badge.deadEnd': 'لا توجد حالة تالية',
    'orderStatusFlow.badge.unreachable': 'لا يمكن الوصول إليها',
    'orderStatusFlow.warnings.title': 'راجع ملاحظات سير العمل التالية',
    'orderStatusFlow.warnings.unreachable': 'لا يمكن الوصول إلى هذه الحالات من الحالة الابتدائية:',
    'orderStatusFlow.warnings.deadEnds': 'لا يمكن نقل الطلبات الموجودة في هذه الحالات إلى أي حالة:',
    'orderStatusFlow.warnings.stranded': 'توجد طلبات في حالات خارج سير العمل؛ يمكن نقلها إلى أي حالة في سير العمل:',
    'orderStatusFlow.warnings.hiddenWithOrders': 'توجد طلبات في حالات غير مستخدمة في البوابة؛ تحتفظ بحالتها لكن لا يمكن التصفية بها حتى يتم نقلها:',
    'orderStatusFlow.portal.title': 'الحالات المستخدمة في بوابة المعمل',
    'orderStatusFlow.portal.hint': 'تظهر هذه الحالات فقط في بوابة المعمل: قوائم الحالات والتصفية و"الانتقال إلى حالة" وسير العمل أدناه. إلغاء تحديد حالة يحذف انتقالاتها أيضاً.',
    'orderStatusFlow.portal.count': '{selected} من {total}',
    'orderStatusFlow.portal.workflowOnly': 'الإبقاء على حالات سير العمل فقط',
    'orderStatusFlow.portal.workflowOnlyHint': 'يلغي تحديد كل حالة ليس لها انتقال في سير العمل.',
    'orderStatusFlow.portal.selectAll': 'تحديد الكل',
    'orderStatusFlow.portal.locked': 'مستخدمة دائماً: مطلوب (البداية)، ومغلق (النهاية)، وملغي (إجراء إلغاء الطلب).',
    'orderStatusFlow.category.intake': 'الاستلام',
    'orderStatusFlow.category.design': 'التصميم',
    'orderStatusFlow.category.try_in': 'التجربة',
    'orderStatusFlow.category.manufacturing': 'التصنيع',
    'orderStatusFlow.category.quality': 'مراقبة الجودة',
    'orderStatusFlow.category.delivery': 'التوصيل',
    'orderStatusFlow.category.closure': 'الإغلاق',
    'orderStatusFlow.category.remake': 'إعادة التصنيع',
    'orderStatusFlow.category.exception': 'الاستثناءات',
    'orderStatusFlow.category.other': 'أخرى',
    'backoffice.vendors.col.status': 'الحالة',
    'backoffice.vendors.col.plan': 'الخطة',
    'backoffice.vendors.col.orders30d': 'الطلبات (30 يوم)',
    'backoffice.vendors.col.created': 'تاريخ الإنشاء',
    'backoffice.vendors.search': 'بحث في المعامل',
    'backoffice.vendors.export': 'تنزيل CSV',
    'backoffice.vendors.health.loadError': 'تعذر تحميل صحة المعمل',
    'backoffice.vendors.health.users': 'المستخدمون',
    'backoffice.vendors.health.clients': 'العملاء',
    'backoffice.vendors.health.orders30d': 'الطلبات (30 يوم)',
    'backoffice.vendors.health.lastLogin': 'آخر دخول',
    'backoffice.vendors.health.ordersTrend': 'اتجاه الطلبات',
    'backoffice.vendors.health.impersonate': 'الدخول كمعمل',
    'backoffice.vendors.health.viewActivities': 'عرض الأنشطة',
    'backoffice.vendors.health.supportNotes': 'ملاحظات الدعم',
    'backoffice.vendors.health.newNote': 'ملاحظة جديدة',
    'backoffice.vendors.health.noNotes': 'لا توجد ملاحظات',
    'backoffice.vendors.health.noteSaved': 'تم حفظ الملاحظة',
    'backoffice.vendors.health.noteError': 'تعذر حفظ الملاحظة',
    'backoffice.vendors.health.impersonationStarted': 'تم فتحصفحة دخول المعمل',
    'backoffice.vendors.health.impersonationError': 'تعذر انتحال جلسة المعمل',
    'backoffice.clients.title': 'جميع العملاء',
    'backoffice.clients.loadError': 'تعذر تحميل العملاء',
    'backoffice.clients.col.name': 'العميل',
    'backoffice.clients.col.vendor': 'المعمل',
    'backoffice.clients.col.created': 'تاريخ الإنشاء',
    'backoffice.orders.title': 'جميع الطلبات',
    'backoffice.orders.loadError': 'تعذر تحميل الطلبات',
    'backoffice.orders.col.vendor': 'المعمل',
    'backoffice.orders.col.client': 'العميل',
    'backoffice.orders.col.status': 'الحالة',
    'backoffice.orders.col.total': 'الإجمالي',
    'backoffice.orders.col.date': 'التاريخ',
    'backoffice.invoices.title': 'جميع الفواتير',
    'backoffice.invoices.subtitle': 'تصفح الفواتير عبر جميع المعامل على المنصة.',
    'backoffice.invoices.loadError': 'تعذر تحميل الفواتير',
    'backoffice.invoices.search': 'ابحث برقم الفاتورة أو العميل',
    'backoffice.invoices.col.reference': 'الفاتورة',
    'backoffice.invoices.col.vendor': 'المعمل',
    'backoffice.invoices.col.client': 'العميل',
    'backoffice.invoices.col.orders': 'الطلبات',
    'backoffice.invoices.col.status': 'الحالة',
    'backoffice.invoices.col.total': 'الإجمالي',
    'backoffice.invoices.col.remaining': 'المتبقي',
    'backoffice.invoices.col.date': 'التاريخ',
    'backoffice.platformUsers.title': 'مستخدمو المنصة',
    'backoffice.platformUsers.create': 'إضافة مستخدم',
    'backoffice.platformUsers.edit': 'تعديل مستخدم',
    'backoffice.platformUsers.loadError': 'تعذر تحميل مستخدمي المنصة',
    'backoffice.platformUsers.saveError': 'تعذر حفظ المستخدم',
    'backoffice.platformUsers.created': 'تم إنشاء المستخدم',
    'backoffice.platformUsers.updated': 'تم تحديث المستخدم',
    'backoffice.platformUsers.deleted': 'تم حذف المستخدم',
    'backoffice.platformUsers.deleteError': 'تعذر حذف المستخدم',
    'backoffice.platformUsers.col.permissions': 'الصلاحيات',
    'backoffice.platformUsers.permissions': 'الصلاحيات',
    'backoffice.platformUsers.passwordOptional': 'اتركه فارغاً للإبقاء على الحالي',
    'backoffice.navbar.search': 'بحث في المعامل والاشتراكات',
    'backoffice.support.title': 'صندوق الدعم',
    'backoffice.support.subtitle': 'الرسائل المباشرة من مستخدمي بوابة المعامل وزوار الموقع.',
    'backoffice.support.loadError': 'تعذر تحميل المحادثات',
    'backoffice.support.threadLoadError': 'تعذر تحميل هذه المحادثة',
    'backoffice.support.sendError': 'تعذر إرسال ردك',
    'backoffice.support.updateError': 'تعذر تحديث المحادثة',
    'backoffice.support.stats.open': 'المحادثات المفتوحة',
    'backoffice.support.stats.unread': 'بانتظار الرد',
    'backoffice.support.stats.vendorUsers': 'مستخدمو المعامل',
    'backoffice.support.stats.visitors': 'زوار الموقع',
    'backoffice.support.filter.search': 'ابحث بالاسم أو الهاتف أو البريد أو المعمل أو الرسالة',
    'backoffice.support.filter.type': 'نوع المرسل',
    'backoffice.support.filter.unreadOnly': 'غير المقروءة فقط',
    'backoffice.support.status.open': 'مفتوحة',
    'backoffice.support.status.closed': 'مغلقة',
    'backoffice.support.status.all': 'الكل',
    'backoffice.support.type.vendor_user': 'مستخدم معمل',
    'backoffice.support.type.visitor': 'زائر الموقع',
    'backoffice.support.empty': 'لا توجد محادثات',
    'backoffice.support.selectConversation': 'اختر محادثة لقراءتها والرد عليها',
    'backoffice.support.notFound': 'المحادثة غير موجودة',
    'backoffice.support.startedAt': 'بدأت {date}',
    'backoffice.support.you': 'أنت',
    'backoffice.support.seen': 'تمت المشاهدة',
    'backoffice.support.whatsapp': 'محادثة على واتساب',
    'backoffice.support.close': 'تعليم كمحلولة',
    'backoffice.support.reopen': 'إعادة فتح',
    'backoffice.support.closed': 'تم تعليم المحادثة كمحلولة',
    'backoffice.support.reopened': 'تمت إعادة فتح المحادثة',
    'backoffice.support.closedNote': 'هذه المحادثة محلولة. ستُعاد فتحها تلقائياً إذا كتب المرسل مجدداً.',
    'backoffice.support.replyPlaceholder': 'اكتب رداً… (Enter للإرسال، Shift+Enter لسطر جديد)',
    'backoffice.support.send': 'إرسال',
    'backoffice.support.files.attach': 'إرفاق صور أو ملفات',
    'backoffice.support.files.remove': 'إزالة',
    'backoffice.support.files.processing': 'جارٍ الإنهاء…',
    'backoffice.support.files.invalidType': '{{name}}: نوع الملف غير مسموح',
    'backoffice.support.files.tooLarge': '{{name}}: حجم الملف أكبر من 20 ميجابايت',
    'backoffice.support.files.tooMany': 'يمكنك إرفاق {{count}} ملفات كحد أقصى لكل رسالة',
    'backoffice.navbar.notifications': 'الإشعارات',
    'backoffice.forbidden.message': 'ليس لديك صلاحية للوصول إلى هذه الصفحة.',
    'sidebar.dashboard': 'لوحة التحكم',
    'sidebar.platform_clients': 'العملاء',
    'sidebar.platform_orders': 'الطلبات',
    'sidebar.platform_invoices': 'الفواتير',
    'sidebar.platform_users': 'مستخدمو المنصة',
    'common.name': 'الاسم',
    'common.password': 'كلمة المرور',
    'common.success': 'تمت العملية بنجاح',
    'common.error': 'حدث خطأ ما',
    'common.deleted': 'تم الحذف بنجاح',
    'common.filters': 'الفلاتر',
    'common.resetFilters': 'إعادة تعيين الفلاتر',
    'backoffice.common.refresh': 'تحديث',
    'backoffice.common.viewAll': 'عرض الكل',
    'backoffice.common.invalidEmail': 'أدخل بريداً إلكترونياً صحيحاً',
    'backoffice.common.passwordMin': 'يجب ألا تقل كلمة المرور عن 8 أحرف',
    'backoffice.filter.vendor': 'تصفية حسب المعمل',
    'backoffice.dashboard.badge': 'مركز إدارة المنصة',
    'backoffice.dashboard.subtitle': 'تابع نمو المعامل والاشتراكات وإيرادات المنصة في لمحة واحدة.',
    'backoffice.dashboard.suspendedCount': '{count} موقوف',
    'backoffice.dashboard.planRequestsCount': '{count} طلبات تغيير خطة معلقة',
    'backoffice.dashboard.thisWeekCount': '{count} هذا الأسبوع',
    'backoffice.vendors.subtitle': 'إدارة المعامل على المنصة وخططها وحالة حساباتها.',
    'backoffice.vendors.createSubtitle': 'سجّل معملاً جديداً. يمكنك إضافة المستخدمين والإعدادات بعد الإنشاء.',
    'backoffice.vendors.exportSelected': 'تنزيل {count} محدد',
    'backoffice.vendors.health.orders': 'الطلبات',
    'backoffice.vendors.health.addNote': 'إضافة ملاحظة',
    'backoffice.subscriptions.subtitle': 'مراجعة التسجيلات وإدارة دورة حياة اشتراكات المعامل.',
    'backoffice.subscriptions.actionError': 'تعذر تحديث الاشتراك',
    'backoffice.subscriptions.rejected': 'تم رفض الاشتراك',
    'backoffice.subscriptions.created': 'تم إنشاء الاشتراك',
    'backoffice.subscriptions.createError': 'تعذر إنشاء الاشتراك',
    'backoffice.subscriptions.trialUntil': 'حتى {date}',
    'backoffice.subscriptions.suspendConfirm': 'إيقاف هذا الاشتراك؟ سيفقد المعمل الوصول حتى تتم إعادة تفعيله.',
    'backoffice.subscriptions.cancelConfirm': 'إلغاء هذا الاشتراك؟ لا يمكن التراجع عن ذلك.',
    'backoffice.subscriptions.rejectTitle': 'رفض الاشتراك',
    'backoffice.subscriptions.rejectReason': 'السبب (اختياري)',
    'backoffice.subscriptions.form.planPlaceholder': 'اختر خطة',
    'backoffice.subscriptions.form.adminName': 'اسم المسؤول',
    'backoffice.subscriptions.form.adminEmail': 'البريد الإلكتروني للمسؤول',
    'backoffice.planRequests.subtitle': 'الموافقة على طلبات ترقية أو تخفيض الخطط من المعامل أو رفضها.',
    'backoffice.planRequests.col.change': 'تغيير الخطة',
    'backoffice.subscriptionPlans.subtitle': 'حدد الخطط المتاحة للمعامل مع الأسعار وحدود الاستخدام.',
    'backoffice.subscriptionPlans.col.limits': 'الحدود',
    'backoffice.subscriptionPlans.unlimited': 'غير محدود',
    'backoffice.subscriptionPlans.deleteConfirm': 'حذف هذه الخطة؟ لا يمكن حذف الخطط التي لها اشتراكات نشطة.',
    'backoffice.clients.subtitle': 'تصفح العملاء في جميع المعامل على المنصة.',
    'backoffice.clients.search': 'ابحث بالاسم أو رقم الهاتف',
    'backoffice.orders.subtitle': 'تصفح الطلبات في جميع المعامل على المنصة.',
    'backoffice.platformUsers.subtitle': 'إدارة حسابات فريق الإدارة وصلاحياتهم.',
    'backoffice.platformUsers.deleteConfirm': 'حذف هذا المستخدم؟ سيفقد الوصول إلى لوحة الإدارة فوراً.',
  },
};

export default translations;
